{
  "accessRights": {
    "allStudentsHaveAccess": "für {className} ({studentCount}) relevant",
    "allSubjects": "Alle Fächer",
    "canCreateCompetences": "Kompetenzeinträge verfassen",
    "canManageAccessRights": "Rechte und Zugriff verwalten",
    "canManageAccessRightsTooltip": "Die Lehrperson kann weitere Kolleg:innen zur Klasse hinzufügen und deren Zugriffsrechte verwalten.",
    "canManageArchiveRights": "Archivrechte verwalten",
    "canManageCompetences": "Kompetenzen verwalten",
    "canManageCompetencesTooltip": "Die Lehrperson kann Fächer und deren Kompetenzen flexibel erstellen, anpassen und löschen.",
    "canManagePerformanceAssessments": "Leistungsfeststellungen verwalten",
    "canManagePerformanceAssessmentsTooltip": "Die Lehrperson kann Leistungsfeststellungen jederzeit erstellen, bearbeiten und entfernen.",
    "canManageStudents": "Schüler:innen verwalten",
    "canManageStudentsTooltip": "Die Lehrperson kann Schüler:innen jederzeit anlegen, bearbeiten und aus der Klasse entfernen.",
    "currentStaffDescription": "Folgende Teammitglieder haben Zugriff:",
    "currentStudentsDescription": "Diese Kompetenz ist für folgende Schülerinnen und Schüler relevant:",
    "hasAccessDouble": "{name1} und {name2} haben Zugriff",
    "hasAccessMultiple": "{name1}, {name2}, und { count } weiterer haben Zugriff | { name1}, {name2}, und { count } weitere haben Zugriff",
    "hasAccessSingle": "{name1} hat Zugriff",
    "hasAccessTriple": "{name1}, {name2} und {name3} haben Zugriff",
    "hasArchiveReadRights": "Archiv-Leserechte",
    "hasNoPermissions": "Keine weiteren Berechtigungen",
    "pleaseSelect": "Bitte auswählen",
    "proAccessRightsTooltip": "Mit einem Digidoo-Abo legst du fest, wer in einer Klasse Schüler:innen, Kompetenzen, Leistungsfeststellungen sowie Rechte und Zugriff verwalten darf.",
    "removeButton": "Entfernen",
    "removeDescription": "Bist du sicher, dass du diese Lehrperson aus der Klasse entfernen möchtest?",
    "removeTitle": "Lehrperson entfernen",
    "selectSpecific": "Nur folgende",
    "someStudentsHaveAccess": "für {studentCount} relevant",
    "splitStudentsEntry": "Einzelne Schüler:innen anzeigen"
  },
  "administrationSetup": {
    "close": "Schließen",
    "competences": {
      "body": "Passe den Kompetenzraster für deine Schule an.",
      "customize": {
        "description": "Bau deinen Raster individuell aus.",
        "title": "Kompetenzraster selbst anpassen"
      },
      "template": {
        "description": "Starte mit einer verwandten Vorlage (anderes Bundesland oder benachbarte Schulform) und passe sie an.",
        "title": "Kompetenzvorlage wählen"
      },
      "title": "Kompetenzen anpassen"
    },
    "initial": {
      "classes": {
        "description": "Lege weitere Klassen an und starte mit der Dokumentation.",
        "title": "Klassen anlegen"
      },
      "competences": {
        "description": "Passe Fächer und Kompetenzen an.",
        "title": "Kompetenzen anpassen"
      },
      "recommended": "(empfohlen)",
      "students": {
        "description": "Lege Schüler:innen an und ordne sie deinen Klassen zu.",
        "title": "Schüler:innen verwalten"
      },
      "team": {
        "description": "Hol dein Kollegium an Bord und dokumentiert gemeinsam.",
        "title": "Team einladen"
      },
      "title": "Bereit für deinen eigenen Start?"
    }
  },
  "apiTokens": {
    "generate": "Generieren",
    "title": "API Tokens",
    "token": "Token"
  },
  "auth": {
    "PasswordResetWidget": {
      "successText": "Du kannst dich nun mit deinem neuen Passwort anmelden.",
      "successTitle": "Geschafft!",
      "toLogin": "Zur Anmeldung"
    },
    "action": {
      "login": "Anmelden"
    },
    "deletedUser": "Gelöschte Lehrperson",
    "emailChange": {
      "failed": "E-Mail-Änderung fehlgeschlagen.",
      "goToLogin": "Zur Anmeldung",
      "invalidLink": "Ungültiger Link",
      "loading": "Bestätige deine neue E-Mail-Adresse...",
      "loginRequired": "Bitte melde dich zuerst mit deiner alten Email-Adresse an, um deine neue E-Mail-Adresse zu bestätigen.",
      "successText": "Deine E-Mail-Adresse wurde erfolgreich auf {email} geändert. Du kannst dich jetzt mit deiner neuen Adresse anmelden.",
      "successTitle": "E-Mail-Adresse erfolgreich geändert",
      "title": "E-Mail-Adresse bestätigen"
    },
    "finish-registration": {
      "checkingCode": "Prüfe Einladungslink...",
      "finish": "Registrierung abschließen",
      "invalidCode": "Dieser Einladungslink ist leider nicht (mehr) gültig!",
      "title": "Bitte setze dein Passwort."
    },
    "footer": {
      "contactMail": "mailto:support{'@'}digidoo.com?subject=Kontaktanfrage",
      "dataProtection": "Datenschutz",
      "legalNotice": "Impressum",
      "terms": "AGB",
      "version": "Beta Version"
    },
    "invite": {
      "alreadyLoggedIn": "Du bist bereits mit folgendem Konto angemeldet. Wie willst du fortfahren?",
      "declineInvitation": "Einladung nicht annehmen",
      "existingUserLoginToAccept": "Für diese E-Mail-Adresse gibt es bereits ein Digidoo Konto. Bitte melde dich an, um die Einladung anzunehmen.",
      "loginExistingAccount": "Mit bestehendem Konto anmelden",
      "loginWithDifferentAccount": "Mit anderem Konto anmelden",
      "title": "{invitedBy} hat dich eingeladen dem Team \"{teamName}\" beizutreten.",
      "titleCode": "Du wurdest eingeladen dem Team \"{teamName}\" beizutreten."
    },
    "login": {
      "appleLoginAction": "Weiter mit Apple",
      "bildungsportalLoginAction": "Weiter mit Bildungsportal",
      "errorDeactivated": "Dein Account wurde deaktiviert. Bitte wende dich an den Support, um ihn wiederherzustellen.",
      "googleLoginAction": "Weiter mit Google",
      "invitationLoginHint": "Bitte melde dich mit {email} an, um die Einladung anzunehmen.",
      "loginAction": "Anmelden",
      "loginEmailOtpHint": "Dein Code ist für 15 Minuten gültig.",
      "loginEmailOtpTitle": "Bitte gib den Code ein, den wir dir an <span class='font-medium'>{email}</span> geschickt haben",
      "loginTotpTitle": "Bitte gib den Code ein, der dir in deiner Authenticator App angezeigt wird.",
      "lostPassword": "Passwort vergessen?",
      "newToDigidoo": "Neu bei Digidoo?",
      "or": "oder",
      "password": "Dein Passwort",
      "register": "Jetzt registrieren",
      "resendEmailOtp": "Email erneut senden",
      "resendEmailSuccess": "Dein neuer Code wurde dir per Mail zugeschickt",
      "title": "Willkommen zurück bei Digidoo.",
      "userIdentifier": "Deine E-Mail"
    },
    "password": {
      "newPassword": "Neues Passwort",
      "newPasswordRepeat": "Neues Passwort (wiederholen)"
    },
    "password-reset": {
      "actionButtonLabel": "Passwort setzen",
      "checkingCode": "Prüfe Rücksetzcode...",
      "invalidCode": "Dieser Rücksetzcode ist leider nicht (mehr) gültig",
      "title": "Passwort ändern"
    },
    "register": {
      "alreadyRegistered": "Bereits registriert?",
      "conditionsConsequence": "Ich stimme den {terms} sowie der {policy} zu.",
      "email": "Deine E-Mail",
      "emailPlaceholder": "name{'@'}domain.com",
      "enterCodeDescription": "Um einer bestehenden Schule beizutreten, klicke auf deinen Einladungslink oder gib deinen einmaligen Zugangscode ein.",
      "enterCodeTitle": "Bestehender Schule beitreten",
      "fullName": "Dein Name (optional)",
      "invitationEmailMismatchError": "Diese Einladung ist an eine andere E-Mail-Adresse gebunden. Bitte kontaktiere deine Schule.",
      "invitationExistingUserError": "Für diese E-Mail-Adresse gibt es bereits ein Digidoo Konto. Bitte melde dich an, um die Einladung anzunehmen.",
      "invitationLockedEmailHint": "Andere E-Mail-Adresse? Bitte kontaktiere deine Schule für eine neue Einladung.",
      "joinExistingSchoolText": "Um einer bestehenden Schule beizutreten, klicke auf deinen Einladungslink oder gib deinen einmaligen Zugangscode ein.",
      "joinNewsletter": "Ich möchte über Neuigkeiten rund um Digidoo informiert werden.",
      "joinSchool": "Beitreten",
      "joinSchoolDescription": "Ich habe eine Einladung erhalten, einem Team beizutreten.",
      "login": "Anmelden",
      "loginToAcceptInvitation": "Zur Anmeldung",
      "onboardNewSchool": "Erstellen",
      "onboardNewSchoolDescription": "Ich möchte eine neue Schule oder private Institution etc. anlegen.",
      "onboardingOverviewJoinTeam": "Team beitreten",
      "onboardingOverviewJoinTeamDescription": "Mit Code oder Einladung",
      "onboardingOverviewStartSchool": "Neu mit Digidoo starten",
      "onboardingOverviewStartSchoolDescription": "Alleine oder im Team",
      "privacy": "Datenschutzerklärung",
      "registerAction": "Registrieren",
      "success": {
        "back": "Zurück zur Anmeldung",
        "text": "Du erhältst in Kürze eine E-Mail an {email}, um deine Registrierung abzuschließen.",
        "title": "Fast geschafft!"
      },
      "terms": "AGB inkl. AV-Vertrag",
      "title": "Erstelle deinen Digidoo Account."
    },
    "reset-password": {
      "email": "E-Mail-Adresse",
      "emailSent": "Wir haben ein Link zur Rücksetzung deines Passworts an die angegebene E-Mail-Adresse gesendet, falls sie in unserem System registriert ist.",
      "resetAction": "Zurücksetzen",
      "title": "Passwort zurücksetzen",
      "to-login": "Zur Anmeldung"
    },
    "sso": {
      "backToLogin": "Zur Anmeldung",
      "errorText": "Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
      "errorTitle": "Anmeldung fehlgeschlagen",
      "loadingText": "Einen Moment bitte.",
      "loadingTitle": "Anmeldung wird abgeschlossen",
      "startLoadingText": "Du wirst zum SSO-Anbieter weitergeleitet.",
      "startLoadingTitle": "Anmeldung wird gestartet"
    }
  },
  "authProviders": {
    "columns": {
      "config": "Config",
      "default": "Standard",
      "enabled": "Aktiv",
      "id": "ID",
      "name": "Name",
      "type": "Typ"
    },
    "create": "Auth Provider erstellen",
    "dialog": {
      "configJsonError": "Config muss valides JSON sein.",
      "configObjectError": "Config muss ein JSON-Objekt sein.",
      "createTitle": "Auth Provider erstellen",
      "editTitle": "Auth Provider bearbeiten"
    },
    "title": "SSO"
  },
  "billing": {
    "active": {
      "body": "Dein Digidoo-Abo ist aktiv. Du kannst alle Funktionen uneingeschränkt nutzen – von der Kompetenzdokumentation über Berichte bis hin zur Lernanalyse.",
      "note": "🥰 Vielen Dank, dass du Digidoo verwendest!",
      "title": "Dein Digidoo {product} Abo ist aktiv."
    },
    "availablePlans": "Weitere Abos für dich und dein Team",
    "banner": {
      "actions": {
        "contactLead": "Schulleitung kontaktieren",
        "manage": "Abo verwalten",
        "reactivate": "Abo reaktivieren",
        "renew": "Abo verlängern",
        "subscribe": "Abo abschließen",
        "trialUpsell": "{percent}% Rabatt sichern",
        "trialUpsellFallback": "Rabatt sichern"
      },
      "email": {
        "body": "Hallo {firstNameReceiver} 👋,\n\nkönntest du bitte das Digidoo-Abo upgraden, damit ich in Zukunft noch vollen Zugriff auf alle Funktionen habe?\n\nVielen Dank! :)\n\nLiebe Grüße\n{firstNameSender}",
        "subject": "Digidoo Testphase: Bitte um Upgrade 😊"
      },
      "subEnded": {
        "note": "Du kannst deine bisherigen Inhalte weiterhin ansehen, aber keine neuen erstellen.",
        "title": "Dein Digidoo {product} Abo ist abgelaufen."
      },
      "subEnding": {
        "title": "Dein Digidoo {product} Abo endet in {days} Tagen."
      },
      "trialEnded": {
        "note": "Du kannst deine bisherigen Inhalte weiterhin ansehen, aber keine neuen erstellen.",
        "title": "Deine Digidoo {product} Testphase ist abgelaufen."
      },
      "trialEnding": {
        "headline": "Du nutzt aktuell Digidoo mit allen Funktionen 🌸",
        "subtitle": "Du hast noch {count} Tag in deiner Testphase. | Du hast noch {count} Tage in deiner Testphase.",
        "title": "Deine Digidoo {product} Testphase endet in {days} Tagen."
      },
      "trialInfo": {
        "actions": {
          "class": "Klasse",
          "team": "Team"
        },
        "afterTrial": "Danach steht dir weiterhin der kostenlose Basiszugang zur Verfügung.",
        "cta": {
          "bothEnd": "ein.",
          "bothMiddle": "oder lade dein",
          "bothStart": "Starte jetzt mit deiner eigenen",
          "classOnlyEnd": ".",
          "classOnlyStart": "Starte jetzt mit deiner eigenen",
          "teamOnlyEnd": "ein.",
          "teamOnlyStart": "Lade jetzt dein"
        },
        "features": {
          "classAnalysis": "Analyse & Klassenübersicht",
          "individualWeighting": "individuelle Notengewichtung",
          "sharedReports": "gemeinsame Berichte",
          "teamCollaboration": "Team-Zusammenarbeit"
        },
        "includedTitle": "Mit allen Funktionen erhältst du:",
        "trialActiveUntil": "Testphase aktiv bis:"
      },
      "trialUpsell": {
        "headline": "Du nutzt aktuell Digidoo mit allen Funktionen 🌸"
      }
    },
    "basis": {
      "body": "Wähle ein Abo, um alle Funktionen freizuschalten – inklusive Kompetenzblume, Berichte und gezielter Lernanalyse.",
      "note": "🤩 Hol dir Digidoo schon ab <strong>{price} pro Schüler:in</strong> und Jahr!",
      "title": "Du nutzt Digidoo Basis."
    },
    "buttons": {
      "addPaymentMethod": "Zahlungsmethode hinzufügen",
      "changeSeats": "Anzahl ändern",
      "chooseSubscription": "Abo wählen",
      "comparePlans": "Pläne vergleichen",
      "contact": "Kontaktiere uns",
      "invoices": "Rechnungen einsehen",
      "manage": "Abo verwalten",
      "openInvoice": "Rechnung einsehen",
      "openPriceCalculator": "Preisrechner öffnen",
      "switch": "Wechseln",
      "upgrade": "Upgrade"
    },
    "checkoutProductDialog": {
      "cancelScheduledChangeHint": "Fortfahren storniert den geplanten Abo-Wechsel.",
      "currentSelectionHint": "Das ist dein aktuelles Abo.",
      "description": "Von Einzelpersonen über kleine Teams bis zu ganzen Schulen – mit unseren Abo-Plänen passt sich Digidoo genau an deine Bedürfnisse an.",
      "subtitleCompact": "Diese Funktion erfordert ein aktives Digidoo Abo.",
      "email": {
        "body": "Hallo,\n\nkönnt ihr bitte das Digidoo-Abo verwalten bzw. freischalten? Danke!\n",
        "subject": "Digidoo: Bitte um Abo-Freigabe/Verlängerung"
      },
      "eyebrow": "Abrechnung",
      "features": {
        "collaboration": "Arbeite effizient im Team",
        "competenceDocumentation": "Dokumentiere Lernfortschritte übersichtlich",
        "reports": "Erstelle Berichte mit einem Klick",
        "statistics": "Analysiere visuell mit der Kompetenzblume",
        "support": "Erhalte jederzeit Unterstützung von uns"
      },
      "overview": {
        "additionalDescription": "Mit deinem Digidoo Abo bekommst du außerdem…",
        "annualDiscount": "🎁 bis zu 50% günstiger bei jährlicher Abrechnung",
        "fallback": {
          "title": "Hol dir dein Digidoo Abo\nund nutze alle Funktionen."
        },
        "features": {
          "customization": "Eigenes Schullogo, Bilder und vieles mehr",
          "development": "Kompetenz- & Entwicklungsverläufe",
          "gradeWeighting": "Notenberechnung & -gewichtung",
          "reports": "Berichte",
          "reportsAndSupportMeasures": "Berichte & Fördermaßnahmen",
          "roles": "Rollen & Berechtigungen",
          "supportMeasures": "Fördermaßnahmen"
        },
        "gradeWeighting": {
          "title": "Hol dir dein Digidoo Abo\nund nutze Notengewichtung."
        },
        "reports": {
          "title": "Hol dir dein Digidoo Abo\nund nutze Berichte."
        },
        "supportMeasures": {
          "title": "Hol dir dein Digidoo Abo\nund nutze Fördermaßnahmen."
        }
      },
      "planSelectionAriaLabel": "Abo-Pläne",
      "studentQuestion": "Wie viele Schüler:innen?",
      "subtitle": "und nutze alle Funktionen ohne Einschränkung.",
      "teacherQuestion": "Wie viele Lehrpersonen?",
      "title": "Hol dir dein Digidoo Abo",
      "titleContinuation": "und nutze alle Funktionen",
      "titleSecondLine": "ohne Einschränkung."
    },
    "chooseYourPlan": "Finde dein perfektes Digidoo.",
    "currentPlan": "Aktiv",
    "endTrialNow": "Testphase beenden",
    "feedbackDialog": {
      "missingFeatures": "Mir fehlen derzeit noch Funktionen",
      "preferFreeVersion": "Alles gut, ich möchte es vorerst lieber kostenlos nutzen",
      "secureDiscount": "{percent} % Rabatt sichern",
      "sendFeedback": "Feedback senden",
      "textPlaceholder": "Du hast weiteres Feedback?",
      "title": "Du verwendest die kostenlose Version von Digidoo. Magst uns Feedback geben?",
      "tooExpensive": "Der Preis passt für mich aktuell nicht",
      "underUsed": "Ich konnte noch nicht alle Funktionen testen"
    },
    "intervalToggle": {
      "ariaLabel": "Abrechnungsintervall",
      "cheaper": "günstiger",
      "monthly": "Monatliche Abrechnung",
      "monthlyShort": "Monatlich",
      "withYearlyBilling": "bei jährlicher Abrechnung",
      "yearly": "Jährliche Abrechnung",
      "yearlyDiscountLabel": "bis zu {percent}% günstiger bei jährlicher Abrechnung",
      "yearlySavingsLabel": "bis zu {percent}% günstiger",
      "yearlyShort": "Jährlich"
    },
    "invoiceAddressSettings": {
      "description": "Diese Adresse wird für zukünftige Rechnungen verwendet.",
      "title": "Rechnungsadresse"
    },
    "invoicePayment": {
      "addressFutureOnlyHint": "Änderungen gelten für zukünftige Rechnungen. Bereits ausgestellte Rechnungen können nur durch den Support korrigiert werden.",
      "addressSubtitle": "Diese Adresse wird für deine Rechnung und zukünftige Rechnungen verwendet.",
      "addressTitle": "Rechnungsdaten eingeben",
      "confirmCreateInvoiceButton": "Abo starten & Rechnung erstellen",
      "confirmCreateInvoiceDescription": "Bitte stelle sicher, dass Name und Adresse zur Institution oder Organisation passen, die dieses Abo bezahlt. Mit dieser Bestätigung startest du das jährliche Digidoo Abo und erstellst eine zahlungspflichtige Rechnung mit 14 Tage Zahlungsfrist.",
      "confirmCreateInvoiceTitle": "Rechnungsdaten prüfen",
      "createInvoice": "Rechnung erstellen",
      "eyebrow": "Abrechnung",
      "fields": {
        "city": "Ort",
        "country": "Land",
        "line1": "Adresse",
        "name": "Name",
        "notes": "Notizen (optional)",
        "notesPlaceholder": "Zusätzliche Angaben für die Rechnung",
        "postalCode": "Postleitzahl",
        "vatId": "UID (optional)"
      },
      "invalidVatId": "Bitte gib eine gültige UID mit Länderpräfix ein, z. B. {example}.",
      "invoiceDescription": "Deine Schule oder Organisation bezahlt den Rechnungsbetrag per Überweisung.",
      "invoiceDueHint": "14 Tage Zahlungsfrist",
      "invoiceTitle": "Zahlung per Überweisung",
      "methodSubtitle": "Du kannst online bezahlen oder eine Rechnung mit 14 Tagen Zahlungsfrist erstellen.",
      "methodTitle": "Wähle deine Zahlungsmethode",
      "onlineDescription": "Bezahle direkt und sicher mit Karte, PayPal, Apple Pay, Google Pay & mehr.",
      "onlineTitle": "Online-Zahlung",
      "overdueNote": "Bezahle die offene Rechnung, um den Zugriff wieder zu aktivieren.",
      "pendingNote": "Bitte behalte die Zahlungsfrist im Blick.",
      "requestOptionText": "Meine Schule oder Organisation bezahlt per Überweisung.",
      "reviewInvoiceAddressButton": "Daten prüfen",
      "secureStripe": "Sicher über Stripe",
      "stripePrefix": "Die Bezahlung wird sicher über",
      "stripeSuffix": "abgewickelt.",
      "successDescription": "Du hast 14 Tage Zeit\ndie Zahlung durchzuführen.",
      "successThanks": "Bis dahin kannst du schon alle Funktionen ohne Einschränkung nutzen.",
      "successTitle": "Dein {product} Abo ist bereit 🎉"
    },
    "invoices": {
      "actions": {
        "download": "Rechnung herunterladen",
        "open": "Rechnung ansehen"
      },
      "columns": {
        "amount": "Betrag",
        "date": "Datum",
        "name": "Name",
        "product": "Abo",
        "status": "Status"
      },
      "empty": "Noch keine Rechnungen vorhanden.",
      "fallbackDate": "–",
      "fallbackInvoiceTitle": "Rechnung",
      "fallbackProduct": "Abo",
      "fallbackQuantity": "–",
      "invoiceTitle": "Rechnung {number}",
      "quantity": "{count} Plätze",
      "status": {
        "open": "Offen",
        "paid": "Bezahlt",
        "uncollectible": "Uneinbringlich",
        "unknown": "Unbekannt",
        "void": "Storniert"
      }
    },
    "offers": {
      "acceptHint": "Nach Annahme hast du 14 Tage Zeit, die Zahlung durchzuführen. Alle Funktionen sind sofort verfügbar.",
      "acceptOffer": "Angebot annehmen",
      "acceptTitle": "Angebot überprüfen",
      "actions": {
        "adjust": "Angebot anpassen",
        "delete": "Angebot löschen",
        "download": "Angebot herunterladen"
      },
      "addressTitle": "Angebotsdaten eingeben",
      "amount": "Betrag:",
      "cardStatus": "Angebot erstellt",
      "createOffer": "Angebot erstellen",
      "createTitle": "Angebot erstellen",
      "deleteConfirmDescription": "Das offene Angebot wird gelöscht und kann danach nicht mehr angenommen werden.",
      "deleteConfirmTitle": "Angebot löschen?",
      "deleteOffer": "Angebot löschen",
      "editAddressLink": "bearbeiten",
      "emptyDocuments": "Noch keine Rechnungen oder Angebote vorhanden.",
      "exclVat": "exkl. USt.",
      "fallbackOfferTitle": "Angebot",
      "invoiceAcceptedDescription": "Das Abo ist aktiv. Bitte begleiche die Rechnung innerhalb von 14 Tagen.",
      "invoiceAcceptedTitle": "Rechnung wurde erstellt.",
      "monthlyUnavailableHint": "Für monatliche Abos können keine Angebote erstellt werden.",
      "offer": "Angebot",
      "offerTitle": "Angebot {number}",
      "offerValidUntil": "Angebot gültig bis:",
      "onlinePayment": "Online-Zahlung",
      "pdfFilePrefix": "angebot",
      "reviewProductDescriptionFallback": "Ideal für deine Digidoo-Nutzung.",
      "reviewProductDescriptionSchool": "Ideal für ganze Schulen & Teams.",
      "reviewProductDescriptionTeam": "Ideal für Einzelpersonen & kleine Teams.",
      "reviewProductName": "Digidoo {product}",
      "status": {
        "accepted": "Angenommen",
        "deleted": "Gelöscht",
        "expired": "Abgelaufen",
        "pending": "Offen",
        "replaced": "Ersetzt"
      },
      "successDescription": "Dein Angebot ist erstellt und 30 Tage gültig.",
      "successDetails": "Wir freuen uns auf dich!",
      "successTitle": "Erledigt 🎉",
      "vatLine": "UID: {vatId}",
      "viewOffer": "Angebot einsehen"
    },
    "perYear": "pro Jahr",
    "planSwitchConfirm": {
      "cancelScheduledChangeConfirmButton": "Wechsel stornieren",
      "cancelScheduledChangeDescription": "Für dein Abo ist zum Ende der Laufzeit ein Wechsel vorgemerkt. Wenn du fortfährst, wird dieser storniert und dein aktuelles Abo {current} läuft unverändert weiter.",
      "cancelScheduledChangeSuccess": "Der geplante Abo-Wechsel wurde storniert.",
      "cancelScheduledChangeTitle": "Geplanten Wechsel stornieren?",
      "confirmButton": "Änderung bestätigen",
      "description": "Aktuell: {current}\nNeu: {target}\n\n{effect}",
      "immediateEffect": "Wir stellen dein Abo sofort um, damit du den neuen Plan direkt nutzen kannst.",
      "immediateWithAmountEffect": "Wir stellen dein Abo sofort um, damit du den neuen Plan direkt nutzen kannst. Für die Änderung wird jetzt voraussichtlich {amount} verrechnet.",
      "immediateWithInvoiceEffect": "Wir stellen dein Abo sofort um, damit du den neuen Plan direkt nutzen kannst. Falls durch die Änderung ein offener Betrag entsteht, findest du ihn danach in deiner Abrechnung.",
      "immediateWithoutPaymentEffect": "Wir stellen dein Abo sofort um, damit du den neuen Plan direkt nutzen kannst. Für diese Änderung ist voraussichtlich keine sofortige Zahlung nötig.",
      "nextPeriod": "dem nächsten Abrechnungszeitraum",
      "periodEndEffect": "Dein aktuelles Abo bleibt bis {date} aktiv. Das neue Abo startet danach.",
      "quantity": "{quantity} {unit}",
      "title": "Abo-Änderung bestätigen",
      "unknownInterval": "Abrechnungsintervall",
      "unknownPlan": "Aktuelles Abo"
    },
    "priceCalculatorDialog": {
      "selection": {
        "useAsSchool": "Ich möchte Digidoo <strong>als Schule oder großes Team</strong> verwenden",
        "useForMe": "Ich möchte Digidoo <strong>alleine</strong> verwenden",
        "useTogether": "Ich möchte Digidoo <strong>alleine oder im Team</strong> verwenden"
      },
      "title": "Preisrechner",
      "yourMonthlyCosts": "Deine monatlichen Kosten",
      "yourYearlyCosts": "Deine jährlichen Kosten"
    },
    "pricesExclVat": "Alle Preise exkl. USt. ",
    "products": {
      "basis": {
        "currentlyActive": "derzeit aktiv",
        "description": "<b>Du bist in der kostenlosen Version von Digidoo.</b> Du kannst deine bisherigen Inhalte weiterhin ansehen und auch neue Einträge erstellen. Die Analyse mit der Kompetenzblume und das Erstellen von Berichten benötigen ein aktives Abo. Starte jetzt ein Abo, um wieder vollen Zugriff auf alle Digidoo-Funktionen zu erhalten.",
        "priceLabel": "{price}",
        "shortDescription": "Ideal zum Starten.<br>Dauerhaft kostenlos.",
        "shortTitle": "Basis",
        "title": "Digidoo Basis"
      },
      "checkoutDescriptionBillingPrefix": "Abrechnung nach ",
      "freeTrial": {
        "description": "Genieße alle Funktionen von Digidoo. Viel Spaß!",
        "title": "Testphase"
      },
      "pro": {
        "description": "Für Einzelpersonen",
        "highlight": "🚀 Perfekt zum Starten",
        "pricing": "<b>{price}</b> pro Jahr",
        "pricingCalculatorDescription": "Für Einzelpersonen",
        "pricingYearlyLine": "{price} für ein Jahr",
        "title": "One"
      },
      "school": {
        "checkoutDescriptionUnit": "Schüler:innen",
        "checkoutMonthlyDescriptionPrefix": "Für ganze Schulen & Teams.",
        "checkoutMonthlyLine": "{price} pro Schüler:in und Monat",
        "checkoutYearlyDescriptionPrefix": "Für ganze Schulen & Teams.",
        "checkoutYearlyLine": "Ab {price} pro Schüler:in und Jahr",
        "description": "Für ganze Schulen & Teams",
        "highlight": "🥳 Arbeite im Team",
        "pricing": "<b>ab {perSeat}</b> pro Schüler:in und Jahr",
        "pricingCalculatorDescription": "ab {price} pro Schüler:in und Jahr",
        "pricingYearlyLine": "jährliche Staffelpreise",
        "title": "Team"
      },
      "team": {
        "checkoutDescriptionUnit": "Lehrpersonen",
        "checkoutMonthlyDescriptionPrefix": "Für Einzelpersonen & kleine Teams.",
        "checkoutMonthlyLine": "{price} pro Lehrperson und Monat",
        "checkoutYearlyDescriptionPrefix": "Für Einzelpersonen & kleine Teams.",
        "checkoutYearlyLine": "{price} pro Lehrperson und Jahr",
        "description": "Für Einzelpersonen & kleine Gruppen",
        "highlight": "🚀 Perfekt zum Starten",
        "pricing": "<b>{perSeat}</b> für jede Lehrperson und Jahr",
        "pricingCalculatorDescription": "{price} pro Lehrperson und Jahr",
        "pricingYearlyLine": "{price} für ein Jahr",
        "title": "Flex"
      },
      "discount": {
        "secureOffer": "🎁 {percent}% Rabatt sichern"
      },
      "trialDiscount": {
        "alwaysCheap": "Immer günstig",
        "badge": "{percent} % Rabatt",
        "validDuringTrial": "🎁 {percent}% Rabatt während der Testphase"
      },
      "units": {
        "forOneYear": "{price} für ein Jahr",
        "monthlyCancelable": "flexibel monatlich kündbar",
        "perMonth": "pro Monat",
        "perStudentPerMonth": "pro Schüler:in und Monat",
        "perStudentPerYear": "pro Schüler:in und Jahr",
        "perTeacherPerMonth": "pro Lehrperson und Monat"
      },
      "yearlyOnly": "Nur jährlich"
    },
    "provider": {
      "checkoutSecurelyProcessedBy": "Die Bezahlung wird sicher über",
      "handled": "abgewickelt",
      "securelyProcessedBy": "Die Bezahlung bei Digidoo wird sicher über"
    },
    "seatTypes": {
      "students": "Schüler:innen",
      "teamMembers": "Teammitglieder"
    },
    "statusCard": {
      "amountDue": "Fälliger Betrag",
      "body": {
        "active": "<span class='font-semibold'>Dein Abo ist aktiv.</span> Du kannst alle Funktionen uneingeschränkt nutzen – von der Kompetenzdokumentation über Berichte bis hin zur Analyse der Lernfortschritte mit der Kompetenzblume.",
        "invoiceDue": "<span class='font-semibold'>Dein Abo ist aktiv und die Rechnung wurde erstellt.</span> Bitte begleiche die Rechnung innerhalb der Zahlungsfrist, damit dein Zugriff ohne Unterbrechung bestehen bleibt.",
        "invoiceOverdue": "<span class='font-semibold'>Deine Rechnung ist überfällig.</span> Dein Zugriff auf die Abo-Funktionen ist pausiert, bis die offene Rechnung bezahlt wurde.",
        "subscriptionEndsIn": "<span class='font-semibold'>Dein Abo endet in {days} Tagen.</span> Danach kannst du deine Inhalte weiterhin einsehen, aber keine neuen Einträge oder Berichte mehr erstellen. Verlängere jetzt, um den vollen Zugriff zu behalten.",
        "subscriptionHasEnded": "<span class='font-semibold'>Dein Abo ist abgelaufen.</span> Du kannst deine bisherigen Inhalte weiterhin ansehen, aber keine neuen Einträge oder Berichte erstellen. Starte jetzt ein Abo, um wieder vollen Zugriff auf alle Digidoo-Funktionen zu erhalten.",
        "trialEndsIn": "<span class='font-semibold'>Deine {trialDays}-Tage-Testphase endet bald.</span> Danach kannst du deine Inhalte weiterhin einsehen, aber keine neuen Einträge oder Berichte mehr erstellen. Sichere dir jetzt den vollen Zugriff auf alle Funktionen – inklusive Kompetenzblume, Berichte und gezielter Lernanalyse.",
        "trialHasEnded": "<span class='font-semibold'>Deine Testphase ist abgelaufen.</span> Du kannst deine bisherigen Inhalte weiterhin ansehen und auch neue Einträge erstellen. Die Analyse mit der Kompetenzblume und das Erstellen von Berichten benötigen ein aktives Abo. Starte jetzt ein Abo, um wieder vollen Zugriff auf alle Digidoo-Funktionen zu erhalten.",
        "trialing": "<span class='font-semibold'>Du nutzt Digidoo aktuell in der Testphase (noch {days} Tage).</span> Danach kannst du deine Inhalte weiterhin einsehen und auch neue Einträge erstellen. Die Analyse mit der Kompetenzblume und das Erstellen von Berichten benötigen ein aktives Abo. Starte jetzt ein Abo, um auch nach der Testphase alle Digidoo-Funktionen ohne Einschränkungen nutzen zu können."
      },
      "cta": {
        "priceHint": "🤩 Hol dir Digidoo schon ab <strong>{price} pro Schüler:in</strong> und Jahr!"
      },
      "exclVat": "exkl. USt.",
      "invoiceDueDate": "Zahlungsfrist",
      "nextBilling": "Nächste Abrechnung",
      "scheduledChange": "Geplanter Abo-Wechsel",
      "seatUsageBar": {
        "barText": "Du verwendest aktuell <b>{used} von {total} Plätzen</b>"
      },
      "status": {
        "active": "Dein Abo ist aktiv",
        "invoiceDueIn": "Rechnung fällig in {days} Tagen",
        "invoiceOverdue": "Rechnung überfällig",
        "subscriptionEndsIn": "Dein Abo endet in {days} Tagen",
        "subscriptionHasEnded": "Dein Abo ist abgelaufen",
        "trialEndsIn": "Deine Testphase endet in {days} Tagen",
        "trialHasEnded": "Deine Testphase ist abgelaufen"
      }
    },
    "subEnded": {
      "body": "Du kannst alle Inhalte weiterhin ansehen, aber keine neuen Einträge oder Berichte erstellen. Reaktiviere dein Abo, um wieder Zugriff auf alle Funktionen zu erhalten.",
      "note": "🤩 Ab <b>{price} pro Schüler:in</b> und Jahr.",
      "reactivate": "Abo reaktivieren",
      "title": "Dein Digidoo {product} Abo ist abgelaufen."
    },
    "subEnding": {
      "body": "Danach kannst du Inhalte weiterhin ansehen, aber keine neuen Einträge oder Berichte mehr erstellen. Verlängere jetzt, um den vollen Zugriff zu behalten.",
      "note": "🥰 Vielen Dank, dass du Digidoo verwendest!",
      "renew": "Abo verlängern",
      "title": "Dein Digidoo {product} Abo endet in {days} Tagen."
    },
    "subscription": {
      "state": "Abo Status",
      "status": {
        "active": "Aktiv",
        "cancelScheduled": "Gekündigt",
        "canceled": "Beendet",
        "incomplete": "Unvollständig",
        "incomplete_expired": "Abgelaufen",
        "past_due": "Zahlung überfällig",
        "paused": "Pausiert",
        "subscriptionOver": "Abo",
        "trialEnded": "Testphase",
        "trialing": "Testphase",
        "unpaid": "Unbezahlt"
      },
      "title": "Abo"
    },
    "successDialog": {
      "acquisitionSource": {
        "description": "Das hilft uns, Digidoo gezielter weiterzuentwickeln.",
        "otherPlaceholder": "Falls du Sonstiges gewählt hast: Woher genau kennst du Digidoo?",
        "subtitle": "Eine kurze Frage noch, bevor du loslegst."
      },
      "description": "Vielen Dank für deine Unterstützung. Gemeinsam gestalten wir Schule einfacher und moderner. Teile jederzeit deine Ideen mit uns – wir freuen uns darauf!",
      "subtitle": "Du kannst nun alle Funktionen ohne Einschränkung nutzen. 🎉",
      "title": "Dein Digidoo {product} Abo ist bereit."
    },
    "syncBillingCustomer": "Billing-Kunde synchronisieren",
    "tabs": {
      "invoices": "Rechnungen & Angebote",
      "subscription": "Abo"
    },
    "tipBilling": "Hier behältst du den Überblick über dein Digidoo-Abo. Du kannst den aktuellen Abostatus einsehen, Rechnungen abrufen, deinen Plan wechseln oder bei Bedarf dein Abo verwalten.",
    "trialEnded": {
      "body": "Du kannst deine bisherigen Inhalte weiterhin ansehen, aber keine neuen Einträge oder Berichte erstellen. Starte jetzt ein Abo, um wieder vollen Zugriff zu erhalten.",
      "note": "😊 Danke fürs Testen!",
      "subscribe": "Abo abschließen",
      "title": "Deine Digidoo {product} Testphase ist abgelaufen."
    },
    "trialEnding": {
      "body": "Danach kannst du Inhalte weiterhin ansehen, aber keine neuen Einträge oder Berichte mehr erstellen. Sichere dir jetzt den vollen Zugriff auf alle Funktionen – inklusive Kompetenzblume, Berichte und gezielter Lernanalyse.",
      "note": "🤩 Hol dir Digidoo schon ab <strong>{price} pro Schüler:in</strong> und Jahr!",
      "title": "Deine Digidoo {product} Testphase endet in {days} Tagen."
    },
    "trialExpiredDialog": {
      "comparePlansLink": "vergleiche die Pläne",
      "downgradeToFreeVersion": "Mit der kostenlosen Version fortsetzen",
      "downgradeToFreeVersionShort": "Kostenlos fortsetzen",
      "firstEntryDone": {
        "description": "Du kannst Digidoo {freeUse}, um Lernfortschritte zu dokumentieren. Digidoo kann dir noch viel mehr Arbeit abnehmen. Erfahre mehr und {comparePlans}.",
        "title": "Du hast Digidoo aktiv genutzt 🌸"
      },
      "firstEntryPending": {
        "description": "Du kannst Digidoo {freeUse}, um Lernfortschritte zu dokumentieren. Digidoo kann dir noch viel mehr Arbeit abnehmen. Erfahre mehr und {comparePlans}.",
        "title": "Hol dir Zeit für das Wesentliche zurück 🌸"
      },
      "freeUseHighlight": "weiterhin kostenlos verwenden"
    },
    "trialExtensionDialog": {
      "accept": "7 Tage kostenlos weitertesten",
      "decline": "Nein danke",
      "description": "Der Schulalltag ist voll, und oft braucht es einfach ein paar Tage mehr, um Digidoo in Ruhe im Unterricht auszuprobieren. {highlight} – mit allen Funktionen, ohne Verpflichtung.",
      "descriptionHighlight": "Wir verlängern deine Testphase einmalig um 7 Tage",
      "successToast": "Deine Testphase wurde um 7 Tage verlängert.",
      "title": "Mehr Zeit zum Ausprobieren"
    },
    "trialUpsellDialog": {
      "title": "Sicher dir jetzt {discount} in der Testphase!",
      "discount": "{percent}% Rabatt",
      "discountFallback": "Rabatt",
      "keepTestingButton": "Weiter testen",
      "keepTestingText": "Du hast noch {trialDays} Tage Zeit, Digidoo in Ruhe kennenzulernen.",
      "keepTestingTitle": "Noch nicht sicher?",
      "subtitle": "Dokumentiere gemeinsam im Team und erstelle Berichte auf Knopfdruck."
    }
  },
  "chartDateFilter": {
    "all": "Insgesamt",
    "apply": "Übernehmen",
    "cancel": "Abbrechen",
    "currentMonth": "Aktueller Monat",
    "currentYear": "Aktuelles Jahr",
    "last12Months": "Letzte 12 Monate",
    "last30Days": "Letzte 30 Tage",
    "last3Months": "Letzte 3 Monate",
    "last6Months": "Letzte 6 Monate",
    "lastMonth": "Letzter Monat",
    "lastYear": "Letztes Jahr"
  },
  "classSelectorWidget": {
    "classListEntry": "{ className } Klasse",
    "newClass": "Neue Klasse",
    "title": "Klassenauswahl"
  },
  "classSetup": {
    "schoolSubjects": "Fächer auswählen",
    "title": "Klasse erstellen"
  },
  "classTeam": {
    "addMember": "Hinzufügen",
    "allCompetences": "Alle Kompetenzen",
    "emptyStateDescription": "Füge jetzt das erste Teammitglied hinzu.",
    "emptyStateTitle": "Noch kein Klassenteam",
    "tip": "Hier siehst du alle Lehrpersonen, die in deiner Klasse <b>{currentClass}</b> unterrichten. Berechtigungen und Freigaben für Fächer sind hier einsehbar und können nur von Admins geändert werden. Je nach eigener Berechtigung kannst du weitere Lehrpersonen zur Klasse hinzufügen."
  },
  "myArchive": {
    "title": "Mein Archiv",
    "scopeHint": "Du siehst nur Klassen und Gruppen, auf die du Zugriff hast.",
    "summary": "{classes} & {groups}",
    "manageSchoolYears": "Schuljahre verwalten",
    "selectSchoolYear": "Schuljahr auswählen",
    "emptySchoolYear": "Keine Klassen oder Gruppen in diesem Schuljahr."
  },
  "classes": {
    "access": "Zugriff",
    "addClass": "Klasse oder Gruppe hinzufügen",
    "addClassAccess": "Teammitglied hinzufügen",
    "addSchoolSubjectFromOtherLevels": "Kompetenzen aus anderen Schulstufen hinzufügen",
    "addStudentsLabel": "Schüler:in hinzufügen",
    "archive": "Klasse archivieren",
    "archiveBannerButton": "Wer hat Zugriff?",
    "archiveBannerDescription": "Du kannst alle Inhalte einsehen, aber keine Änderungen vornehmen.",
    "archiveBannerTitle": "Diese Klasse befindet sich im Archiv.",
    "archiveBulk": "Klassen archivieren",
    "archiveBulkAction": "{count} Klasse archivieren | {count} Klassen archivieren",
    "archiveBulkConfirmDescription": "Inhalte archivierter Klassen sind nicht mehr bearbeitbar. Bist du sicher, dass du fortfahren möchtest?",
    "archiveBulkCurrentClass": "Klasse {className}",
    "archiveBulkInProgress": "Klassen werden archiviert…",
    "archiveBulkPartialFailure": "Folgende Klassen konnten nicht archiviert werden: {classNames}",
    "archiveBulkStep": "{x} von {y}",
    "archiveBulkSuccess": "{count} Klasse archiviert. | {count} Klassen archiviert.",
    "archiveBulkTitle": "{count} Klasse archivieren | {count} Klassen archivieren",
    "archiveClassAddNote": "Notiz hinzufügen",
    "archiveClassConfirmButton": "Ja, Klasse archivieren",
    "archiveClassConfirmDescription": "Inhalte archivierter Klassen sind nicht mehr bearbeitbar. Bist du sicher, dass du fortfahren möchtest?",
    "archiveClassFinalNoteDescription": "Möchtest du abschließend noch eine Notiz zur Klasse hinzufügen?",
    "archiveClassFinalNotePlaceholder": "Notiz (optional)",
    "archiveClassFinalizeDescription": "Super, wir haben alles was wir brauchen. Bitte überprüfe deine Angaben.",
    "archiveClassOverviewDescription": "Ein weiteres Schuljahr neigt sich dem Ende zu. Lass uns gemeinsam die {className} Klasse abschließen.",
    "archiveClassOverviewHelpText": "Abgeschlossene Klassen sind in der Klassenauswahl unter “Mein Archiv…” zu finden.",
    "archiveClassTeamDescription": "Alle Inhalte bleiben erhalten, können jedoch nicht mehr geändert werden.",
    "archiveInProgress": "Klasse wird archiviert…",
    "bumpUp": "Klasse hochstufen",
    "bumpUpClassSelectClassDescription": "Bitte wähle die Klasse, die du hochstufen möchtest.",
    "bumpUpClassSelectModeDescription": "Willst du eine neue Klasse erstellen, oder eine Klasse in die nächste Schulstufe hochstufen?",
    "bumpUpDescription": "Stufe eine bestehende Klasse in die nächste Schulstufe hoch. Schülerinnen und Schüler, sowie Zugriffsrechte werden übernommen.",
    "bumpUpDialogDescription": "Es ist sinnvoll, die bestehende Klasse vor dem Hochstufen zu archivieren - so bleibt der Jahresverlauf vollständig erhalten. Du kannst aber auch direkt hochstufen.",
    "bumpUpDialogTitle": "Klasse archivieren",
    "changeClasses": "Klasse wechseln",
    "changeClassesTooltip": "Hier kannst du zwischen deinen Klassen und der Schuladministration wechseln.",
    "classAmount": "{count} Klasse | {count} Klassen",
    "classInviteOverview": "Zusammenfassung anzeigen",
    "create": "Neue Klasse",
    "createAction": "Klasse erstellen",
    "createClassTooltip": "Erstelle deine erste Klasse in der <b>Schuladministration</b>.",
    "createCompetences": "Kompetenzvorlagen anlegen",
    "createDescription": "Erstelle eine Klasse mit neuen Schülerinnen und Schülern.",
    "createNewClass": "Neue Klasse erstellen",
    "createSuccess": "{ name } wurde erstellt",
    "data": "Klassendaten",
    "delete": "Klasse löschen",
    "demoBannerDescription": "Schau dich um und probiere gerne alle Funktionen aus.",
    "demoBannerTitle": "Du befindest dich in der Digidoo Demoklasse.",
    "editClass": "Klasse bearbeiten",
    "editClassAccess": "Zugriff bearbeiten",
    "editClasses": "Klassen bearbeiten",
    "emptyStateDescription": "Erstelle jetzt deine erste Klasse.",
    "emptyStateTitle": "Noch keine Klassen",
    "filteredEmptyStateDescription": "Für das ausgewählte Schuljahr wurden keine Klassen gefunden.",
    "filteredEmptyStateTitle": "Keine Klassen für dieses Schuljahr",
    "finalizeClass": "Klasse einrichten",
    "finalizeClassAssessmentTypeDescription": "Welche Visualisierung willst du für die Leistungsfeststellung verwenden?",
    "finalizeClassStudentsDescription": "Bitte trage nun alle Schülerinnen und Schüler ein.",
    "finalizeClassStudentsDescriptionNoPerm": "Aktuell sind die folgenden Schülerinnen und Schüler für deine Klasse verfasst. Bitte kontaktiere die Administration, um diese zu verwalten.",
    "finalizeClassStudentsDescriptionNoStudentNoPerm": "Aktuell sind noch keine Schülerinnen und Schüler eingetragen. Bitte kontaktiere die Administration, um diese anzulegen und zu verwalten.",
    "finalizeDescription": "Super, wir haben alles, was wir brauchen. Bitte überprüfe deine Angaben.",
    "finalizeTitle": "Deine Klasse ist fertig eingerichtet und du kannst loslegen.",
    "finalizedClassOverviewDescription": "Deine Klasse ist bereit und du kannst loslegen.",
    "finalizedClassOverviewDescriptionAlt": "Deine Klasse ist fast fertig eingerichtet. Bitte überprüfe die folgenden Infos und du kannst gleich loslegen.",
    "finalizedTitle": "Deine Klasse ist bereit und du kannst loslegen.",
    "futureSchoolYearConfirm": {
      "confirmButtonLabel": "Trotzdem Erstellen",
      "declineButtonLabel": "Aktuelles Schuljahr wählen",
      "description": "Du erstellst diese Klasse im {selectedSchoolYearName}, obwohl derzeit das {currentSchoolYearName} aktiv ist. Möchtest du die Klasse wirklich im zukünftigen Schuljahr anlegen?",
      "title": "Zukünftiges Schuljahr ausgewählt"
    },
    "general": "Allgemein",
    "generalDataDescription": "Lass uns eine neue Klasse erstellen. Bitte lege Schulstufe und Name fest.",
    "goToClass": "Gleich zur Klasse wechseln",
    "groupedByClass": "Gruppiert nach Klasse",
    "groupedByGroup": "Gruppiert nach Gruppe",
    "mobileDocumentationTip": {
      "description": "Schon Digidoo auf dem Tablet oder deinem Computer probiert?",
      "title": "Mehr Platz zum Dokumentieren"
    },
    "moreClassesRefineSearch": "+{count} weitere Klasse – Suche eingrenzen | +{count} weitere Klassen – Suche eingrenzen",
    "newSchoolLevel": "Neue Schulstufe",
    "newYear": "Neues Schuljahr",
    "nickname": "Spitzname",
    "optionalName": "Name (optional)",
    "nicknamePlaceholder": "Eulenklasse",
    "noStudents": "Keine existierenden Schülerinnen und Schüler",
    "notGrouped": "Nicht gruppiert",
    "onlyBumpUp": "Nur Klasse hochstufen",
    "performanceAssessmentDescription": "Welche Arten der Leistungsfeststellung willst du verwenden?",
    "performanceAssessmentValidationError": "Alle Leistungsfeststellungen müssen einen Namen haben.",
    "performanceAssessmentWarning": "Die Gesamtgewichtung sollte 100% betragen.",
    "preSchoolPrefix": "V",
    "remove": "Klasse löschen",
    "removeBulk": "Klassen löschen",
    "removeBulkConfirmHint": "Alle eingegeben Inhalte der ausgewählten Klassen werden gelöscht. Schülerinnen und Schüler werden nicht gelöscht.",
    "removeBulkConfirmText": "Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um die Klasse {classNames} dauerhaft zu löschen. | Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um die Klassen {classNames} dauerhaft zu löschen.",
    "removeConfirmHint": "Alle eingegeben Inhalte werden gelöscht. Schülerinnen und Schüler werden nicht gelöscht.",
    "removeConfirmInputPlaceholder": "Vorname Nachname oder E-Mail",
    "removeConfirmText": "Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um die Klasse \"{className}\" dauerhaft zu löschen.",
    "responsible": "Verantwortlich",
    "schoolSubjectsDescription": "Welche Kompetenzen sollen verwendet werden?",
    "schoolSubjectsDescriptionAlt": "Diese Kompetenzen werden verwendet.",
    "schoolYearOverBannerDescription": "Willst du die Klasse archivieren?",
    "schoolYearOverBannerDescriptionNoPerm": "Bitte wende dich an die Administration, wenn du die Klasse archivieren lassen möchtest.",
    "schoolYearOverBannerTitle": "Das Schuljahr ist zu Ende.",
    "selection": {
      "selectedCount": "{count} Klasse ausgewählt | {count} Klassen ausgewählt"
    },
    "status": {
      "active": "Aktiv",
      "archived": "Archiviert"
    },
    "studentCount": "{count} Schüler:innen",
    "studentsAllInClass": "Der Name ist schon in der Klasse | Alle {count} Namen sind schon in der Klasse",
    "studentsAlreadyInClass": "{count} Name ist schon in der Klasse. | {count} Namen sind schon in der Klasse.",
    "studentsDescription": "Bitte trage hier alle Schülerinnen und Schüler der Klasse \"{className}\" ein.",
    "studentsPlaceholder": "Existierende Schülerinnen oder Schüler hinzufügen",
    "tableStudentCount": "Schüler:innen",
    "teamDescription": "Bitte lege fest, wer aus deinem Team Zugriff hat.",
    "teamDescriptionAlt": "Diese Personen haben Zugriff zur Klasse.",
    "teamSelectLabel": "Teammitglieder hinzufügen (Name oder E-Mail)",
    "teamSelectPlaceholder": "Name oder E-Mail",
    "tipAdmin": "Hier kannst du Klassen erstellen und bearbeiten. Du siehst auf einen Blick die zuständigen Lehrpersonen sowie die Anzahl der Schülerinnen und Schüler – beides lässt sich direkt einsehen und verwalten.",
    "tooltip": {
      "description": "Klicke hier, um deine erste Klasse zu erstellen."
    },
    "withoutClass": "Ohne Klasse",
    "welcomeToYourNewClass": "Willkommen in deiner neuen Klasse",
    "year": "Schuljahr"
  },
  "competence": {
    "confirm": "Für diese Kompetenz wurden bereits Einträge erstellt. Bist du sicher, dass du diese Kompetenz bearbeiten möchtest?",
    "count": "{count} Kompetenz | {count} Kompetenzen",
    "edit": "Kompetenz bearbeiten",
    "editPlural": "Kompetenzen bearbeiten",
    "openDomain": "Kompetenzbereich {name} öffnen",
    "remove": "Kompetenz entfernen",
    "searchPlaceholder": "Kompetenzen suchen …",
    "select": "Kompetenzen wählen",
    "showAll": "Alle Kompetenzen anzeigen"
  },
  "competenceAssessment": {
    "adjust": "Anpassen",
    "descriptionPlaceholder": "Beschreibung (optional)",
    "selectCompetenceAssessmentDescription": "Diese Leistungsfeststellung wird über die ausgewählten Kompetenzen festgehalten.",
    "selectVisual": "Lege fest, wie deine Kompetenzeinträge visualisiert werden sollen.",
    "title": "Kompetenzbewertung",
    "titlePlaceholder": "Titel (optional)",
    "visualDescription": "Visualisierung: ",
    "noVisualHint": "Erstelle zuerst eine Visualisierung für diesen Bereich."
  },
  "competenceIconGroup": {
    "activitiesAndNature": "Aktivitäten und Natur",
    "creativityAndCommunication": "Kreativität und Kommunikation",
    "geometryAndNumbers": "Geometrie und Zahlen",
    "media": "Medien",
    "peopleAndBodies": "Mensch und Körper",
    "productivityAndLearning": "Produktivität und Lernen",
    "symbols": "Symbole"
  },
  "competenceIcons": {
    "Admin": "Administrator",
    "Ai": "KI",
    "Angle": "Winkel",
    "Approve": "Genehmigen",
    "Archive": "Archiv",
    "Area": "Fläche",
    "ArrowDown": "Pfeil runter",
    "ArrowLeft": "Pfeil links",
    "ArrowRight": "Pfeil rechts",
    "ArrowUp": "Pfeil hoch",
    "Bandage": "Verband",
    "Bicycle": "Fahrrad",
    "Book": "Buch",
    "BookOpen": "Offenes Buch",
    "Brush": "Pinsel",
    "Bubble": "Sprechblase",
    "BubbleCheck": "Sprechblase Check",
    "BubbleHelp": "Sprechblase Hilfe",
    "BubbleProblem": "Sprechblase Problem",
    "BubbleQuote": "Sprechblase Zitat",
    "Calendar": "Kalender",
    "Chart": "Diagramm",
    "Check": "Prüfen",
    "CheckCircle": "Check Kreis",
    "Class": "Klasse",
    "Close": "Schließen",
    "Competence": "Kompetenz",
    "Competence2": "Kompetenz 2",
    "Competence3": "Kompetenz 3",
    "Competence4": "Kompetenz 4",
    "Competence5": "Kompetenz 5",
    "Copy": "Kopieren",
    "CreditCard": "Kreditkarte",
    "Cross": "Kreuz",
    "DavidStar": "Davidstern",
    "Delete": "Löschen",
    "Divide": "Dividieren",
    "Document": "Dokument",
    "DocumentCheck": "Dokument geprüft",
    "DocumentLines": "Dokument mit Linien",
    "DocumentPen": "Dokument bearbeiten",
    "Download": "Herunterladen",
    "Ear": "Ohr",
    "Edit": "Bearbeiten",
    "Email": "E-Mail",
    "Folder": "Ordner",
    "Football": "Fußball",
    "Gaming": "Gaming",
    "Girl": "Mädchen",
    "Glasses": "Brille",
    "Graduation": "Abschluss",
    "Group": "Gruppe",
    "Grow": "Wachsen",
    "Hammer": "Hammer",
    "Hand": "Hand",
    "HandsUp": "Hände hoch",
    "Heart": "Herz",
    "Help": "Hilfe",
    "Highlight": "Hervorheben",
    "Home": "Startseite",
    "HomeAdd": "Startseite hinzufügen",
    "Hundred": "Hundert",
    "Info": "Info",
    "Institution": "Institution",
    "Institution2": "Institution 2",
    "Invite": "Einladung",
    "Key": "Schlüssel",
    "Layers": "Ebenen",
    "Leaf": "Blatt",
    "Length": "Länge",
    "Lightning": "Blitz",
    "Link": "Link",
    "Loader": "Ladesymbol",
    "Location": "Standort",
    "Lock": "Schloss",
    "Map": "Karte",
    "MinusCircle": "Minus Kreis",
    "Moon": "Mond",
    "Move": "Bewegen",
    "Music": "Musik",
    "NewFolder": "Neuer Ordner",
    "Notification": "Benachrichtigung",
    "Owner": "Inhaber",
    "Percentage": "Prozent",
    "Phone": "Telefon",
    "Play": "Start",
    "Plus": "Plus",
    "PlusCircle": "Plus Kreis",
    "PointRight": "Zeigt nach rechts",
    "PointUp": "Zeigt nach oben",
    "Presentation": "Präsentation",
    "Print": "Drucken",
    "Rate": "Bewerten",
    "Remove": "Entfernen",
    "Room": "Raum",
    "Run": "Laufen",
    "Scissors": "Schere",
    "Scribble": "Kritzelei",
    "Search": "Suchen",
    "See": "Auge",
    "Settings": "Einstellungen",
    "Shield": "Schild",
    "Size": "Größe",
    "Smile": "Lächeln",
    "Smile2": "Lächeln 2",
    "Snowflake": "Schneeflocke",
    "Speak": "Sprechen",
    "Stand": "Stehen",
    "Star": "Stern",
    "Sum": "Summe",
    "Sun": "Sonne",
    "Sync": "Synchronisieren",
    "Temperature": "Temperatur",
    "Ten": "Zehn",
    "ThumbsUp": "Daumen hoch",
    "Thousand": "Tausend",
    "ThreeD": "3D",
    "Time": "Zeit",
    "User": "Benutzer",
    "UserNew": "Neuer Benutzer",
    "Video": "Video",
    "Warning": "Warnung",
    "Web": "Web"
  },
  "competenceObservation": {
    "addCompetences": "Kompetenzen hinzufügen",
    "allCompetencesAlreadyAddedToAllStudents": "Alle Kompetenzen wurden bereits allen Schüler:innen hinzugefügt.",
    "allCompetencesAlreadyAddedToStudent": "Alle Kompetenzen wurden bereits dieser Schülerin bzw. diesem Schüler hinzugefügt.",
    "chooseStudents": "Wähle die Schülerinnen und Schüler für den Kompetenzeintrag aus.",
    "competencePlaceholder": "Suche Kompetenz/-bereiche",
    "confirm": {
      "confirmButtonLabel": "Nur hier entfernen",
      "declineButtonLabel": "Bei allen entfernen",
      "description": "Willst du die verknüpfte Kompetenz nur bei “{studentName}” oder auch bei allen weiteren Schüler:innen entfernen?",
      "title": "Kompetenz entfernen"
    },
    "create": "Neuer Kompetenzeintrag",
    "createShort": "Neuer Eintrag",
    "createYourFirstObservation": "Erstelle deinen ersten Eintrag",
    "delete": "Kompetenz entfernen",
    "edit": "Kompetenzeintrag bearbeiten",
    "noEligibleCompetences": "Keine Kompetenzen verfügbar",
    "noEligibleStudents": "Keine Schüler:innen verfügbar",
    "notesPlaceholder": "Anmerkungen zum Kompetenzeintrag (optional)",
    "selectAll": "Alle auswählen",
    "studentPlaceholder": "Suche",
    "trendUpsellAriaLabel": "Abo-Pläne für die Entwicklungskurve öffnen",
    "trendUpsellDescription": "Mach Fortschritte über die Zeit sichtbar.",
    "trendUpsellTitle": "Entwicklungskurve mit Digidoo"
  },
  "cookieConsent": {
    "acceptAll": "Alle akzeptieren",
    "acceptSelection": "Auswahl speichern",
    "categories": {
      "analytics": {
        "ariaLabel": "Analyse aktivieren",
        "description": "Google Analytics (Google Ireland Limited) misst Seitenaufrufe und Interaktionen und verwendet dafür Cookies und Online-Kennungen. Dieser Dienst lädt erst nach deiner Einwilligung.",
        "title": "Analyse & Website-Verbesserung"
      },
      "marketing": {
        "ariaLabel": "Marketing aktivieren",
        "description": "Meta Pixel (Meta Platforms Ireland Limited) und TikTok Pixel (TikTok Technology Limited) erfassen Besuche und Interaktionen für Werbemessung und Zielgruppenbildung. Bist du angemeldet, werden deine E-Mail-Adresse und Nutzer-ID gehasht an Meta übermittelt, damit Registrierungen und Käufe den Anzeigen zugeordnet werden können. Google Ads über Google Tag Manager wird nur bei zusätzlicher Einwilligung in Analyse geladen. Dabei können Cookies, Online-Kennungen und besuchte URLs verarbeitet und Daten in Drittländer wie die USA übermittelt werden.",
        "title": "Marketing & Werbemessung"
      },
      "necessary": {
        "ariaLabel": "Technisch notwendige Cookies sind immer aktiv",
        "description": "Diese Technologien ermöglichen den Betrieb von App und Website. Wir speichern deine Cookie-Auswahl für 180 Tage. Optionale Dienste bleiben ohne Einwilligung deaktiviert.",
        "title": "Technisch notwendig"
      }
    },
    "choose": "Wählen",
    "close": "Ohne Änderungen schließen",
    "description": "Wir verwenden notwendige Cookies für den Betrieb von App und Website. Mit deiner freiwilligen Einwilligung nutzen wir außerdem Analyse- und Marketingdienste. Du kannst alle optionalen Dienste ablehnen und deine Einwilligung jederzeit über „Cookie-Einstellungen“ widerrufen.",
    "settings": "Cookie-Einstellungen",
    "title": "Wir verwenden Cookies.",
    "viewCookies": "Mehr zum Datenschutz",
    "withdrawalHint": "Wenn du eine Einwilligung widerrufst, laden wir die Seite neu, um bereits geladene Trackingdienste zu beenden."
  },
  "country": {
    "at": "Österreich",
    "de": "Deutschland",
    "ch": "Schweiz"
  },
  "dataTable": {
    "allItemsLoaded": "Keine weiteren Einträge",
    "items": {
      "classes": {
        "perPage": "Klassen pro Seite",
        "range": "{start}–{end} von {total} Klassen"
      },
      "documents": {
        "perPage": "Dokumente pro Seite",
        "range": "{start}–{end} von {total} Dokumenten"
      },
      "entries": {
        "perPage": "Einträge pro Seite",
        "range": "{start}–{end} von {total} Einträgen"
      },
      "groups": {
        "perPage": "Gruppen pro Seite",
        "range": "{start}–{end} von {total} Gruppen"
      },
      "members": {
        "perPage": "Mitglieder pro Seite",
        "range": "{start}–{end} von {total} Mitgliedern"
      },
      "people": {
        "perPage": "Personen pro Seite",
        "range": "{start}–{end} von {total} Personen"
      },
      "reports": {
        "perPage": "Berichte pro Seite",
        "range": "{start}–{end} von {total} Berichten"
      },
      "schoolYears": {
        "perPage": "Schuljahre pro Seite",
        "range": "{start}–{end} von {total} Schuljahren"
      },
      "students": {
        "perPage": "Schüler:innen pro Seite",
        "range": "{start}–{end} von {total} Schüler:innen"
      },
      "users": {
        "perPage": "Benutzer pro Seite",
        "range": "{start}–{end} von {total} Benutzern"
      }
    },
    "loadingMore": "Weitere Einträge werden geladen…",
    "next": "Nächste",
    "pagination": "Pagination",
    "previous": "Vorherige"
  },
  "date": {
    "select": "Datum wählen",
    "today": "Heute",
    "tomorrow": "Morgen",
    "yesterday": "Gestern"
  },
  "demoClassTour": {
    "addDocumentation": {
      "learningProgress": {
        "description": "Schreib einfach los! Dokumentiere den Lernfortschritt deiner Klasse in wenigen Schritten.",
        "title": "Dokumentieren"
      },
      "report": {
        "description": "Klicke jederzeit auf „{action}“, um einen neuen Bericht zu erstellen.",
        "title": "Bericht erstellen"
      }
    },
    "classSelection": {
      "description": "Klicke auf deine Klasse, um schnell zwischen Klassen zu wechseln oder zur Schuladministration zu gelangen.",
      "title": "Deine Schule"
    },
    "confirm": {
      "confirmButtonLabel": "Mit Tour fortfahren",
      "declineButtonLabel": "Zur Schuladministration",
      "description": "Wenn du zur Schuladministration wechselst, wird die Digidoo Tour beendet.",
      "title": "Tour beenden?"
    },
    "generalNavigation": {
      "description": "Hier hast du jederzeit schnellen Zugriff auf wichtige Klassenbereiche – etwa die Analyse, die Berichte oder die Klasseneinstellungen.",
      "title": "Deine Klasse"
    },
    "studentFilters": {
      "description": "Wähle hier, ob du lieber einen Gesamtüberblick über deine Schülerinnen und Schüler sehen willst, oder dich bewusst auf ein Fach konzentrieren möchtest.",
      "title": "Fächer"
    },
    "studentTabs": {
      "description": "Hier findest du den Lernstand und die Entwicklung deiner Schüler:innen auf einen Blick. Wechsle zwischen <b>Einträge, Übersicht und Berichten</b>, um alle Details anzusehen.",
      "title": "Schüler:in-Details"
    },
    "welcome": {
      "description": "Wir haben für dich schon mal eine <b>Demoklasse</b> angelegt. Schau dich um und probiere gerne alle Funktionen aus.",
      "title": "Lass uns gemeinsam Digidoo kennenlernen."
    },
    "yourClass": {
      "description": "Hier links findest du alle Schülerinnen und Schüler deiner Klasse. ",
      "title": "Deine Schüler:innen"
    }
  },
  "dragAndDrop": {
    "cancelled": "Verschieben von {name} abgebrochen.",
    "dropped": "{name} abgelegt, Position {position} von {total}.",
    "handleLabel": "{name} verschieben",
    "instructions": "Mit der Leertaste aufnehmen, mit den Pfeiltasten verschieben, mit der Leertaste ablegen oder mit Escape abbrechen.",
    "lifted": "{name} aufgenommen, Position {position} von {total}.",
    "moved": "Position {position} von {total}.",
    "movedToList": "{list}, Position {position} von {total}."
  },
  "emailWhitelist": {
    "addAllowedEmailsDialog": {
      "add": "Hinzufügen",
      "addEmailsNote": "Erlaubte E-Mail-Adressen hinzufügen, um neue Benutzer zu registrieren\nFormat: test{'@'}test.com,test2{'@'}test.com",
      "cancel": "Abbrechen",
      "email": "E-Mail-Adresse",
      "title": "Erlaubte E-Mail-Adressen hinzufügen"
    },
    "create": "Neue E-Mail-Whitelist",
    "table": {
      "email": "E-Mail-Adresse"
    },
    "title": "E-Mail-Whitelist"
  },
  "entityAppearance": {
    "background": "Hintergrundfarbe",
    "colors": {
      "amber": "Bernstein",
      "blue": "Blau",
      "brown": "Braun",
      "green": "Grün",
      "lightGray": "Hellgrau",
      "lime": "Limette",
      "mutedPurple": "Grauviolett",
      "orange": "Orange",
      "orchid": "Orchidee",
      "papaya": "Papaya",
      "pink": "Pink",
      "purple": "Violett",
      "red": "Rot",
      "sand": "Sand",
      "skyBlue": "Himmelblau",
      "turquoise": "Türkis",
      "white": "Weiß",
      "yellow": "Gelb"
    },
    "defaultTone": "Standard",
    "dropImage": "Bild hierher ziehen oder",
    "edit": "Darstellung bearbeiten",
    "emoji": "Emoji",
    "icon": "Icon",
    "image": "Bild",
    "imageDecodeError": "Dieses Bild konnte nicht geöffnet werden. Bitte eine andere Datei auswählen.",
    "imageLoading": "Bild wird geöffnet…",
    "imageSizeError": "Bitte ein Bild mit maximal 1 MB auswählen.",
    "imageTypeError": "Bitte ein Bild im Format JPG, PNG, WebP oder GIF auswählen.",
    "loadError": "Der Emoji-Katalog konnte nicht geladen werden.",
    "loading": "Emojis werden geladen…",
    "noResults": "Keine Ergebnisse",
    "removeImage": "Bild löschen",
    "search": "Suchen",
    "selectImage": "auswählen",
    "skinTone": "Hautton",
    "text": "Text",
    "uploadImage": "Datei hochladen…"
  },
  "errorMessages": {
    "BILLING_CHECKOUT_BLOCKED": "Es gibt noch eine offene Rechnung oder ein nicht abgeschlossenes Abo. Bitte begleiche zuerst die aktuelle Rechnung oder verwalte dein Abo im Abrechnungsbereich.",
    "BILLING_PRODUCT_ALREADY_EXISTS": "Für diesen Produkttyp gibt es bereits ein Produkt.",
    "CLASS_ALREADY_ARCHIVED": "Die Klasse wurde bereits abgeschlossen. Änderungen sind nicht mehr möglich.",
    "CLASS_HAS_STILL_STUDENTS": "Diese Klasse kann nicht gelöscht werden. Bitte entferne zuerst alle zugewiesenen Schülerinnen und Schüler.",
    "COMPETENCE_ASSESSMENT_SUBJECT_ACCESS_DENIED": "Bearbeiten nicht möglich: Dir fehlt der Zugriff auf Fächer mit Einträgen dieser Kompetenzbewertung.",
    "CONTACT_OWNER_TO_UPGRADE": "Deine Schule muss ihr Abo upgraden. Bitte kontaktiere deine Schulleitung.",
    "DEMO_CLASS_COPY_FAILED": "Die Demoklasse konnte nicht erstellt werden. Bitte versuche es später erneut.",
    "EMAIL_CHANGE_MAIL_ALREADY_SENT": "Eine Email wurde bereits gesendet. Versuch es in ein paar Minuten erneut",
    "EMAIL_COOLDOWN_ACTIVE": "Wir haben dieser Person kürzlich ein ähnliches E-Mail gesendet. Bitte warte, bis du es erneut versuchst.",
    "EMPTY_DTO": "Ungültige Eingabedaten",
    "FEATURE_DISABLED": "Diese Funktion ist nicht aktiviert.",
    "FILE_ALREADY_EXISTS": "Diese Datei existiert bereits",
    "FILE_SIZE_LIMIT_EXCEEDED": "Die maximale Dateigröße wurde überschritten",
    "FILE_TYPE_INVALID": "Der ausgewählte Dateityp wird nicht unterstützt",
    "FILE_VALIDATION_FAILED": "Die Datei ist ungültig",
    "FOREIGN_KEY_CONSTRAINT": "Löschen nicht möglich: Verknüpfte Daten vorhanden",
    "GET_FILE_ERROR": "Die Datei konnte nicht geladen werden",
    "IMPORT_FAILED": "Die Datei konnte nicht importiert werden",
    "INVALID_EMAIL_CHANGE_CODE": "Der Code ist ungültig, abgelaufen oder wurde bereits verwendet. Bitte frage einen neuen Code an.",
    "INVALID_IMPLICIT_DELETION": "Diese Aktion würde zu ungewollten Löschungen führen",
    "INVALID_INVITATION_CODE": "Der Einladungscode ist ungültig, abgelaufen oder wurde bereits verwendet. Bitte frage einen neuen Code an.",
    "INVALID_LOGIN": "Ungültige Anmeldedaten",
    "INVALID_PARAMETERS": "Ungültige Parameter",
    "INVALID_PASSWORD_RESET_CODE": "Der Passwort-Reset-Link ist ungültig oder abgelaufen",
    "INVALID_REFERRAL_CODE": "Der Empfehlungslink ist ungültig oder abgelaufen.",
    "INVALID_SCHOOL_YEAR": "Ungültiges Schuljahr",
    "INVALID_TOKEN": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an",
    "INVALID_USER_INVITATION": "Die Benutzereinladung ist ungültig",
    "INVITATION_RECIPIENT_DEACTIVATED": "Einladungen an deaktivierte Accounts sind nicht möglich.",
    "LOCAL_AUTH_PROVIDER_NEEDED": "Das Zurücksetzen des Passworts ist nicht verfügbar. Bitte kontaktiere den Support.",
    "MISSING_TENANT_ID": "Deine Sitzung ist ungültig. Es konnte keine Schule zugeordnet werden.",
    "NOT_FOUND": "Die angeforderte Ressource wurde nicht gefunden",
    "NOT_IMPLEMENTED": "Diese Funktion ist noch nicht verfügbar",
    "NO_PERMISSION": "Du hast keine Berechtigung für diese Aktion",
    "PASSWORD_MISMATCH": "Ungültiges Passwort",
    "PASSWORD_RESET_MAIL_ALREADY_SENT": "Eine E-Mail zum Zurücksetzen des Passworts wurde bereits versendet. Bitte warte einen Moment, bevor du es erneut versuchst",
    "PDFGEN_FAILED_REQUEST": "Die PDF-Datei konnte nicht erstellt werden. Bitte versuche es später erneut.",
    "PDFGEN_GENERIC_ERROR": "Die PDF-Datei konnte nicht erstellt werden. Bitte versuche es später erneut.",
    "PDFGEN_TIMEOUT_ERROR": "Das Erstellen der PDF-Datei hat zu lange gedauert. Bitte versuche es später erneut.",
    "PERFORMANCE_ASSESSMENT_SUBJECT_ACCESS_DENIED": "Bearbeiten oder Löschen nicht möglich: Dir fehlt der Zugriff auf Fächer mit Einträgen dieser Leistungsfeststellung.",
    "PLAN_UPGRADE_REQUIRED": "Du musst dein Abo upgraden.",
    "REFERRAL_ALREADY_ATTRIBUTED": "Für deinen Account wurde bereits eine Empfehlung eingelöst.",
    "REFERRAL_GRANT_EXCEEDS_MAXIMUM": "Die Gutschrift würde den maximalen Empfehlungsrabatt überschreiten.",
    "REFERRAL_NOT_ELIGIBLE": "Diese Empfehlung kann für deinen Account nicht eingelöst werden.",
    "REFERRAL_SELF_REFERRAL": "Du kannst deinen eigenen Empfehlungslink nicht verwenden.",
    "RELEASE_ID_ALREADY_EXISTS": "Release-ID existiert bereits.",
    "REPORT_ALREADY_COMPLETED": "Der Bericht wurde bereits abgeschlossen. Änderungen sind nicht mehr möglich.",
    "REPORT_COVER_IMAGE_MISSING": "Für das Deckblatt wird ein Bild benötigt, bevor der Bericht abgeschlossen werden kann.",
    "REPORT_NO_CLASS_ASSOCIATION": "Dieser Bericht ist keiner Klasse zugeordnet.",
    "SCHOOL_CLASS_ALREADY_ASSIGNED_TO_YEAR": "Diese Klasse ist bereits einem Schuljahr zugewiesen",
    "SCHOOL_YEAR_ALREADY_EXISTS": "Dieses Schuljahr existiert bereits",
    "SCHOOL_YEAR_IN_USE": "Das Schuljahr wird bereits verwendet",
    "STUDENT_NO_SUBJECT_RELATION": "Dieses Fach ist nicht für diese Schüler:in verfügbar",
    "TEMPLATE_SET_ALREADY_EXISTS": "Eine Kompetenzvorlage mit diesem Land, Bundesland, Schultyp, dieser Sprache, Version und Quelle existiert bereits.",
    "TENANT_ALREADY_EXISTS": "Eine Schule mit diesem Namen existiert bereits",
    "TENANT_NOT_CONNECTED_TO_STATE": "Deiner Schule ist noch kein Bundesland zugeordnet. Es kann in den Schuleinstellungen ergänzt werden.",
    "TOO_MANY_LEVELS": "Zu viele Ebenen",
    "TOO_MANY_REQUESTS": "Zu viele Anfragen. Bitte warte einen Moment",
    "UNKNOWN": "Ein unerwarteter Fehler ist aufgetreten",
    "UNKNOWN_REGISTRATION": "Deine E-Mail-Adresse ist nicht freigeschaltet. Für eine Freischaltung wende dich bitte an den Support.",
    "USER_ALREADY_EXISTS": "Diese E-Mail-Adresse wird bereits verwendet.",
    "USER_DEACTIVATED": "Dein Account wurde deaktiviert. Bitte wende dich an den Support, um ihn wiederherzustellen.",
    "VALIDATION_FAILED": "Bitte überprüfe deine Eingaben",
    "WEEKLY_REPORT_FAILED": "Wochenbericht konnte nicht erstellt werden oder ist fehlerhaft.",
    "invalidAbbreviation": "Die Abkürzung muss zwischen 1 und 3 Zeichen lang sein",
    "invalidColor": "Die Farbe muss ein gültiges Hex-Format haben",
    "invalidDate": "Die angegebene Datum ist ungültig",
    "invalidEmail": "Diese E-Mail-Adresse scheint kein gültiges Format zu haben",
    "invalidNumber": "Ungültige Zahl",
    "loginFailed": "Anmeldung fehlgeschlagen",
    "maxLength": "Darf höchstens {max} Zeichen lang sein",
    "networkError": "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
    "noAbbreviation": "Bitte gib eine Abkürzung ein",
    "noAddressLine1": "Bitte gib eine Adresse ein",
    "noConditions": "Bitte stimme den Geschäftsbedingungen und der Datenschutzerklärung zu",
    "noEmail": "Bitte gib eine E-Mail-Adresse an",
    "noFirstName": "Bitte gib einen Vornamen ein",
    "noLastName": "Bitte gib einen Nachnamen ein",
    "noName": "Bitte gib einen Namen ein",
    "noOwnEmail": "Bitte gib deine E-Mail-Adresse an",
    "noPassword": "Bitte gib dein Passwort an",
    "noSchoolSelected": "Bitte wähle eine Schule aus",
    "noTitle": "Bitte gib einen Titel ein",
    "noUserRoleType": "Bitte wähle eine Rolle",
    "passwordMismatch": "Passwörter stimmen nicht überein",
    "passwordTooShort": "Das Passwort muss mindestens {minLength} Zeichen lang sein",
    "totpCodeWrong": "Der Code ist ungültig"
  },
  "feedback": {
    "accountDeactivation": "Account-Deaktivierung",
    "appVersion": "App Version",
    "category": "Kategorie",
    "markHandled": "Als behandelt markieren",
    "markOpen": "Als offen markieren",
    "message": "Nachricht",
    "source": "Quelle",
    "starRating": "Sterne-Bewertung",
    "statusHandled": "Behandelt",
    "statusOpen": "Offen",
    "title": "Feedback",
    "userAgent": "User Agent",
    "view": "Feedback einsehen"
  },
  "general": {
    "addComments": "Anmerkungen hinzufügen",
    "activate": "Aktivieren",
    "active": "Aktiv",
    "add": "Hinzufügen",
    "additionalStudentCount": "+{count} weitere",
    "allClassesAndGroups": "Alle Klassen und Gruppen",
    "classesAndGroups": "Klassen und Gruppen",
    "description": "Beschreibung",
    "addStudents": "Schüler:innen hinzufügen",
    "all": "Alle",
    "allEntries": "Alle Einträge",
    "allStates": "Alle Bundesländer",
    "and": "und",
    "archive": "Archiv",
    "back": "Zurück",
    "billing": "Bezahlung & Abrechnung",
    "billingCustomerId": "Abrechnungs Id",
    "brand": "Digidoo",
    "bumpUp": "Hochstufen",
    "calculation": "Analyse berücksichtigt",
    "cancel": "Abbrechen",
    "cancelEntry": "Eintrag abbrechen",
    "cancelEntryDescription": "Wenn du dieses Fenster schließt, gehen alle bisher vorgenommenen Änderungen verloren. Möchtest du den Eintrag trotzdem abbrechen?",
    "choose": "Wählen",
    "class": "Klasse",
    "classTeam": "Klassenteam",
    "classes": "Klassen",
    "clearFilters": "Filter entfernen",
    "close": "Schließen",
    "competenceEntry": "Kompetenzeintrag",
    "competenceGrid": "Kompetenzraster",
    "competenceObservations": "Kompetenzeintrag | Kompetenzeinträge",
    "competences": "Kompetenzen",
    "contact": "Kontakt",
    "contactUs": "Kontaktiere uns",
    "continue": "Weiter",
    "continueEditing": "Weiter bearbeiten",
    "copy": "Kopieren",
    "country": "Land",
    "create": "Erstellen",
    "createSuccess": "{ count } Eintrag hinzugefügt! | { count } Einträge hinzugefügt!",
    "created": "Erstellt",
    "createdAt": "Erstellt am",
    "date": "Datum",
    "deactivated": "Deaktiviert",
    "delete": "Löschen",
    "deleteSuccess": "Eintrag gelöscht!",
    "demoClass": "Demoklasse",
    "details": "Details",
    "discardChanges": "Änderungen verwerfen",
    "discardChangesDescription": "Du hast Änderungen vorgenommen, aber noch nicht mit „Fertig“ gespeichert. Wenn du dieses Fenster schließt, gehen diese Änderungen verloren. Möchtest du die Änderungen trotzdem verwerfen?",
    "discardChangesTitle": "Änderungen verwerfen?",
    "done": "Fertig",
    "download": "Speichern",
    "downloadAll": "Alle speichern",
    "duplicate": "Duplizieren",
    "edit": "Bearbeiten",
    "editSuccess": "Eintrag bearbeitet!",
    "email": "E-Mail",
    "fileType": "{format}-Datei",
    "findOutMore": "Erfahre mehr",
    "firstName": "Vorname",
    "goToOverview": "Zur Übersicht",
    "group": "Gruppierung",
    "groups": "Gruppen",
    "hideDetails": "Details verbergen",
    "imageFileType": "{format}-Bild",
    "import": "Importieren",
    "inherited": "Vererbt",
    "journal": "Verlauf",
    "language": "Sprache",
    "lastName": "Nachname",
    "later": "Später",
    "learnMore": "Mehr erfahren",
    "learningProgress": "Lernfortschritt",
    "legalNotice": "Impressum",
    "logout": "Abmelden",
    "maxFileSize": "max. Dateigröße: {size}",
    "more": "mehr",
    "moreResultsRefineSearch": "+{count} weiterer Treffer – Suche eingrenzen | +{count} weitere Treffer – Suche eingrenzen",
    "multiEntry": "Eintrag",
    "name": "Name",
    "newEntry": "Neuer Eintrag",
    "no": "Nein",
    "noActions": "Keine Aktionen verfügbar",
    "noEntries": "Keine Einträge",
    "noEntriesYet": "Noch keine Einträge",
    "noOptions": "Keine Optionen verfügbar",
    "noResults": "Keine Ergebnisse",
    "noSeatsAvailableForInvitation": "Es ist kein Platz mehr frei, um ein weiteres Mitglied einzuladen.",
    "or": "oder",
    "order": "Reihenfolge",
    "performanceAssessment": "Leistungsfeststellung | Leistungsfeststellungen",
    "performanceVisual": "Visualisierung",
    "print": "Drucken",
    "printAll": "Alle drucken",
    "recommended": "empfohlen",
    "remove": "Entfernen",
    "retry": "Erneut versuchen",
    "role": "Rolle",
    "save": "Speichern",
    "schoolLevel": "Schulstufe",
    "schoolLevelCount": "1 Schulstufe | {count} Schulstufen",
    "schoolLevelOption": "{ schoolLevel }. Schulstufe",
    "schoolLevelPreSchool": "Vorschulstufe",
    "schoolLevelsContinuousHint": "Schulstufen müssen zusammenhängend sein — keine Lücken erlaubt (z. B. 1–6).",
    "schoolName": "Schule",
    "schoolTemplate": "Schulvorlage",
    "schoolTerm": "Semester",
    "schoolType": "Schultyp",
    "schoolYearPeriod": "Zeitraum",
    "schoolYears": "Schuljahre",
    "search": "Suche",
    "securityAndPrivacy": "Sicherheit & Datenschutz",
    "select": "Auswählen",
    "selectAll": "Alle auswählen",
    "selectEntryType": "Eintragstyp wählen",
    "show": "Zeige",
    "showAll": "Anzeigen",
    "showDetails": "Details anzeigen",
    "skip": "Überspringen",
    "startTour": "Tour starten",
    "state": "Bundesland",
    "status": "Status",
    "student": "Schüler:in",
    "studentCount": "{count} Schüler:in | {count} Schüler:innen",
    "students": "Schüler:innen",
    "subjectOrSubjects": "{count} Fach | {count} Fächer",
    "subjects": "Fächer",
    "switchToClass": "Zur Klasse wechseln",
    "teachers": "Lehrpersonen",
    "team": "Team",
    "template": "Template",
    "templateSource": "Vorlagenquelle",
    "title": "Titel",
    "today": "Heute",
    "updated": "Bearbeitet",
    "updatedAt": "Bearbeitet am",
    "uploadSizeExceeded": "Die Datei ist zu groß. Bitte wähle eine Datei mit maximal {size}.",
    "uploadTypeInvalid": "Dieser Dateityp wird nicht unterstützt. Bitte wähle einen der folgenden Dateitypen: {fileTypes}.",
    "willBeInvited": "wird zum Team eingeladen",
    "willBeInvitedDescription": "Die Lehrperson erhält im Anschluss eine Einladung deinem <b>Team beizutreten</b> und kann danach gleich in dieser Klasse loslegen.",
    "xOfY": "{ x } von { y }",
    "yes": "Ja",
    "completed": "Abgeschlossen"
  },
  "gradeCalculation": {
    "activation": {
      "activatedToast": "Notenberechnung aktiviert",
      "description": "Digidoo berechnet aus den Leistungsfeststellungen und deren Gewichtung eine nachvollziehbare Notenempfehlung.",
      "descriptionLink": "Gewichtung",
      "descriptionPrefix": "Digidoo berechnet aus deinen Leistungsfeststellungen und deren ",
      "descriptionSuffix": " einen nachvollziehbaren Notenvorschlag und schafft Klarheit bei der Beurteilung.",
      "descriptionWithLink": "Digidoo berechnet aus deinen Leistungsfeststellungen und deren {link} einen nachvollziehbaren Notenvorschlag und schafft Klarheit bei der Beurteilung.",
      "inactive": "Die Notenempfehlung ist nicht aktiv.",
      "title": "Notenempfehlung aktivieren"
    },
    "decreaseWeighting": "Gewichtung verringern",
    "disclaimer": "Die berechneten Noten dienen als Orientierung. Die abschließende Beurteilung und Verantwortung für die Notengebung liegt bei der Lehrperson.",
    "editWeighting": "Gewichtung bearbeiten",
    "entryTag": "Gewichtung",
    "entryTagDescription": "Lege fest, ob und wie sehr sich diese Leistungsfeststellung auf die Gesamtbeurteilung auswirkt.",
    "gradeLevels": {
      "addLevel": "Note hinzufügen",
      "bestGrade": "Beste Note",
      "bestGradeLower": "beste Note",
      "defaultName": "Note",
      "descriptionPlaceholder": "Beschreibung",
      "lowerIsBetterLabel": "Niedrigere Zahl ist die beste Note",
      "namePlaceholder": "Name",
      "orderDescription": "Welche Reihenfolge soll die Notenberechnung verwenden?",
      "orderTitle": "Reihenfolge",
      "reverseAction": "Reihenfolge umdrehen",
      "reverseConfirmDescriptionRich": "Du drehst die Reihenfolge der Noten um. Aus {fromGrade} wird {toGrade}. Bestehende Notenvorschläge aller aktiven Klassen werden neu berechnet.",
      "reverseConfirmTitle": "Reihenfolge umdrehen",
      "title": "Noten",
      "worstGrade": "Schlechteste Note",
      "worstGradeLower": "schlechteste Note"
    },
    "increaseWeighting": "Gewichtung erhöhen",
    "noWeightingContext": "Für diesen Kontext sind noch keine Leistungsfeststellungen vorhanden.",
    "recommendation": {
      "achieved": "Erreicht",
      "asOfDate": "mit Stand vom {date}",
      "asOfToday": "mit heutigem Stand",
      "assessmentLabel": "Leistungsfeststellung",
      "assessmentsTitle": "Leistungsfeststellungen",
      "assessmentsTitleWithCount": "{count} Eintrag | {count} Einträge",
      "contribution": "Beitrag",
      "dialogExplanation": "Die stärkste Auswirkung auf die aktuelle Empfehlung hat {assessment} mit {weighting}% Gewichtung.",
      "dialogExplanationPartial": "Die Empfehlung basiert aktuell auf {availableWeight}% der verfügbaren Gewichtung. {assessment} wirkt derzeit am stärksten.",
      "dialogFallback": "Für diese Notenempfehlung liegen aktuell bewertete Leistungsfeststellungen vor.",
      "exactGrade": "Genaue Note",
      "gradeProposal": "Notenvorschlag",
      "includedEntries": "Einträge",
      "meanGrade": "Mittelwert",
      "moreAboutRecommendation": "Mehr zur Notenempfehlung",
      "noData": "Keine Daten",
      "observationsLabel": "Lernbeobachtungen",
      "shortTitle": "Note",
      "subjectCardNoRecommendation": "keine Notenempfehlung",
      "subjectCardObservationCount": "{ count } Lernbeobachtung | { count } Lernbeobachtungen",
      "subjectCardRecommendationPrefix": "Empfehlung:",
      "subjectCardRecommendationValue": "{grade}",
      "subjectCardRecommendationValueWithName": "{grade} ({name})",
      "title": "Notenempfehlung",
      "titleAverage": "Notendurchschnitt",
      "totalAchieved": "Gesamt erreicht",
      "widgetDescription": "Auf Basis der aktuellen Gewichtung ergibt sich derzeit Note {grade}. Den stärksten Einfluss hat {assessment}.",
      "widgetDescriptionAverageOverall": "Auf Basis aller Empfehlungen ergibt sich ein Notendurchschnitt von {exactGrade} – gerundet die {grade}.",
      "widgetDescriptionEmpty": "Für die Berechnung einer Notenempfehlung ist mindestens {entry} erforderlich.",
      "widgetDescriptionEmptyEntry": "eine Leistungsfeststellung",
      "widgetDescriptionFallback": "Auf Basis der aktuellen Gewichtung liegt bereits eine Notenempfehlung vor.",
      "widgetDescriptionResult": "Auf Basis der Gewichtung und Verteilung ergibt sich insgesamt die {grade}.",
      "widgetDescriptionResultWithDetailsPlural": "Auf Basis deiner {count} Einträge und deren Gewichtung ergibt sich {asOf} insgesamt die {grade}.",
      "widgetDescriptionResultWithDetailsSingular": "Auf Basis deines Eintrags und dessen Gewichtung ergibt sich {asOf} insgesamt die {grade}.",
      "widgetGradeLabel": "Note {grade}",
      "widgetGradeLabelWithName": "Note {grade} ({name})",
      "widgetHideSensitiveData": "Sensible Daten ausblenden",
      "widgetShowDetails": "Details anzeigen",
      "widgetShowSensitiveData": "Sensible Daten anzeigen"
    },
    "schoolLevels": {
      "confirmAction": "Aktualisieren",
      "confirmDescription": "Die Notenberechnung ist danach für {scope} aktiv.",
      "confirmRemoveAction": "Deaktivieren",
      "confirmRemoveDescriptionRich": "Die Notenberechnung ist danach nur noch für {scope} aktiv.",
      "confirmRemoveTitle": "Notenberechnung deaktivieren",
      "confirmTitle": "Notenberechnung aktualisieren",
      "dialogDescription": "Für welche Schulstufen soll die Notenempfehlung verwendet werden?",
      "dialogTitle": "Schulstufen",
      "edit": "bearbeiten",
      "listMultiple": "{items} und {lastItem}",
      "listPair": "{firstItem} und {secondItem}",
      "scopeAll": "alle Schulstufen",
      "scopeMultiple": "Schulstufen {schoolLevels}",
      "scopePreSchoolAndMultiple": "die Vorschulstufe sowie Schulstufen {schoolLevels}",
      "scopePreSchoolAndSingle": "die Vorschulstufe sowie Schulstufe {schoolLevel}",
      "scopeSingle": "Schulstufe {schoolLevel}",
      "scopeSinglePreSchool": "die Vorschulstufe",
      "summary": "Die Notenberechnung ist für {scope} aktiv."
    },
    "tags": {
      "default": "Normal gewichten",
      "excluded": "Nicht gewichten",
      "high": "Hoch gewichten",
      "higher": "Höher gewichten",
      "lower": "Niedriger gewichten"
    },
    "tagsDescription": "Diese vorbereiteten Tags steuern, wie stark einzelne Leistungsfeststellungen in die Berechnung einfließen. Die Tag-Struktur bleibt damit für spätere Admin-Konfigurationen offen.",
    "tagsTitle": "Tags für Leistungsfeststellungen",
    "tip": "Hier aktivierst du die automatische Notenberechnung deiner <b>{school}</b> und legst die Standard-Visualisierung für den Notenvorschlag fest.",
    "title": "Noten",
    "visual": {
      "description": "Lege fest, wie deine Noten visualisiert werden sollen.",
      "label": "Schulnoten",
      "title": "Visualisierung"
    },
    "weightingContext": {
      "default": "Alle Fächer",
      "inherited": "Erbt die allgemeine Gewichtung für {subject}",
      "subjectSpecific": "Fachspezifisch für {subject}"
    },
    "weightingDescription": "Die Gewichtung wird für die automatische Notenempfehlung verwendet.",
    "weightingDialogTitleDefault": "Gewichtung für alle Fächer",
    "weightingDialogTitleSubject": "Gewichtung für {subject}",
    "weightingTotal": "Gesamtgewichtung: {total}%",
    "weightingValidation": "Die Gewichtung muss genau 100% ergeben. Aktuell: {total}%.",
    "weightingValidationCompact": "Die Gewichtungen ergeben aktuell {total}% statt 100%. Bitte passe die Werte an.",
    "weightingZeroInfo": "Leistungsfeststellungen mit 0% Gewichtung werden bei der Notenberechnung nicht berücksichtigt."
  },
  "groups": {
    "abbreviation": "Abkürzung",
    "archive": "Gruppe archivieren",
    "archiveBannerTitle": "Diese Gruppe befindet sich im Archiv.",
    "archiveConfirmButton": "Ja, Gruppe archivieren",
    "archiveConfirmDescription": "Inhalte archivierter Gruppen sind nicht mehr bearbeitbar. Bist du sicher, dass du fortfahren möchtest?",
    "archiveInProgress": "Gruppe wird archiviert…",
    "archiveOverviewDescription": "Ein weiteres Schuljahr neigt sich dem Ende zu. Lass uns gemeinsam die {className} Gruppe abschließen.",
    "bumpUp": "Gruppe hochstufen",
    "bumpUpDialogDescription": "Es ist sinnvoll, die bestehende Gruppe vor dem Hochstufen zu archivieren - so bleibt der Jahresverlauf vollständig erhalten. Du kannst aber auch direkt hochstufen.",
    "bumpUpDialogTitle": "Gruppe archivieren",
    "canManageAccessRightsTooltip": "Die Lehrperson kann weitere Kolleg:innen zur Gruppe hinzufügen und deren Zugriffsrechte verwalten.",
    "canManageStudentsTooltip": "Die Lehrperson kann Schüler:innen jederzeit anlegen, bearbeiten und aus der Gruppe entfernen.",
    "collectiveRatingWholeGroup": "Sammelbewertung für die gesamte Gruppe",
    "createGroupAction": "Gruppe erstellen",
    "createNewGroup": "Neue Gruppe erstellen",
    "createSuccess": "{ name } wurde erstellt",
    "data": "Gruppendaten",
    "delete": "Gruppe löschen",
    "deleteBlockedByStudents": "Diese Gruppe kann nicht gelöscht werden. Bitte entferne zuerst alle zugewiesenen Schülerinnen und Schüler.",
    "editGroup": "Gruppe bearbeiten",
    "finalizedOverviewDescription": "Deine Gruppe ist bereit und du kannst loslegen.",
    "finalizedOverviewDescriptionAlt": "Deine Gruppe ist fast fertig eingerichtet. Bitte überprüfe die folgenden Infos und du kannst gleich loslegen.",
    "futureSchoolYearDescription": "Du erstellst diese Gruppe im {selectedSchoolYearName}, obwohl derzeit das {currentSchoolYearName} aktiv ist. Möchtest du die Gruppe wirklich im zukünftigen Schuljahr anlegen?",
    "generalDataDescription": "Lass uns eine neue Gruppe erstellen. Bitte lege Schuljahr und Name fest.",
    "group": "Gruppe",
    "groupAmount": "{count} Gruppe | {count} Gruppen",
    "levelAndGroup": "Schulstufe / Gruppe",
    "myGroup": "Meine Gruppe",
    "onlyBumpUp": "Nur Gruppe hochstufen",
    "performanceAssessmentTipTeacher": "Hier siehst du, welche Art der Leistungsdokumentation in deiner Gruppe <b>{currentClass}</b> verwendet wird. Je nach Berechtigung kannst du diese bearbeiten oder neue Dokumentationsarten hinzufügen.",
    "performanceVisualBlockedByArchived": "Du kannst die Visualisierung nicht ändern, da die Gruppe archiviert ist.",
    "performanceVisualTipTeacher": "Hier siehst du die Visualisierungen, die für die Leistungsdokumentation in deiner Gruppe <b>{currentClass}</b> verwendet werden. Je nach Berechtigung kannst du weitere Visualisierungen hinzufügen.",
    "proAccessRightsTooltip": "Mit einem Digidoo-Abo legst du fest, wer in einer Gruppe Schüler:innen, Kompetenzen, Leistungsfeststellungen sowie Rechte und Zugriff verwalten darf.",
    "remove": "Gruppe löschen",
    "removeConfirmHint": "Alle eingegeben Inhalte werden gelöscht. Schülerinnen und Schüler werden nicht gelöscht.",
    "removeConfirmText": "Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um die Gruppe \"{className}\" dauerhaft zu löschen.",
    "reportNoStudents": "Deine Gruppe hat noch keine Schüler:innen. Füge Schüler:innen hinzu, damit du einen Bericht erstellen kannst.",
    "reportNoSubjects": "Deine Gruppe hat noch keine Fächer. Füge Fächer hinzu, damit du einen Bericht erstellen kannst.",
    "schoolSubjectDescription": "Bitte wähle das Fach für deine Gruppe.",
    "schoolYearOverBannerDescription": "Willst du die Gruppe archivieren?",
    "schoolYearOverBannerDescriptionNoPerm": "Bitte wende dich an die Administration, wenn du die Gruppe archivieren lassen möchtest.",
    "statisticsTip": "Hier erhältst du mit der Digidoo-Blume einen visuellen Überblick über den Kompetenzstand deiner Gruppe <b>{currentClass}</b>. Analysiere einzelne Fächer und Kompetenzen im Detail und sieh auf einen Blick, wie die gesamten Einträge verteilt sind. Verfeinere deine Analyse mit gezielten Filtern.",
    "studentsAllInGroup": "Der Name ist schon in der Gruppe | Alle {count} Namen sind schon in der Gruppe",
    "studentsAlreadyInGroup": "{count} Name ist schon in der Gruppe. | {count} Namen sind schon in der Gruppe.",
    "studentsDescription": "Bitte trage hier alle Schülerinnen und Schüler der Gruppe \"{className}\" ein.",
    "studentsStepDescription": "Bitte trage nun alle Schüler:innen der Gruppe ein.",
    "switchToGroup": "Zur Gruppe wechseln",
    "switchToGroupAfterCreate": "Gleich zur Gruppe wechseln",
    "team": "Gruppenteam",
    "teamEmptyStateTitle": "Noch kein Gruppenteam",
    "teamMemberRemoveDescription": "Bist du sicher, dass du diese Lehrperson aus der Gruppe entfernen möchtest?",
    "teamMemberWillBeInvitedDescription": "Die Lehrperson erhält im Anschluss eine Einladung deinem <b>Team beizutreten</b> und kann danach gleich in dieser Gruppe loslegen.",
    "teamMembersDescriptionAlt": "Diese Personen haben Zugriff zur Gruppe.",
    "teamTip": "Hier siehst du alle Lehrpersonen, die in deiner Gruppe <b>{currentClass}</b> unterrichten. Berechtigungen und Freigaben für Fächer sind hier einsehbar und können nur von Admins geändert werden. Je nach eigener Berechtigung kannst du weitere Lehrpersonen zur Gruppe hinzufügen.",
    "timelineSetupNoStudentSubjectsRequestMailBody": "Hallo {firstNameReceiver},\n\nich möchte Lernfortschritte für {studentName} in der Gruppe \"{className}\" erstellen, aber für diese:n Schüler:in sind noch keine Fächer verknüpft und ich habe dafür keine Berechtigung.\n\nBitte verknüpfe Fächer für diese:n Schüler:in, damit ich starten kann:\n{classSetupLink}\n\nVielen Dank!",
    "timelineSetupNoStudentSubjectsRequestMailSubject": "Bitte Fächer für {studentName} in der Gruppe \"{className}\" verknüpfen",
    "timelineSetupNoStudentsMessage": "Lernfortschritte brauchen Schüler:innen. Füge sie zuerst hinzu oder verknüpfe bestehende mit dieser Gruppe.",
    "timelineSetupNoStudentsRequestMailBody": "Hallo {firstNameReceiver},\n\nich möchte Lernfortschritte für die Gruppe \"{className}\" erstellen, aber in dieser Gruppe sind noch keine Schüler:innen verknüpft und ich habe dafür keine Berechtigung.\n\nBitte lege Schüler:innen an oder verknüpfe bestehende Schüler:innen mit dieser Gruppe, damit ich starten kann:\n{classSetupLink}\n\nVielen Dank!",
    "timelineSetupNoStudentsRequestMailSubject": "Bitte Schüler:innen für die Gruppe \"{className}\" hinzufügen",
    "timelineSetupNoSubjectsMessage": "Jeder Lernfortschritt braucht ein Fach. Du hast in dieser Gruppe noch keinen Zugriff auf ein Fach.",
    "tipAdmin": "Hier kannst du Gruppen erstellen und verwalten. In Gruppen kannst du Schüler:innen klassen- und schulstufenübergreifend zusammenfassen – zum Beispiel für Förder-, Chor- oder Leistungsgruppen.",
    "tipAll": "Hier siehst du den zeitlichen Verlauf aller Einträge deiner Gruppe <b>{currentClass}</b> auf einen Blick. Verschaffe dir einen genauen Überblick und filtere gezielt nach Fächern.",
    "tipSettings": "Hier siehst du alle Schülerinnen und Schüler deiner Gruppe <b>{currentClass}</b>. Je nach Berechtigung kannst du ihre Daten verwalten oder neue Schülerinnen und Schüler zur Gruppe hinzufügen.",
    "withoutGroup": "Ohne Gruppe",
    "welcomeToYourNewGroup": "Willkommen in deiner neuen Gruppe",
    "wholeGroup": "Gesamte Gruppe",
    "wholeGroupWithName": "Gruppe {name}"
  },
  "growth": {
    "firstEntrySuccess": {
      "bodyInvite": "Möchtest du nun dein Team einladen,\ndamit ihr gleich gemeinsam loslegen könnt?",
      "bodySimple": "Du hast deinen ersten erfolgreichen Eintrag erstellt.",
      "closeCta": "Schließen",
      "doneCta": "Fertig",
      "goToClassCta": "Zur Klasse wechseln",
      "hint": "⏱️ Das dauert nur ca. 3 Minuten.",
      "inviteCta": "Mein Team einladen",
      "laterCta": "Ich mache das später",
      "requestClassCta": "Klasse anfragen",
      "requestClassHint": "Dir wurde noch keine Klasse zugewiesen. Bitte fordere den Zugang bei der Direktion an.",
      "requestClassMailBody": "Hallo {firstNameReceiver},\n\n{fullNameSender} ist bereits bei Digidoo registriert, hat jedoch noch keine Klasse zugewiesen bekommen.\n\nBitte lege eine Klasse an oder ordne die Person einer bestehenden Klasse zu.\n\nHier kannst du die Klassenzuweisung vornehmen:\n{classAssignmentLink}\n\nVielen Dank!",
      "requestClassMailSubject": "Bitte erstelle eine Klasse für mich",
      "secondEntryCta": "Zweiten Eintrag erstellen",
      "title": "Super! Dein erster Eintrag ist geschafft."
    },
    "popup": {
      "createClass": {
        "body": "Starte jetzt und dokumentiere\nLernfortschritte direkt in deiner Klasse.",
        "close": "Schließen",
        "hint": "⏱️ Das dauert nur ca. 2 Minuten.",
        "primary": "Klasse erstellen",
        "secondary": "Ich mach das später",
        "title": "Erstelle jetzt deine erste\nKlasse."
      },
      "decision": {
        "body": "Digidoo kann alleine oder im Team genutzt werden. Sag uns kurz, was für dich aktuell passt.",
        "hint": "🙂 Diese Entscheidung kannst du jederzeit ändern.",
        "primary": "Ich arbeite vorerst alleine",
        "secondary": "Ich möchte im Team arbeiten",
        "title": "Wie möchtest du Digidoo nutzen?"
      },
      "firstEntry": {
        "body": "Erlebe Digidoo am besten, indem du einen echten Eintrag machst.",
        "close": "Schließen",
        "hint": "⏱️ Das dauert nur ca. 2 Minuten.",
        "primary": "Ersten Eintrag starten",
        "secondary": "Ich mache das später",
        "title": "Starte jetzt mit deinem\nersten Eintrag."
      },
      "schoolSetup": {
        "body": "Erstelle Kompetenzen, Fächer und Klassen und starte mit der Dokumentation von Lernfortschritten.",
        "close": "Schließen",
        "hint": "⏱️ Das dauert nur ca. 2 Minuten.",
        "primary": "Schule einrichten",
        "secondary": "Ich mach das später",
        "title": "Super, lass uns nun deine\nSchule einrichten."
      }
    },
    "tooltip": {
      "firstEntry": {
        "body": "Klicke hier, um deinen ersten Eintrag zu erstellen.",
        "title": "Los geht’s!"
      }
    }
  },
  "inviteUser": {
    "access": {
      "optional": "(optional)",
      "teacherLabel": "Die eingeladenen Personen haben Zugriff auf:"
    },
    "admin": {
      "description": "Lade ein oder mehrere Administrator:innen ein. Diese erhalten automatisch Zugriff auf alle Klassen.",
      "title": "Administrator:innen einladen"
    },
    "error": {
      "alreadyInvited": "Diese Person wurde bereits eingeladen.",
      "alreadyMember": "Diese Person ist bereits Mitglied deiner Schule."
    },
    "external": {
      "description": "Lade Personen außerhalb eurer Schule ein. Externe Personen haben Zugriff auf ausgewählte Kompetenzen.",
      "title": "Externe Personen einladen"
    },
    "teacher": {
      "description": "Lade ein oder mehrere Kolleg:innen ein. Wenn du möchtest, kannst du sie direkt einer Klasse zuweisen.",
      "title": "Lehrpersonen einladen"
    }
  },
  "help": {
    "description": "Du brauchst Hilfe oder hast Ideen, wie Digidoo noch besser sein könnte?",
    "faq": "Hilfe",
    "feedback": "Feedback",
    "feedbackMail": {
      "body": "Hallo Digidoo Team,\nich habe folgendes Feedback für euch:\n\n\n\nLiebe Grüße,\n{ name }\n\n\nTechnische Details, bitte nicht ändern:\n",
      "subject": "Feedback zu Digidoo"
    },
    "fixedArticles": {
      "videoTutorials": {
        "question": "Video Tutorials",
        "sectionTitle": "Video Tutorials"
      },
      "welcome": {
        "question": "Willkommen",
        "sectionTitle": "Willkommen"
      }
    },
    "mostFrequentQuestions": "Häufige Fragen",
    "nothingSelected": "Nichts ausgewählt",
    "privacy": "Privatsphäre",
    "rating": {
      "anchorText": "Digidoo bewerten",
      "description": "Dein Feedback hilft uns, Digidoo stetig zu verbessern.",
      "directFeedback": "Oder gib uns direkt Feedback",
      "engagementDescription": "Super! Du hast schon {count} {entity} erstellt.",
      "entities": {
        "competenceEntry": "Kompetenzeinträge",
        "performanceAssessmentEntry": "Leistungsfeststellungen",
        "report": "Berichte"
      },
      "feedbackEntityDescription": "Super! Du hast schon {count} {entity}. Wie gefällt dir Digidoo bisher?",
      "final": "Danke. Dein Feedback ist bei uns eingegangen.",
      "greatRatingDescription": "Schön, dass Digidoo dich im Schulalltag unterstützt.",
      "greatRatingTitle": "Danke für dein positives Feedback 🎉",
      "improveRatingDescription1Star": "Es tut uns leid, dass Digidoo dich noch nicht überzeugt. Was können wir verbessern?",
      "improveRatingDescription2And3Stars": "Erzähl uns bitte kurz, was nicht gut funktioniert hat.",
      "improveRatingTitle": "Danke für dein Feedback.",
      "rateNow": "Jetzt bewerten",
      "rateOnGoogle": "Auf Google bewerten",
      "recommend": "Digidoo weiterempfehlen",
      "sendFeedback": "Feedback senden",
      "sendSuccess": "Vielen Dank für dein Feedback!",
      "textPlaceholder": "Du hast Feedback?",
      "title": "Wie gefällt dir Digidoo?"
    },
    "title": "Hilfe & Kontakt",
    "tooltipDescription": "Klicke jederzeit hier, um mehr über Digidoo zu erfahren, Video Tutorials anzusehen oder uns zu kontaktieren.",
    "tooltipTitle": "Hilfe und Support",
    "version": "Digidoo { version }",
    "videos": "Video Tutorials",
    "webinar": {
      "bookSlot": "Termin wählen",
      "description": "Wir beantworten gerne deine Fragen und machen dich mit Digidoo vertraut.",
      "title": "Webinar"
    }
  },
  "imageAlt": {
    "digidooLogo": "Digidoo Logo",
    "digidooUpgradeIcon": "Digidoo Upgrade Symbol",
    "logo": "Logo"
  },
  "asyncOperations": {
    "error": "Ausführung fehlgeschlagen",
    "pending": "Wird ausgeführt",
    "success": "Wurde erfolgreich ausgeführt"
  },
  "providerEmails": {
    "allTypes": "Alle E-Mail-Typen",
    "deactivatedMemberId": "Deaktiviertes Mitglied (ID)",
    "deliveryDetail": "Zustelldetails",
    "deliveryState": "Zustellstatus",
    "deliveryStateAt": "Zustellstatus aktualisiert",
    "deliveryStates": {
      "bounced": "Unzustellbar",
      "complained": "Beschwerde",
      "delayed": "Verzögert",
      "delivered": "Zugestellt",
      "rejected": "Abgelehnt"
    },
    "emptyDescription": "Für diese Auswahl sind keine E-Mail-Protokolle vorhanden.",
    "error": "Versandfehler",
    "idFilter": "ID: {id}",
    "loadError": "E-Mails konnten nicht geladen werden.",
    "loading": "E-Mails werden geladen…",
    "messageId": "Nachrichten-ID",
    "metadata": {
      "billingSubscriptionId": "Abonnement-ID",
      "targetClassId": "Klassen-ID",
      "tenantId": "Schul-ID"
    },
    "noTracking": "Keine Tracking-Daten",
    "openUser": "In Benutzern öffnen",
    "providerMessageId": "Provider-Nachrichten-ID",
    "recipient": "Empfänger",
    "recipientUser": "Empfänger-Konto",
    "sendStates": {
      "error": "Fehlgeschlagen",
      "sending": "Wird gesendet",
      "success": "Gesendet"
    },
    "sender": "Absender",
    "status": "Versandstatus",
    "title": "E-Mails",
    "type": "E-Mail-Typ"
  },
  "schoolSubject": {
    "title": "Fächer",
    "abbreviation": "Kürzel",
    "schoolLevel": "Schulstufe",
    "competenceDomains": "Kompetenzbereiche",
    "assignedTypes": "Zugeordnete Fachtypen",
    "onlyWithoutTypes": "Nur ohne Fachtyp",
    "onlyNotClassifiable": "Nur nicht klassifizierbare",
    "allSchoolLevels": "Alle Schulstufen",
    "allSchoolTypes": "Alle Schultypen",
    "classify": "Mit LLM klassifizieren",
    "classifyPending": "Fach wird klassifiziert …",
    "classifyDone": "Fach klassifiziert",
    "classifyError": "Klassifizierung fehlgeschlagen",
    "classifyAllPending": "Fächer werden klassifiziert …",
    "classifyAllDone": "Klassifizierung abgeschlossen",
    "classifyAllError": "Klassifizierung fehlgeschlagen",
    "selectedCount": "{count} Fach ausgewählt | {count} Fächer ausgewählt",
    "editTypes": "Fachtypen bearbeiten",
    "editTypesHint": "Wähle die Fachtypen für dieses Fach.",
    "noTypes": "Keine Fachtypen"
  },
  "schoolSubjectType": {
    "title": "Fachtypen",
    "key": "Schlüssel",
    "label": "Bezeichnung",
    "order": "Reihenfolge",
    "deleteConfirm": "Möchtest du den Fachtyp \"{name}\" wirklich löschen?",
    "classifyAll": "Klassifizierung starten",
    "classifyAllConfirm": "Alle Fächer werden im Hintergrund anhand bestehender Fächer und Synonyme (ohne LLM) neu klassifiziert. Fortfahren?",
    "classifyStarted": "Klassifizierung wurde gestartet."
  },
  "externalMaterial": {
    "title": "Externes Material",
    "externalId": "Externe ID",
    "family": "Familie",
    "logo": "Logo",
    "logoSecurityHint": "Bilder von selbst erstellten Apps werden aus Sicherheitsgründen nicht geladen.",
    "logoUploadHint": "Speichere den Eintrag zuerst, um ein Logo hochzuladen.",
    "subjectSource": "Fach / Gegenstand",
    "schoolLevels": "Schulstufen",
    "countries": "Länder",
    "anyCountry": "Alle Länder",
    "languages": "Sprachen",
    "anyLanguage": "Alle Sprachen",
    "subjectTypes": "Fachtypen",
    "noSubjectTypes": "Keine Fachtypen",
    "sourceUrl": "Quell-URL",
    "searchTerms": "Suchbegriffe",
    "usageCount": "Verwendungen",
    "isVisible": "Sichtbar",
    "isFree": "Kostenlos",
    "isVerified": "Verifiziert",
    "premium": "Premium Partner",
    "premiumPartner": "Premium Partner",
    "deleteConfirm": "Möchtest du den Eintrag \"{name}\" wirklich löschen?",
    "import": "Aus Katalog importieren",
    "importConfirm": "Der Material-Katalog wird importiert bzw. aktualisiert. Fortfahren?",
    "importSuccess": "{total} Materialien importiert.",
    "classify": "Klassifizierung starten",
    "classifyConfirm": "Die Fachtypen aller Materialien werden anhand des Katalogs neu zugeordnet. Fortfahren?",
    "classifySuccess": "{total} Materialien klassifiziert.",
    "onlyWithoutTypes": "Nur ohne Fachtypen",
    "selectedCount": "{count} Material ausgewählt | {count} Materialien ausgewählt"
  },
  "languages": {
    "columns": {
      "code": "Code",
      "isActive": "Aktiv",
      "isUserSelectable": "Von Benutzern wählbar",
      "name": "Name",
      "uiTranslations": "UI-Übersetzungen"
    },
    "create": "Sprache hinzufügen",
    "deleteConfirm": {
      "description": "Soll die Sprache \"{language}\" wirklich gelöscht werden? Sprachen, die bereits verwendet werden, können nur deaktiviert werden.",
      "title": "Sprache löschen"
    },
    "dialog": {
      "codeError": "Der Code muss ein Basis-Sprachcode aus 2-3 Kleinbuchstaben sein (z. B. \"de\").",
      "codePlaceholder": "fr",
      "createTitle": "Sprache hinzufügen",
      "editTitle": "Sprache bearbeiten",
      "namePlaceholder": "Français",
      "userSelectableHint": "Von Benutzern wählbare Sprachen erscheinen in der Sprachauswahl. Fehlen UI-Übersetzungen, werden Texte in der Standardsprache angezeigt."
    },
    "title": "Sprachen"
  },
  "legalNotice": {
    "title": "Impressum"
  },
  "loginProvider": {
    "apple": "Apple",
    "bildungsportal": "Bildungsportal",
    "google": "Google",
    "local": "E-Mail"
  },
  "mobileBlocker": {
    "ctaButton": "Trotzdem weiter im Browser",
    "description": "Digidoo funktioniert bereits im Browser.<br>Für die beste Übersicht und Nutzung empfehlen wir Laptop oder Tablet.<br>Die mobile Version wird aktuell optimiert.",
    "title": "Am besten auf Laptop oder Tablet starten."
  },
  "multiCompetenceObservation": {
    "applyAll": "Für alle übernehmen",
    "applyAllDescriotionsSuccess": "Notiz für {count} {entity} übernommen",
    "applyCompetenceObservationToAll": "Bewertung für alle übernehmen",
    "toggleObservationTypeByCompetence": "Nach Kompetenz",
    "toggleObservationTypeByStudent": "Nach Schüler:innen"
  },
  "myAccount": {
    "backToOrganisation": "Zurück zu {organisation}",
    "deactivateAccount": {
      "accountConfirm": {
        "confirm": "Account löschen",
        "description": "Bitte gib deinen Vor- und Nachnamen ein, um deinen Account dauerhaft zu löschen.",
        "hint": "Das Löschen deines Accounts lässt sich nicht rückgängig machen. Alle Inhalte werden nach 14 Tagen dauerhaft gelöscht.",
        "namePlaceholder": "Vor- und Nachname",
        "title": "Account löschen"
      },
      "button": "Account löschen",
      "feedback": {
        "description": "Es tut uns leid, dass Digidoo dich noch nicht überzeugt. Was können wir verbessern?",
        "error": "Dein Feedback konnte nicht gesendet werden. Bitte versuche es erneut oder fahre ohne Feedback fort.",
        "placeholder": "Du hast Feedback?",
        "sending": "Wird gesendet …",
        "skip": "Ohne Feedback fortfahren",
        "title": "Schade, dass du gehst."
      },
      "ownerWarning": {
        "deleteSchool": "Schule löschen | Schulen löschen",
        "description": "Du hast die Leitung der {schools}, deshalb kannst du deinen Account nicht löschen. Du kannst die Leitung auf ein anderes Mitglied übertragen oder die Schule löschen. | Du hast die Leitung der {schools}, deshalb kannst du deinen Account nicht löschen. Du kannst die Leitung auf andere Mitglieder übertragen oder die Schulen löschen.",
        "subscriptionInfo": "Wenn du deine Schule löschst, werden alle aktiven Abos automatisch gekündigt. | Wenn du deine Schulen löschst, werden alle aktiven Abos automatisch gekündigt.",
        "title": "Account löschen",
        "transferLeadership": "Leitung übertragen"
      },
      "schoolDeleteConfirm": {
        "confirm": "Schule löschen | Schulen löschen",
        "description": "Bitte gib deinen Vor- und Nachnamen ein, um die Schule {schools} dauerhaft zu löschen. | Bitte gib deinen Vor- und Nachnamen ein, um die Schulen {schools} dauerhaft zu löschen.",
        "hint": "Das Löschen einer Schule lässt sich nicht rückgängig machen. Alle Inhalte werden nach 14 Tagen dauerhaft gelöscht. Lade vorher herunter, was du behalten willst – zum Beispiel Berichte.",
        "namePlaceholder": "Vor- und Nachname",
        "success": "Schule erfolgreich gelöscht | Schulen erfolgreich gelöscht",
        "title": "Schule löschen | Schulen löschen"
      }
    },
    "disabledSSOInfo": "Nutzer, die SSO über Google etc. verwenden, können E-Mail und Passwort nicht ändern. Wende dich bitte an den Support, falls das notwendig ist.",
    "form": {
      "changeEmail": "Email ändern",
      "changeEmailHint": "Nach dem Betätigen des Buttons \"Fertig\" erhältst du eine E-Mail zur Bestätigung deiner neuen E-Mail-Adresse.",
      "changeEmailSuccess": "Die Email wurde erfolgreich geändert.",
      "changeEmailSuccessInquiry": "Zur Bestätigung deiner neuen E-Mail-Adresse haben wir dir eine Email zugesandt. Bitte überprüfe dein Postfach.",
      "changePassword": "Passwort ändern",
      "changePasswordSuccess": "Passwort erfolgreich geändert.",
      "currentPassword": "Aktuelles Passwort",
      "deactivateAccount": "Account deaktivieren",
      "newMail": "Neue Email"
    },
    "introduction": "Hallo {firstName},",
    "introductionSubline": "Hier kannst du deinen Digidoo-Account verwalten.",
    "rate": "Bewerten",
    "recommend": "Empfehlen",
    "sections": {
      "display": {
        "description": "Diese Einstellung gilt für die Anzeige von Namen in Listen, Klassen und Berichten.",
        "nameOrderQuestion": "Wie willst du Namen in Digidoo sehen?",
        "sortedBy": "Sortiert nach",
        "title": "Darstellung",
        "updated": "Darstellung aktualisiert",
        "weekRepresentation": {
          "calendarWeek": "Kalenderwochen (z. B. KW39)",
          "description": "Gilt für den Verlauf und alle Wochenansichten in Digidoo. Schulwochen zählen ab dem ersten Schultag deines Schuljahres.",
          "question": "Wochen anzeigen als",
          "schoolWeek": "Schulwochen (z. B. SW1)"
        }
      },
      "emailAndPassword": "E-Mail & Passwort",
      "emailsAndNotifications": {
        "newsletter": "Newsletter",
        "technicalOnly": "Technisch notwendige Benachrichtigungen",
        "title": "Emails & Benachrichtigungen",
        "updatedSetting": "Benachrichtigungseinstellungen aktualisiert",
        "weeklyReport": "Wochenbericht"
      },
      "language": {
        "description": "Gilt für die App, E-Mail und die gesamte Kommunikation. Kompetenzen sind davon ausgenommen.",
        "label": "Anzeigesprache",
        "title": "Sprache",
        "updated": "Sprache aktualisiert"
      },
      "subscription": {
        "description": {
          "member": "Du bist <span class='font-semibold'>{role}</span> der Schule {schoolName}. Das Abo wird von deiner Schule verwaltet. Dir entstehen keine Kosten.",
          "owner": {
            "active": "Klicke auf Abo verwalten, um dein Abo einzusehen oder abzuändern.",
            "subscriptionEnded": "Dein Abo ist abgelaufen. Klicke auf Abo verwalten, um dein Abo wieder zu aktivieren.",
            "subscriptionEnding": "Dein Abo endet in {days} Tagen. Klicke auf Abo verwalten, um dein Abo einzusehen oder zu verlängern.",
            "trialEnded": "Du kannst Digidoo <span class='font-semibold text-success'>weiterhin kostenlos verwenden</span>, um Kompetenzen zu dokumentieren. Alles, was dir Arbeit abnimmt - wie Berichte, Auswertungen und strukturierte Übergaben - ist Teil des Upgrades.",
            "trialing": "Deine {trialDays}-Tage-Testphase endet in {days} Tagen. Danach kannst du Digidoo weiterhin mit dem kostenlosen Basiszugang nutzen. Für den vollen Zugriff auf alle Digidoo-Funktionen benötigst du ein aktives Abo.",
            "youAre": "Du bist die <span class='font-semibold'>{role}</span> der Schule {schoolName}."
          }
        },
        "discountCodeFaq": "Wie löse ich meinen Rabattcode ein?",
        "manage": "Abo verwalten",
        "title": "Abo Status {schoolName}"
      },
      "twoFactorAuth": {
        "description": "Mit der Zwei-Faktor-Authentifizierung (2FA) sicherst du dein Digidoo-Konto noch besser ab – entweder via App oder E-Mail. <span class='font-semibold'>So bleibt dein Konto optimal geschützt.<span>",
        "disableTooltipText": "Du kannst 2FA nicht mehr deaktiveren, da du Mitglied in einer Schule bist, in der 2FA verpflichtend ist.",
        "title": "Zwei-Faktor-Authentifizierung"
      }
    },
    "socialMedia": {
      "facebook": "Folge uns auf Facebook",
      "instagram": "Folge uns auf Instagram",
      "whatsapp": "WhatsApp-Community beitreten"
    },
    "title": "Mein Account",
    "toOnboarding": "Schule einrichten"
  },
  "navigation": {
    "class": {
      "class": "Klasse",
      "reports": "Berichte",
      "settings": "Einstellungen",
      "statistics": "Analyse"
    },
    "provider": {
      "apiTokens": "API Tokens",
      "competenceAssessments": "Kompetenzbewertung",
      "competenceTemplates": "Vorlagen",
      "dashboard": "Dashboard",
      "feedback": "Feedback",
      "gradeScales": "Noten",
      "importCompetenceTemplates": "Importieren",
      "jobs": "Queue",
      "languages": "Sprachen",
      "onboardingCheckout": "Onboarding-Käufe",
      "releases": "Releases",
      "schoolYears": "Schuljahre",
      "schools": "Schulen",
      "sso": "SSO",
      "tenants": "Tenants",
      "users": "Benutzer",
      "masterData": "Stammdaten",
      "system": "System",
      "home": "Home",
      "statistics": "Statistik",
      "monitoring": "Monitoring",
      "cron": "Cronjobs"
    }
  },
  "note": {
    "addAnnotationsPlaceholder": "Klicke hier, um Anmerkungen hinzuzufügen …",
    "addNotesPlaceholder": "Klicke hier, um Notizen hinzuzufügen…",
    "delete": "Notiz löschen",
    "deleteConfirm": {
      "confirmButtonLabel": "Löschen",
      "declineButtonLabel": "Abbrechen",
      "description": "Die Notiz wird dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.",
      "title": "Notiz löschen?"
    },
    "edit": "Notiz bearbeiten",
    "linkCompetence": "Kompetenz verknüpfen",
    "notes": "Notizen",
    "title": "Notiz"
  },
  "notification": {
    "cannotOpen": "Diese Benachrichtigung konnte nicht geöffnet werden.",
    "noNotifications": "Keine neuen Benachrichtigungen",
    "title": "Benachrichtigungen"
  },
  "onboarding": {
    "acquisitionSource": {
      "options": {
        "colleagueReferral": "Empfehlung von Kolleg:innen",
        "eventTraining": "Veranstaltung / Fortbildung",
        "googleSearch": "Google / Suche",
        "other": "Sonstiges",
        "schoolAdmin": "Schule / Direktion",
        "socialMedia": "Social Media"
      },
      "title": "Wie hast du von Digidoo erfahren?"
    },
    "checkout": {
      "billedPerStudents": "Abrechnung nach Schüler:innen",
      "billedPerTeachers": "Abrechnung nach Lehrpersonen",
      "buyNow": "Jetzt kaufen",
      "contactSupport": "Support kontaktieren",
      "finalizing": "Deine Schule wird eingerichtet …",
      "orPayWithCard": "oder mit Karte",
      "payment": {
        "failed": "Die Zahlung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
        "processing": "Deine Zahlung wird verarbeitet – einen Moment bitte …",
        "sessionFailed": "Der Kauf konnte nicht gestartet werden. Bitte versuche es erneut.",
        "unavailable": "Die Bezahlung ist derzeit nicht verfügbar. Bitte versuche es später erneut."
      },
      "perStudentPerYear": "pro Schüler:in und Jahr",
      "perTeacherPerMonth": "pro Lehrperson und Monat",
      "priceChanged": "Der Preis hat sich aktualisiert. Bitte prüfe die Bestellübersicht und klicke erneut auf „Jetzt kaufen“.",
      "priceFrom": "ab {price}",
      "promotionChip": "🍁 Herbst-Aktion",
      "provisioningFailed": "Deine Zahlung war erfolgreich, aber die Einrichtung deiner Schule dauert gerade länger. Wir kümmern uns automatisch darum – bitte kontaktiere den Support, falls das Problem bestehen bleibt.",
      "studentQuantityLabel": "Anzahl Schüler:innen",
      "summary": {
        "expressDiscount": "Express-Rabatt",
        "studentsLine": "Schüler:innen",
        "teachersLine": "Lehrpersonen",
        "teachersLineUnitPrice": "zu je {unitPrice}",
        "tierFrom": "ab {from} Schüler:innen",
        "tierPrices": "Staffelpreise",
        "total": "Gesamt",
        "unlimitedStudents": "Unbegrenzte Schüler:innen",
        "unlimitedTeachers": "Unbegrenzte Lehrpersonen",
        "vat": "{percent}% MwSt"
      },
      "supportMail": {
        "body": "Hallo Digidoo-Team,\n\nmeine Zahlung war erfolgreich, aber meine Schule wurde noch nicht eingerichtet.\n\nCheckout-Referenz: {draftId}\n\nViele Grüße",
        "subject": "Problem beim Kaufabschluss – Schule wurde nicht eingerichtet"
      },
      "teacherQuantityLabel": "Anzahl Lehrpersonen",
      "title": "Sichere dir jetzt {discount}\nauf dein erstes Jahr!",
      "titleDiscount": "{percent} % Rabatt",
      "trialButton": "Kostenlos testen",
      "trialLink": "oder kostenlos testen"
    },
    "class": {
      "hasNickname": "Hat deine Klasse eine Spitznamen?",
      "name": "Name",
      "schoolLevel": "Schulstufe",
      "title": "Hallo {firstName}, lass uns deine Klasse gemeinsam einrichten."
    },
    "createSchool": {
      "description": "Mit ein paar Angaben können wir Digidoo passend für dich vorbereiten.",
      "title": "Richte Digidoo für deinen Unterricht ein."
    },
    "finalize": {
      "helpText": "Wir wünschen dir viel Freude mit Digidoo, und bitte lass uns jederzeit wissen wie wir Digidoo weiter für dich verbessern können.",
      "letsGo": "Los geht's!",
      "titleAdmin": "Super, du bist nun bereit loszulegen.\nWir wünschen dir viel Freude mit Digidoo",
      "titleClassic": "Super, du bist nun bereit loszulegen.",
      "titlePersonalClass": "Schön, dass du da bist {firstName}. Dir wurde bereits eine Klasse zugewiesen – los geht’s!",
      "titlePersonalDemoOnlyClass": "Schön, dass du da bist {firstName}. Du hast noch keine reguläre Klasse, kannst Digidoo aber schon in der Demoklasse ausprobieren.",
      "titlePersonalNoClass": "Schön, dass du da bist {firstName}. Dir wurde noch keine Klasse zugewiesen. Wir informieren dich, sobald du loslegen kannst.",
      "titlePersonalPrimary": "Schön, dass du da bist {firstName} 😊",
      "titlePersonalSecondaryAdmin": "Als Administrator:in hast du Zugriff auf alle Klassen in der Schule und kannst Einstellungen ändern.",
      "titlePersonalSecondaryClass": "Dir wurde bereits eine Klasse zugewiesen – los geht’s!",
      "titlePersonalSecondaryDemoOnlyClass": "Du hast noch keine reguläre Klasse, kannst Digidoo aber schon in der Demoklasse ausprobieren.",
      "titlePersonalSecondaryGroup": "Dir wurde bereits eine Gruppe zugewiesen – los geht’s!",
      "titlePersonalSecondaryNoClass": "Dir wurde noch keine Klasse zugewiesen. Wir informieren dich, sobald du loslegen kannst."
    },
    "finalizeBilling": {
      "titlePrimary": "Schön, dass du da bist, {firstName} 😊",
      "titleSecondary": "Ob allein oder im Team, Digidoo begleitet Lernentwicklung langfristig, macht Stärken und Fortschritte sichtbar und erstellt Berichte auf Knopfdruck.",
      "trialHint": "Alle Funktionen testen – danach kostenlos weiter nutzen."
    },
    "success": {
      "body": "Ob allein oder im Team – Digidoo macht Lernfortschritte sichtbar und erstellt Berichte auf Knopfdruck.",
      "continue": "Los geht’s",
      "purchase": {
        "titlePrimary": "Juhu, du bist startklar!",
        "titleSecondary": "Dein {planTitle} Abo ist aktiv. Los geht’s 🎉",
        "titleSecondaryNoPlan": "Dein Abo ist aktiv. Los geht’s 🎉"
      },
      "trial": {
        "buyNow": "Oder doch gleich kaufen?",
        "buyNowPromotion": "{percent}% Herbst-Rabatt sichern",
        "titlePrimary": "Juhu, du bist startklar!",
        "titleSecondary": "Digidoo ist jetzt vollständig für dich freigeschaltet. 🎉"
      }
    },
    "footer": {
      "logout": "Logout"
    },
    "joinSchool": {
      "hint": "Wie bekomme ich meinen Zugangscode?",
      "subtitle": "Um einer bestehenden Schule beizutreten, klicke auf deinen Einladungslink oder gib deinen einmaligen Zugangscode ein.",
      "title": "Bestehender Schule beitreten."
    },
    "profile": {
      "title": "Lass uns erstmals kennenlernen.",
      "whichSchool": "In welcher Schule unterrichtest du?",
      "whichSchoolPlaceholder": "VS Beispiel"
    },
    "school": {
      "canton": "Kanton",
      "country": "Land",
      "enterData": "Daten selbst eingeben",
      "nameLabel": "Suche deine Schule",
      "namePlaceholder": "Name der Schule, Schulkennzahl etc.",
      "noSchoolHintText": "z.B. für private Organistation, Privatlehrer:in, Eltern etc.",
      "noSchools": "Keine Schule zu \"{query}\" gefunden",
      "noSchoolsHelp": "Du findest deine Schule nicht?",
      "noSchoolsHelpContact": "Kontaktiere uns",
      "ownSchoolType": "Eigener Schultyp",
      "ownSchoolTypeLabel": "Eigener Schultyp",
      "proceedWithoutSchool": "Ohne Schulauswahl fortfahren",
      "schoolAlreadyInUseconfirmDialog": {
        "confirmButtonLabel": "Bestehender Schule beitreten",
        "declineButtonLabel": "Schule trotzdem erstellen",
        "description": "Die Schule “{schoolName}” ist bereits bei Digidoo aktiv. Bitte kontaktiere die Schulleitung, um dem Team beizutreten.",
        "title": "Schule existiert bereits"
      },
      "schoolHasNoSchoolType": "Für diesen Schultyp sind derzeit noch keine Kompetenzvorlagen hinterlegt. Du kannst aber jederzeit eigene Vorlagen erstellen und anpassen.",
      "schoolIsAlreadyUsed": "Diese Schule ist bereits bei Digidoo aktiv. Du kannst dennoch fortfahren und eine separate, eigenständige Schulinstanz anlegen.",
      "schoolType": "Schultyp",
      "searchSchool": "Schule suchen",
      "slogan": "Schulmotto",
      "sloganPlaceholder": "Die gesunde Volksschule",
      "state": "Bundesland"
    },
    "schoolLevels": {
      "edit": "Schulstufen bearbeiten",
      "editConfirmDescription": "Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um die Schulstufen zu bearbeiten.",
      "editConfirmHint": "Die entfernten Schulstufen werden auch aus den Kompetenzvorlagen deiner Schule entfernt. Bestehende Klassen sind davon nicht betroffen.",
      "editDescription": "Welche Schulstufen umfasst deine Schule?",
      "primary": "Primarstufe",
      "secondary": "Sekundarstufe",
      "title": "Bitte wähle nun die Schulstufen für deine “{schoolTypeName}”."
    },
    "schoolSubject": {
      "helpText": "Du kannst alle Kompetenzen später anpassen und neue hinzufügen.",
      "importOwnCompetences": "Eigene Kompetenzen importieren",
      "title": "Super, wir haben für dich schon mal alle Kompetenzen für die {schoolLevel}. Schulstufe vorbereitet."
    },
    "selection": {
      "title": "Hallo {firstName},\nwie möchtest du Digidoo nutzen?"
    },
    "students": {
      "addStudent": "Weitere Schüler:in hinzufügen",
      "addStudentOptional": "Oder neue Schüler:innen eingeben",
      "helpText": "Du kannst die Schülerinnen und Schüler auch später noch anpassen.",
      "title": "Magst du gleich die Liste deiner Schülerinnen und Schüler eingeben?",
      "validationError": "Jede Schüler:in muss einen Vornamen und einen Nachnamen haben."
    },
    "team": {
      "helpText": "Du kannst mehrere Personen gleichzeitig einladen. Gib dazu einfach mehrere E-Mail-Adressen, jeweils getrennt durch ein Komma, ein.",
      "mailsPlaceholder": "vorname.nachname{'@'}schule.at",
      "messagePlaceholder": "Optionale Nachricht",
      "title": "Lade nun dein Team über E-Mail ein."
    },
    "waitingApproval": {
      "approvalHint": "Wir melden uns in Kürze per E-Mail, sobald deine Schule freigeschaltet ist.",
      "subline": "Bei Digidoo wird jede Schule individuell aufgenommen – dafür brauchen wir kurz Zeit.",
      "title": "Hallo {firstName},",
      "videoButton": "Intro Video ansehen",
      "videoHint": "Währenddessen kannst du schon in unserem Intro-Video entdecken, was dich erwartet."
    }
  },
  "onboardingCheckoutCases": {
    "columns": {
      "buyer": "Käufer:in",
      "lastError": "Letzter Fehler",
      "plan": "Plan",
      "school": "Schule",
      "status": "Status",
      "updatedAt": "Zuletzt aktualisiert"
    },
    "discard": "Verwerfen",
    "discardConfirm": {
      "description": "Möchtest du den Checkout-Entwurf für „{school}“ wirklich verwerfen? Eine noch nicht bezahlte Zahlung wird abgebrochen.",
      "title": "Checkout-Entwurf verwerfen?"
    },
    "openStripeCustomer": "Stripe-Kunde öffnen",
    "openStripeSubscription": "Stripe-Abo öffnen",
    "openTenant": "Schule öffnen",
    "provision": "Jetzt einrichten",
    "status": {
      "pendingPayment": "Warte auf Zahlung",
      "provisioned": "Bezahlt & angelegt",
      "provisioningFailed": "Anlegen fehlgeschlagen"
    },
    "statusFilterAll": "Alle Status",
    "title": "Onboarding-Käufe"
  },
  "pdfPrint": {
    "competence": "Kompetenz",
    "page": "Seite {page}",
    "pageOf": "{current} von {total}",
    "studentName": "Name des Kindes"
  },
  "performanceAssessment": {
    "addNotes": "Anmerkung hinzufügen",
    "addSubjectSpecific": "Fachspezifische Leistungsfeststellungen hinzufügen",
    "changeSymbol": "Symbol für {name} ändern",
    "confirm": "Für diese Leistungsfeststellung wurden bereits Einträge erstellt. Bist du sicher, dass du diese Leistungsfeststellung bearbeiten möchtest?",
    "copyTo": "Kopieren nach…",
    "count": "Leistungsfeststellung {count}",
    "countAlt": "{count} Leistungsfeststellung | {count} Leistungsfeststellungen",
    "create": "Neue Leistungsfeststellung",
    "createOwn": "Eigene Leistungsfeststellung",
    "edit": "Leistungsfeststellung bearbeiten",
    "editList": "Liste bearbeiten",
    "editPlural": "Leistungsfeststellungen bearbeiten",
    "emptyStateDescription": "Erstelle jetzt die erste Leistungsfeststellung.",
    "emptyStateTitle": "Noch keine Leistungsfeststellungen",
    "hasObservationWarning": "Diese Leistungsfeststellung wurde bereits verwendet. Änderungen sind deshalb nur noch eingeschränkt möglich.",
    "helpText": "Du kannst die Leistungsfeststellungen auch später noch anpassen.",
    "hint": "Hier legst du fest, wie die Leistungen in den einzelnen Schulstufen und Semestern dokumentiert werden sollen. Für die Kompetenzerfassung steht dir bereits eine Vorlage zur Verfügung.",
    "noPAsYetForSubject": "Du hast für dieses Fach noch keine Leistungsfeststellungen erstellt.",
    "noWeighting": "Keine Gewichtung",
    "noWeightingLabel": "Keine",
    "remove": "Leistungsfeststellung löschen",
    "removeConfirmText": "Bist du sicher, dass du die Leistungsfeststellung \"{name}\" löschen möchtest?",
    "removeSubjectSpecific": "Fachspezifische Leistungsfeststellungen entfernen",
    "removeSubjectSpecificDescription": "Die {count} verknüpften Einträge dieser Leistungsfeststellung werden gelöscht. Das lässt sich nicht rückgängig machen. Danach werden wieder die Leistungsfeststellungen aller Fächer verwendet.",
    "removeSubjectSpecificDescriptionEmpty": "Die fachspezifischen Leistungsfeststellungen werden gelöscht. Das lässt sich nicht rückgängig machen. Danach werden wieder die Leistungsfeststellungen aller Fächer verwendet.",
    "removeSubjectSpecificDescriptionOneEntry": "Der verknüpfte Eintrag dieser Leistungsfeststellung wird gelöscht. Das lässt sich nicht rückgängig machen. Danach werden wieder die Leistungsfeststellungen aller Fächer verwendet.",
    "removeSubjectSpecificNamePlaceholder": "Gib deinen Namen als Bestätigung ein",
    "removeSubjectSpecificTitle": "Eigene Leistungsfeststellungen für {subject} entfernen?",
    "removeTitle": "{name} entfernen?",
    "removeWithEntriesConfirmText": "Alle {count} mit dieser Leistungsfeststellung verknüpften Einträge werden gelöscht. Das lässt sich nicht rückgängig machen.",
    "removeWithEntriesNamePlaceholder": "Gib deinen Namen als Bestätigung ein",
    "removeWithOneEntryConfirmText": "Der mit dieser Leistungsfeststellung verknüpfte Eintrag wird gelöscht. Das lässt sich nicht rückgängig machen.",
    "schoolTemplate": "Schulvorlage",
    "subjectSearchPlaceholder": "Fach suchen…",
    "subjectSpecificSetupCopyAction": "Erstellen",
    "subjectSpecificSetupCopyDescription": "Die allgemeinen Leistungsfeststellungen werden mit {count} verknüpften Einträgen für {subject} übernommen. Danach werden sie eigenständig verwaltet und können nicht wieder zusammengeführt werden.",
    "subjectSpecificSetupCopyDescriptionOneEntry": "Die allgemeinen Leistungsfeststellungen werden mit einem verknüpften Eintrag für {subject} übernommen. Danach werden sie eigenständig verwaltet und können nicht wieder zusammengeführt werden.",
    "subjectSpecificSetupCopySuccess": "Die Leistungsfeststellungen für {subject} wurden übernommen.",
    "subjectSpecificSetupCopyTitle": "Leistungsfeststellungen für {subject} erstellen?",
    "template": "Vorlage",
    "templates": "Vorlagen",
    "tipTeacher": "Hier siehst du, welche Art der Leistungsdokumentation in deiner Klasse <b>{currentClass}</b> verwendet wird. Je nach Berechtigung kannst du diese bearbeiten oder neue Dokumentationsarten hinzufügen.",
    "title": "Leistungsfeststellungen",
    "weighting": "Gewichtung"
  },
  "performanceAssessmentEntry": {
    "addNotes": "Anmerkung hinzufügen",
    "applyObservationToAll": "Für alle übernehmen",
    "collectiveAssessment": {
      "apply": "Für alle übernehmen",
      "button": "Sammelbewertung",
      "competenceLabel": "Kompetenz",
      "hint": "Tippe auf eine Kachel und die Bewertung wird für alle Schülerinnen und Schüler übernommen.",
      "ratingLabel": "Bewertung",
      "targetCompetences": "Kompetenzen",
      "targetLabel": "Bewertungstyp",
      "targetPerformanceAssessment": "Leistungsfeststellung",
      "title": "Sammelbewertung",
      "unknownCompetence": "Kompetenz #{id}"
    },
    "competencesDescription": "Willst du zu dieser Leistungsfeststellung auch Kompetenzen hinzufügen?",
    "competencesHelpText": "Du kannst die Leistungsfeststellung auch ohne Kompetenzen erstellen.",
    "confirmBulkDescriptionDialog": {
      "fullyDescribed": {
        "confirm": "Alle überschreiben",
        "description": "Bei allen ausgewählten Schüler:innen liegen schon Beobachtungen vor. Sollen diese überschrieben werden?"
      },
      "partiallyDescribed": {
        "confirm": "Alle überschreiben",
        "decline": "Fehlende ergänzen",
        "description": "Bei einigen Schüler:innen liegen schon Beobachtungen vor. Sollen diese überschrieben werden oder möchtest du nur fehlende ergänzen?"
      },
      "title": "Es gibt schon Beobachtungen"
    },
    "confirmBulkDialog": {
      "fullyObserved": {
        "confirm": "Alle überschreiben",
        "description": "Bei allen ausgewählten Schüler:innen liegen schon Bewertungen vor. Sollen diese überschrieben werden?"
      },
      "partiallyObserved": {
        "confirm": "Alle überschreiben",
        "decline": "Fehlende ergänzen",
        "description": "Bei einigen Schüler:innen liegen schon Bewertungen vor. Sollen diese überschrieben werden oder möchtest du nur fehlende ergänzen?"
      },
      "title": "Es gibt schon Bewertungen"
    },
    "confirmContinueWithoutCompetences": {
      "confirmButtonLabel": "Kompetenz wählen",
      "declineButtonLabel": "Nur Anmerkung anlegen",
      "description": "Für diesen Eintrag wurde keine Kompetenz ausgewählt. Der Eintrag wird daher nur als Anmerkung gespeichert.",
      "title": "Keine Kompetenz gewählt"
    },
    "confirmDuplicateGradings": {
      "confirmButtonLabel": "Bewertungen übernehmen",
      "declineButtonLabel": "Nicht übernehmen",
      "description": "Möchtest du die bisherigen Bewertungen und Anmerkungen für diesen Lernfortschritt mit übernehmen?",
      "title": "Bewertungen übernehmen"
    },
    "confirmDuplicateSingle": {
      "confirmButtonLabel": "Für alle duplizieren",
      "declineButtonLabel": "Nur für {studentName}",
      "description": "Dieser Eintrag enthält weitere Schüler:innen. Soll der Eintrag für alle dupliziert werden oder nur für {studentName}?",
      "title": "Eintrag duplizieren"
    },
    "description": "Anmerkung zur Leistungsfeststellung (optional)",
    "detailDialog": {
      "confirmDelete": {
        "description": "Die Leistungsfeststellung und alle zugehörigen Bewertungen und Beobachtungen werden dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.",
        "title": "Leistungsfeststellung löschen?"
      },
      "confirmRemoveCompetence": {
        "description": "Die Kompetenz wird aus dieser Leistungsfeststellung entfernt. Bereits erfasste Bewertungen für diese Kompetenz werden dabei unwiderruflich gelöscht.",
        "title": "Kompetenz entfernen?"
      },
      "confirmRemoveStudents": {
        "description": "Die abgewählten Schüler:innen werden aus dieser Leistungsfeststellung entfernt. Ihre bereits erfassten Bewertungen und Beobachtungen werden dabei unwiderruflich gelöscht.",
        "title": "Schüler:innen entfernen?"
      },
      "linkedCompetences": "Verknüpfte Kompetenzen",
      "nextStudent": "Nächste:r Schüler:in",
      "noteAvailable": "Beobachtung vorhanden",
      "openStudentList": "Schüler:innenliste öffnen",
      "previousStudent": "Vorherige:r Schüler:in"
    },
    "documentation": "Dokumentation",
    "editCompetenceGrid": "Kompetenzraster bearbeiten",
    "editEntry": "Leistungsfeststellung bearbeiten",
    "emptyStateDescription": "Erstelle jetzt einen Eintrag.",
    "filteredEmptyStateDescription": "Für die aktuelle Suche wurden keine Einträge gefunden.",
    "filteredEmptyStateTitle": "Keine passenden Einträge",
    "linkedCompetences": "Zugeordnete Kompetenzen",
    "metaData": "Bitte wähle Fach und Art der Leistungsfeststellung.",
    "newEntry": "Neuer Lernfortschritt",
    "noLinkedCompetences": "Keine zugeordneten Kompetenzen",
    "noStudentsAddCta": "Schüler:innen hinzufügen",
    "noStudentsEmptyStateTitle": "Noch keine Schüler:innen in dieser Klasse",
    "noStudentsRequestCta": "Schüler:innen anfragen",
    "noStudentsRequestMailBody": "Hallo {firstNameReceiver},\n\nich möchte Lernfortschritte für die Klasse \"{className}\" erstellen, aber in dieser Klasse sind noch keine Schüler:innen verknüpft und ich habe dafür keine Berechtigung.\n\nBitte lege Schüler:innen an oder verknüpfe bestehende Schüler:innen mit dieser Klasse, damit ich starten kann:\n{classStudentsLink}\n\nVielen Dank!",
    "noStudentsRequestMailSubject": "Bitte Schüler:innen für die Klasse \"{className}\" hinzufügen",
    "noSubjectsYet": "Du hast noch keine Fächer angelegt. Lege zuerst ein Fach im Kompetenzraster an, um Lernfortschritte zu erstellen.",
    "notes": "Anmerkung zur Leistungsfeststellung",
    "open": "Offen",
    "pdf": {
      "confirmButton": "Herunterladen",
      "confirmDescription": "Möchtest du diesen Lernfortschritt wirklich herunterladen?",
      "confirmTitle": "Lernfortschritt herunterladen",
      "generationFailed": "PDF-Erstellung fehlgeschlagen. Bitte versuche es erneut."
    },
    "performanceAssessmentType": "Typ",
    "ratingLabel": "Bewertung",
    "students": "{count} Schüler:in | {count} Schüler:innen",
    "studentsDescription": "Wähle die Schülerinnen und Schüler für die Leistungsfeststellung aus.",
    "studentsHelpText": "Du kannst Schülerinnen und Schüler auch später noch hinzufügen.",
    "subject": "Fach",
    "timelineSetup": {
      "noStudentSubjectsCreateCta": "Fächer verknüpfen",
      "noStudentSubjectsMessage": "Diese:r Schüler:in braucht ein Fach. Verknüpfe zuerst ein Fach.",
      "noStudentSubjectsRequestCta": "Fächer anfragen",
      "noStudentSubjectsRequestMailBody": "Hallo {firstNameReceiver},\n\nich möchte Lernfortschritte für {studentName} in der Klasse \"{className}\" erstellen, aber für diese:n Schüler:in sind noch keine Fächer verknüpft und ich habe dafür keine Berechtigung.\n\nBitte verknüpfe Fächer für diese:n Schüler:in, damit ich starten kann:\n{classSetupLink}\n\nVielen Dank!",
      "noStudentSubjectsRequestMailSubject": "Bitte Fächer für {studentName} in der Klasse \"{className}\" verknüpfen",
      "noStudentSubjectsTitle": "Noch keine Fächer verknüpft",
      "noStudentsCreateCta": "Schüler:innen hinzufügen",
      "noStudentsMessage": "Lernfortschritte brauchen Schüler:innen. Füge sie zuerst hinzu oder verknüpfe bestehende mit dieser Klasse.",
      "noStudentsRequestCta": "Schüler:innen anfragen",
      "noStudentsRequestMailBody": "Hallo {firstNameReceiver},\n\nich möchte Lernfortschritte für die Klasse \"{className}\" erstellen, aber in dieser Klasse sind noch keine Schüler:innen verknüpft und ich habe dafür keine Berechtigung.\n\nBitte lege Schüler:innen an oder verknüpfe bestehende Schüler:innen mit dieser Klasse, damit ich starten kann:\n{classSetupLink}\n\nVielen Dank!",
      "noStudentsRequestMailSubject": "Bitte Schüler:innen für die Klasse \"{className}\" hinzufügen",
      "noStudentsTitle": "Noch keine Schüler:innen vorhanden",
      "noSubjectsCreateCta": "Fächer anlegen",
      "noSubjectsMessage": "Jeder Lernfortschritt braucht ein Fach. Lege zuerst Fächer für diese Klasse an.",
      "noSubjectsRequestCta": "Fächer anfragen",
      "noSubjectsRequestMailBody": "Hallo {firstNameReceiver},\n\nich möchte Lernfortschritte für die Klasse \"{className}\" erstellen, aber in dieser Klasse sind noch keine Fächer angelegt und ich habe dafür keine Berechtigung.\n\nBitte lege Fächer für diese Klasse an, damit ich starten kann:\n{classSetupLink}\n\nVielen Dank!",
      "noSubjectsRequestMailSubject": "Bitte Fächer für die Klasse \"{className}\" hinzufügen",
      "noSubjectsTitle": "Noch keine Fächer vorhanden"
    },
    "unratedLabel": "Noch nicht bewertet"
  },
  "performanceAssessmentStudentEntry": "Leistungseintrag für Schüler",
  "performanceVisual": {
    "assessmentSteps": "Bewertungsstufen",
    "bad": "schlecht",
    "blockedByAccessRights": "Du kannst die Visualisierung nicht ändern, da du keine Berechtigung für diese Aktion hast.",
    "blockedByClassArchived": "Du kannst die Visualisierung nicht ändern, da die Klasse archiviert ist.",
    "blockedByEntries": "Du kannst die Visualisierung nicht ändern, da bereits Einträge getätigt wurden.",
    "create": "Neue Visualisierung",
    "createOwn": "Eigene Visualisierung",
    "edit": "Visualisierung bearbeiten",
    "good": "gut",
    "isLinkedToPerformanceAssessmentWarning": "Diese Visualisierung ist mit einer Leistungsfeststellung verknüpft. Änderungen sind deshalb nur noch eingeschränkt möglich.",
    "nonOfficial": "Eigene",
    "official": "Digidoo Vorlagen",
    "steps": "{ name } ({ count } Stufe) | { name } ({ count } Stufen)",
    "stepsAlt": "{ count } Stufe | { count } Stufen",
    "tipAdmin": "Hier kannst du eigene Visualisierungen deiner <b>{school}</b> hochladen und erhältst zusätzlich eine Auswahl gängiger Vorlagen zur direkten Nutzung.",
    "tipTeacher": "Hier siehst du die Visualisierungen, die für die Leistungsdokumentation in deiner Klasse <b>{currentClass}</b> verwendet werden. Je nach Berechtigung kannst du weitere Visualisierungen hinzufügen.",
    "visual": "Visualisierung"
  },
  "privacy": {
    "title": "Datenschutz"
  },
  "providerDashboard": {
    "acquisitionSource": {
      "colleagueReferral": "Empfehlung",
      "eventTraining": "Veranstaltung",
      "googleSearch": "Google / Suche",
      "other": "Sonstiges",
      "schoolAdmin": "Schule / Direktion",
      "socialMedia": "Social Media",
      "title": "Akquisitionsquellen"
    },
    "competenceTemplates": {
      "title": "Kompetenzvorlagen"
    },
    "entryActivity": {
      "observations": "Kompetenzbeobachtungen",
      "performanceEntries": "Leistungseinträge",
      "resolution": {
        "day": "Tag",
        "month": "Monat",
        "week": "Woche"
      },
      "resolutionPicker": "Auflösung auswählen",
      "title": "Eintragsaktivität",
      "totalEntries": "{formattedCount} Eintrag | {formattedCount} Einträge"
    },
    "filter": {
      "admin": "Admin",
      "allCountries": "Alle Länder",
      "allRoles": "Alle Rollen",
      "days": "{count} Tage",
      "owner": "Inhaber",
      "user": "Nutzer"
    },
    "interval": "Intervall: ",
    "kpi": {
      "classesAndGroups": "Klassen / Gruppen",
      "observations": "Kompetenzbeobachtungen",
      "performanceAssessments": "Leistungsfeststellungen",
      "reports": "Berichte",
      "students": "Schüler",
      "tenants": "Schulen",
      "twoFactor": "2FA aktiv",
      "users": "Nutzer"
    },
    "loginProviderDistribution": {
      "title": "Verteilung der Login-Anbieter"
    },
    "menuTitle": "Dashboard",
    "newUsers": {
      "resolutionPicker": "Auflösung auswählen",
      "title": "Neue Nutzer",
      "totalUsers": "{formattedCount} Nutzer"
    },
    "onboardingFunnel": {
      "account_created": "Konto erstellt",
      "administration_setup_done": "Administration abgeschlossen",
      "class_created": "Klasse erstellt",
      "email_verified": "E-Mail verifiziert",
      "first_entry_created": "Erster Eintrag",
      "fromPreviousStep": "vom Schritt davor",
      "license_purchased": "Abo gekauft",
      "mode": {
        "closed": "Geschlossen",
        "open": "Offen"
      },
      "modeInfo": "<b>Geschlossen:</b> Jeder Schritt setzt voraus, dass alle vorherigen Schritte abgeschlossen wurden. Die Zahlen sind kumulativ und nehmen ab.<br/><br/><b>Offen:</b> Jeder Schritt wird unabhängig gezählt, egal ob vorherige Schritte abgeschlossen wurden.",
      "modeLabel": "Modus",
      "modePicker": "Trichter-Modus",
      "school_created": "Schule erstellt",
      "title": "Onboarding-Trichter Inhaber"
    },
    "productStatus": {
      "activeProduct": "Aktives Abo",
      "downgraded": "Kostenlose Version",
      "expired": "Testphase beendet",
      "freeTrial": "Testphase",
      "noProduct": "Kein Abo",
      "title": "Abo-Status"
    },
    "productType": {
      "proUser": "One",
      "school": "Team",
      "team": "Flex",
      "title": "Produktverteilung"
    },
    "reportDistribution": {
      "competenceType": "Bericht: Kompetenztyp-Verteilung",
      "coverSheet": "Bericht: Deckblatt-Verteilung",
      "none": "Ohne",
      "summarySheet": "Bericht: Schlussblatt-Verteilung"
    },
    "roleDistribution": {
      "title": "Rollenverteilung"
    },
    "schoolTypeDistribution": {
      "selectCountry": "Wähle ein Land aus, um die Schultyp-Verteilung zu sehen.",
      "title": "Schultyp-Verteilung"
    },
    "starRating": {
      "averageRating": "Durchschnitt",
      "title": "Sternebewertungen"
    },
    "tenantLocationDistribution": {
      "cantons": "Kantonsverteilung",
      "countries": "Länderverteilung",
      "emptyDescription": "Für die gewählten Filter sind keine Schulen mit einer passenden Länder- oder Bundeslandzuordnung vorhanden.",
      "emptyTitle": "Keine Schulen vorhanden",
      "states": "Bundesländerverteilung"
    },
    "timelineActivity": {
      "notes": "Notizen",
      "performanceAssessmentEntries": "Leistungsfeststellungen",
      "resolutionPicker": "Auflösung auswählen",
      "supportMeasureEntries": "Fördermaßnahmen",
      "totalSupportMeasureEntries": "{formattedCount} Fördermaßnahme | {formattedCount} Fördermaßnahmen",
      "typeDistribution": "Timeline: Eintragstyp-Verteilung"
    },
    "trialExpiredFeedback": {
      "missingFeatures": "Fehlende Funktionen",
      "preferFreeVersion": "Bleibt lieber kostenlos",
      "subscriptionTooExpensive": "Zu teuer",
      "title": "Feedback: Testphase abgelaufen",
      "underUsed": "Zu wenig genutzt"
    },
    "usage": {
      "classesAndPerformance": "Klassen & Leistungen",
      "classesOnly": "Nur Klassen",
      "hasEntries": "Hat Einträge",
      "performanceOnly": "Nur Leistungen",
      "title": "Nutzung"
    },
    "userActivity": {
      "active": "Aktiv",
      "hasEntities": "Hat Einträge",
      "highlyActive": "Sehr aktiv",
      "inactive": "Inaktiv",
      "setupIncomplete": "Setup offen",
      "title": "Nutzeraktivität"
    }
  },
  "providerCron": {
    "title": "Cronjobs",
    "detail": {
      "title": "Cronjob-Details"
    },
    "refresh": "Aktualisieren",
    "filters": {
      "name": "Cronjob",
      "status": "Status",
      "allNames": "Alle Cronjobs",
      "allStatuses": "Alle Status"
    },
    "table": {
      "name": "Cronjob",
      "schedule": "Zeitplan",
      "lastStarted": "Letzter Start",
      "lastSucceeded": "Letzter Erfolg",
      "lastFailed": "Letzter Fehler",
      "error": "Fehlermeldung"
    },
    "status": {
      "ok": "OK",
      "failed": "Fehlgeschlagen",
      "running": "Läuft",
      "never-run": "Noch nie gelaufen"
    },
    "names": {
      "attribution-cleanup": "Herkunftsdaten bereinigen",
      "attribution-conversion-delivery": "Käufe an Werbeplattformen melden",
      "billing-sync": "Abrechnung synchronisieren",
      "billing-referral-reconciliation": "Empfehlungs-Abgleich",
      "billing-onboarding-draft-sweep": "Onboarding-Käufe – Aufräumen",
      "billing-trial-ending-mail": "Testphase endet – E-Mail",
      "billing-trial-ended-mail": "Testphase beendet – E-Mail",
      "billing-offer-expiry-reminder-mail": "Angebot läuft ab – E-Mail",
      "two-factor-reminder-mail": "2FA-Erinnerung – E-Mail",
      "onboarding-reminder-mail": "Onboarding-Erinnerung – E-Mail",
      "growth-trial-mails": "Growth-Testphasen-Mails",
      "weekly-report-emails": "Wochenbericht – E-Mails",
      "deactivated-account-cleanup": "Bereinigung deaktivierter Konten",
      "crm-contact-sync": "CRM-Kontakte synchronisieren",
      "session-cleanup": "Sitzungsbereinigung",
      "subject-classification": "Fach-Klassifizierung",
      "support-account-cleanup": "Bereinigung Support-Konto"
    }
  },
  "providerJobs": {
    "count": "{visible} von {total}",
    "detail": {
      "executeNow": "Jetzt ausführen",
      "executeNowConfirmDescription": "Der Job wird zur sofortigen Ausführung neu eingeplant.",
      "executeNowConfirmTitle": "Job jetzt ausführen?",
      "title": "Job-Details"
    },
    "failedTitle": "Fehlgeschlagene Jobs",
    "historyTitle": "Ausführungshistorie",
    "outcome": {
      "cancelled": "Abgebrochen",
      "completed": "Abgeschlossen",
      "failed": "Fehlgeschlagen"
    },
    "priority": {
      "high": "Hoch",
      "low": "Niedrig",
      "normal": "Normal"
    },
    "queuedTitle": "Wartende und laufende Jobs",
    "refresh": "Aktualisieren",
    "reset": {
      "confirm": "Queue zurücksetzen",
      "description": "Alle wartenden, geplanten, erneut versuchten und dauerhaft fehlgeschlagenen Jobs werden entfernt. Laufende Jobs werden fortgesetzt.",
      "success": "{removed} Jobs entfernt. {running} laufende Jobs wurden nicht verändert.",
      "title": "Queue zurücksetzen?"
    },
    "stats": {
      "execution": "Durchschnittliche Ausführungszeit",
      "pickup": "Durchschnittliche Wartezeit",
      "total": "Durchschnittliche Gesamtdauer"
    },
    "status": {
      "failed": "Fehlgeschlagen",
      "queued": "Wartet",
      "retrying": "Wiederholung",
      "running": "In Arbeit",
      "scheduled": "Geplant"
    },
    "table": {
      "attempts": "Versuche",
      "error": "Fehler",
      "executionDuration": "Ausführungszeit",
      "finishedAt": "Beendet am",
      "graphileJobId": "Graphile-Job-ID",
      "job": "Job",
      "operationUuid": "Operation-UUID",
      "payload": "Payload",
      "pickupDuration": "Wartezeit",
      "priority": "Priorität",
      "queue": "Queue",
      "queuedAt": "Eingereiht am",
      "result": "Ergebnis",
      "scheduledAt": "Geplant für",
      "startedAt": "Gestartet am",
      "totalDuration": "Gesamtdauer"
    },
    "title": "Queue"
  },
  "providerTemplates": {
    "visualsTip": "Die Visualisierungen zur Bewertung von Leistungen (Farben, Smileys, Notenzahlen …). Sie stammen aus einem festen App-Katalog und sind hier schreibgeschützt. Neue Visualisierungen erfordern eine Entwicklerin oder einen Entwickler.",
    "performanceAssessmentsTip": "Die bewertbaren Leistungsfeststellungen (Mitarbeit, Test, Prüfung …), je Schulstufe und Fach. Namen werden je Inhaltssprache übersetzt und verweisen auf eine Visualisierung; ein land- oder sprachspezifischer Eintrag überschreibt den globalen Standard.",
    "gradeScalesTip": "Eine Skala je Land (und Inhaltssprache) legt die Notenstufen fest. Hier kann die Richtung sowie Stufen festelegt werden — eine Schule erbt die Skala seines Landes. Es gibt immer genau eine pro Land; sie kann nicht gelöscht werden.",
    "competenceTip": "Kompetenzeintrag: genau einen pro Schulstufe, bei der nur die Visualisierung für Kompetenzeinträge gewählt werden kann. Die Bezeichnung wird von der App übersetzt und der Eintrag existiert immer — er kann nicht gelöscht werden.",
    "schoolTypeConfigTip": "Lege fest, welche Schulstufen ein Schultyp umfasst und wie sie beschriftet werden (fortlaufende Nummerierung vs. angepasst), je Land — mit optionalen Bundesland- oder Sprach-Überschreibungen. Das bestimmt die Stufen, die einer Schule dieses Schultyps zur Verfügung stehen.",
    "templateSetsTip": "Kompetenzvorlagen sind die Lehrpläne (Fächer + Kompetenzen), mit denen eine Schule startet, filterbar nach Land, Inhaltssprache und Schultyp. Eine Schule kopiert bei der Erstellung den am genauesten passenden Satz."
  },
  "quickEntry": {
    "clearCompetences": "Kompetenzen entfernen",
    "collapsedPlaceholder": "Was möchtest du festhalten?",
    "collectiveRatingStudents": "Sammelbewertung für {students}",
    "collectiveRatingWholeClass": "Sammelbewertung für die gesamte Klasse",
    "commandCompetences": "Kompetenzen",
    "commandOpenSubject": "Fach…",
    "commandOpenCompetences": "Kompetenzen…",
    "commandOpenStudents": "Schüler:innen…",
    "commandSubject": "Fach",
    "confirmDiscard": {
      "confirmButtonLabel": "Verwerfen",
      "declineButtonLabel": "Weiter bearbeiten",
      "description": "Dein Schnelleintrag wurde noch nicht gespeichert. Möchtest du die Eingaben verwerfen?",
      "title": "Eintrag verwerfen?"
    },
    "createdToast": {
      "action": "Öffnen"
    },
    "dialogLabel": "Schnelleintrag",
    "expandLabel": "Schnelleintrag beginnen",
    "rateIndividually": "Individuell bewerten…",
    "removeSubject": "Fach entfernen",
    "requiredAction": {
      "performanceAssessment": "Wähle noch eine Leistungsfeststellung aus.",
      "schoolSubject": "Füge noch ein Fach hinzu.",
      "students": "Wähle mindestens eine:n Schüler:in aus.",
      "text": "Füge noch einen Text hinzu.",
      "textTooLong": "Der Text ist zu lang. Kürze ihn bitte."
    },
    "saveEntry": "Eintrag speichern",
    "searchSubjectsPlaceholder": "Fach suchen…",
    "sectionPerformanceAssessment": "Leistungsfeststellung",
    "selectionHint": "Tippe {personShortcut} für Personen oder {commandShortcut} für Fächer und Kompetenzen. – z. B. {personExample} oder {subjectExample}",
    "selectionHintPersonExample": "{'@'}angelika",
    "selectionHintSubjectExample": "/deutsch",
    "selectPerformanceAssessment": "Leistungsfeststellung wählen",
    "selectSubject": "Fach wählen",
    "typeNote": "Notiz",
    "typeSupportMeasure": "Fördermaßnahme",
    "visibilityHint": {
      "missingCompetence": "Der Eintrag wird für {studentName} gespeichert, aber ohne ausgewählte Kompetenz nicht in diesem Verlauf angezeigt.",
      "missingStudent": "Der Eintrag wird gespeichert, aber ohne {studentName} nicht in diesem Verlauf angezeigt."
    }
  },
  "referral": {
    "dialog": {
      "descriptionMember": "Teile deinen persönlichen Empfehlungslink mit Kolleg:innen. Schließt jemand darüber ein Digidoo-Abo ab, erhält deine Schule bis zu 50% Rabatt auf dein eigenes Abo.",
      "descriptionOwner": "Teile deinen persönlichen Empfehlungslink mit Kolleg:innen. Schließt jemand darüber ein Digidoo-Abo ab, erhältst du bis zu 50% Rabatt auf dein eigenes Abo.",
      "linkCopied": "Empfehlungslink wurde in die Zwischenablage kopiert",
      "myLink": "Mein Empfehlungslink",
      "percentDiscount": "{percent}%",
      "rewardDescriptionMember": "Deine Schule erhält {discount} auf die nächste Digidoo Abrechnung.",
      "rewardDescriptionOwner": "Du erhältst {discount} auf deine nächste Digidoo Abrechnung.",
      "rewardTitle": "Du hast noch keine Empfehlungen. | Vielen Dank für {count} erfolgreiche Empfehlung. | Vielen Dank für {count} erfolgreiche Empfehlungen.",
      "sendLink": "Link versenden",
      "sendLinkEmailSubject": "Meine Empfehlung für dich: Digidoo 🌼",
      "sendLinkEmailText": "Hey 👋\n\nich nutze Digidoo zur strukturierten Dokumentation von Lernfortschritten und Kompetenzen – und kann es echt empfehlen.\nDu kannst es auch im Team oder schulweit einsetzen.\n\n👉 Du kannst hier kostenlos starten:\n{ referralLink }\n\nLiebe Grüße,\n{ name }",
      "subtitleMember": "und deine Schule erhält bis zu 50% auf die nächste Abrechnung.",
      "subtitleOwner": "und erhalte bis zu 50% auf deine nächste Abrechnung.",
      "title": "Sichere dir bis zu 50% Rabatt."
    },
    "postReleaseDialog": {
      "description": "Digidoo wächst durch Empfehlungen von Lehrpersonen wie dir. Wenn Digidoo dir hilft, freuen wir uns über jede Weiterempfehlung.",
      "title": "Danke für deinen Support 💜"
    },
    "prompt": {
      "primary": "Digidoo weiterempfehlen",
      "secondary": "Ich mach das später"
    },
    "reportSuccessDialog": {
      "description": "Hilf anderen Lehrpersonen, auch Zeit bei der Dokumentation zu sparen.",
      "title": "Bericht erfolgreich erstellt 💜"
    },
    "widget": {
      "title": "Empfehlungsprogramm"
    }
  },
  "release": {
    "actionTarget": {
      "gradeCalculationSettings": "Notenberechnung (Schuleinstellungen)",
      "none": "– keine Aktion –"
    },
    "all": "Releases",
    "close": "Alles klar",
    "confirm": {
      "confirmButtonLabel": "Veröffentlichen",
      "declineButtonLabel": "Abbrechen",
      "description": "Bitte bestätige, dass du diesen Release veröffentlichen möchtest. Dabei wird eine Benachrichtigung an alle User im System ausgeschickt. Tippe dafür 'Digidoo' in das nachfolgende Feld ein.",
      "removeConfirmInputPlaceholder": "Digidoo",
      "title": "Release veröffentlichen"
    },
    "confirmClose": {
      "confirmButtonLabel": "Ohne Speichern schließen",
      "description": "Möchtest du den Release wirklich schließen? Alle bisher vorgenommenen Änderungen gehen dabei verloren.",
      "title": "Release schließen"
    },
    "content": {
      "options": {
        "bulletPoint": "Bulletpoint",
        "image": "Bild",
        "text": "Text",
        "title": "Titel"
      },
      "title": "Inhalt",
      "type": "Typ"
    },
    "create": "Release erstellen",
    "cta": {
      "description": "Optionaler Button, der Nutzer:innen direkt zu einer passenden Einstellung führt. Die Beschriftung des Buttons wird automatisch aus dem gewählten Ziel abgeleitet. Wird nur Inhaber:innen und Administrator:innen angezeigt.",
      "labels": {
        "gradeCalculationSettings": "Mehr zur Notenberechnung"
      },
      "target": "Ziel",
      "title": "Aktion"
    },
    "identifier": "Identifikation",
    "identifierDescription": "Die Identifikation (z.B.: 1.4.6) wird in der Notification-Message neben dem Text 'Was ist neu in Digidoo {ID}' angezeigt, sowie im Dialog über dem Titel.",
    "image": {
      "description": "Optionales Header-Bild, das nur im Release-Dialog über dem Inhalt angezeigt wird.",
      "title": "Banner-Bild"
    },
    "releaseNow": "Jetzt Veröffentlichen",
    "releasedAt": "Veröffentlicht",
    "success": "Release erfolgreich veröffentlicht!",
    "testEmail": {
      "action": "Test-E-Mail senden",
      "description": "Wähle die User aus, die eine Test-E-Mail für Release {releaseId} erhalten sollen.",
      "noRecipients": "Noch keine User ausgewählt.",
      "searchPlaceholder": "User suchen",
      "send": "Test-E-Mail senden",
      "success": "Test-E-Mail erfolgreich gesendet!",
      "title": "Test-E-Mail senden"
    },
    "title": "Titel",
    "titleDescription": "Der Titel erscheint ausschließlich im Dialog als Überschrift."
  },
  "reports": {
    "access": {
      "hasAccessDouble": "<b>Du</b> und <b>{name1}</b> haben Zugriff auf diesen Bericht.",
      "hasAccessMultiple": "<b>Du</b>, <b>{name1}</b> und <b>{count}</b> weiterer haben Zugriff auf diesen Bericht. | <b>Du</b>, <b>{name1}</b> und <b>{count}</b> weitere haben Zugriff auf diesen Bericht.",
      "hasAccessSingle": "<b>Du</b> hast Zugriff auf diesen Bericht.",
      "hasAccessTriple": "<b>Du</b>, <b>{name1}</b> und <b>{name2}</b> haben Zugriff auf diesen Bericht."
    },
    "allReports": "Alle Berichte",
    "ambiguousCompetenceCount": "{count} uneindeutige Kompetenz | {count} uneindeutige Kompetenzen",
    "commentPlaceholder": "Anmerkungen (optional)",
    "competencesSchoolLevel": "Kompetenzen Schulstufe {schoolLevel}",
    "completeReport": "Bericht abschließen",
    "completedAt": "am {date} um {time}",
    "completedAtLong": "Abgeschlossen am {date}",
    "completedBy": "durch {name}",
    "configuration": {
      "assessedCompetencesOnly": "Nur dokumentierte Kompetenzen im Bericht anzeigen",
      "competenceTypeOptionDescription": {
        "compact": "Alle Kompetenzen aller Fächer werden platzsparend und übersichtlich auf wenigen Seiten dargestellt.",
        "simple": "Zeigt pro Seite ein Fach mit Kompetenzbereichen und Kompetenzblume für einen schnellen Überblick.",
        "withNotes": "Zeigt Kompetenzen mit Kompetenzblume und bietet zusätzlich Platz für individuelle Notizen.",
        "withPerformanceAssessments": "Stellt Kompetenzen mit Kompetenzblume sowie die zugehörigen Leistungsfeststellungen dar."
      },
      "competenceTypeOptions": {
        "compact": "Kompakt",
        "simple": "Einfach",
        "withNotes": "Notizen",
        "withPerformanceAssessments": "Leistungsfeststellungen"
      },
      "competences": "Berichtsformat",
      "coverSheet": "Deckblatt",
      "coverSheetOptions": {
        "simple": "Einfach",
        "withChart": "Kompetenzblume",
        "withCustomImage": "Eigenes Bild",
        "withFlower": "Blume",
        "withNote": "Notiz"
      },
      "description": "Wie möchtest du den Bericht gestalten?",
      "notesReportDescription": "Listet alle Notizen des Zeitraums in einer Tabelle auf.",
      "showCompetenceLevelDescriptions": "Beschreibung der Kompetenzstufen anzeigen",
      "showGradeRecommendation": "Notenempfehlung anzeigen",
      "showNoteCompetences": "Verknüpfte Kompetenzen anzeigen",
      "summarySheet": "Unterschriften & Notizen",
      "summarySheetOptions": {
        "signature": "Unterschrift Schule",
        "simple": "Rückmeldung Eltern"
      }
    },
    "confirmCloseDescription": "Sobald du den Bericht abschließt, kannst du keine Änderungen mehr vornehmen.",
    "confirmCloseWithAmbiguousPerformanceLevels": "Der Bericht enthält noch {ambiguousCompetences}. Bitte überprüfe diese bevor du den Bericht abschließt.|Der Bericht enthält noch {ambiguousCompetences}. Bitte überprüfe diese bevor du den Bericht abschließt.",
    "confirmCloseWithAmbiguousPerformanceLevelsTitle": "Uneindeutige Kompetenzen",
    "coverImage": {
      "changeLayout": "Layout ändern",
      "errorSize": "Die Datei ist zu groß. Es sind maximal 1 MB erlaubt.",
      "errorType": "Dieser Dateityp wird nicht unterstützt. Erlaubt sind PNG, JPG oder WebP.",
      "hint": "{types} · max. {size}",
      "options": "Optionen",
      "remove": "Entfernen",
      "replace": "Ersetzen",
      "requiredDescription": "Für das Deckblatt „Eigenes Bild“ wird ein Bild benötigt. Lade ein Bild hoch oder wähle ein anderes Deckblatt-Layout, um den Bericht abzuschließen.",
      "requiredTitle": "Eigenes Bild fehlt",
      "upload": "Bild hochladen",
      "uploading": "Wird hochgeladen..."
    },
    "create": "Neuer Bericht",
    "createNotesReport": "Neuer Notizbericht",
    "creatingReports": "Berichte werden erstellt…",
    "delete": "Bericht löschen",
    "deleteConfirmDescription": "Möchtest du diesen Bericht mit allen Seiten wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteGroup": "Gruppierung löschen",
    "deletePage": "Seite löschen",
    "deletePageConfirmDescription": "Möchtest du diese Seite wirklich aus dem Bericht löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "editConfiguration": "Layout anpassen",
    "editConfigurationDescription": "Wie möchtest du den Bericht gestalten?",
    "emptyStateDescription": "Erstelle jetzt deinen ersten Bericht.",
    "emptyStateTitle": "Noch keine Berichte",
    "entriesRequired": {
      "finishEntries": {
        "body": "Es gibt bereits Einträge, aber sie sind noch nicht bewertet. Vervollständige mindestens einen, um einen Bericht zu erstellen.",
        "hint": "⏱️ Das dauert nur ein paar Minuten.",
        "primary": "Einträge vervollständigen",
        "title": "Vervollständige zuerst deine Einträge."
      },
      "firstEntry": {
        "body": "Erfasse zuerst deinen ersten Lernfortschritt, damit du einen Bericht erstellen kannst.",
        "hint": "⏱️ Das dauert nur ca. 2 Minuten.",
        "primary": "Ersten Eintrag starten",
        "title": "Starte jetzt mit deinem ersten Eintrag."
      },
      "noStudents": {
        "body": "Deine Klasse hat noch keine Schüler:innen. Füge Schüler:innen hinzu, damit du einen Bericht erstellen kannst.",
        "hint": "⏱️ Das dauert nur ein paar Minuten.",
        "primary": "Schüler:innen hinzufügen",
        "title": "Füge zuerst Schüler:innen hinzu."
      },
      "noSubjects": {
        "body": "Deine Klasse hat noch keine Fächer. Füge Fächer hinzu, damit du einen Bericht erstellen kannst.",
        "hint": "⏱️ Das dauert nur ein paar Minuten.",
        "primary": "Fächer hinzufügen",
        "title": "Füge zuerst Fächer hinzu."
      }
    },
    "filteredEmptyStateDescription": "Für die aktuellen Filter wurden keine Berichte gefunden.",
    "filteredEmptyStateTitle": "Keine passenden Berichte",
    "finalizeDescription": "Super, wir haben alles was wir brauchen.\nBitte überprüfe deine Angaben.",
    "finishReport": "Bericht erstellen",
    "finishedReports": "Berichte wurden erstellt",
    "firstSemester": "1. Semester",
    "generalData": {
      "allEntriesAverage": "Durchschnitt aller Kompetenzeinträge",
      "calculationMethodLabel": "Der Bericht berücksichtigt",
      "competenceAssessmentLabel": "vom Typ",
      "description": "Bitte gib deinem Bericht einen Namen und wähle den Zeitraum aus.",
      "endDateBeforeStartDate": "Das Enddatum darf nicht vor dem Startdatum liegen.",
      "from": "Von",
      "latestEntry": "Neuester Kompetenzeintrag",
      "namePlaceholder": "Elternsprechtag 2",
      "performanceAssessmentNotAvailable": "Nicht verfügbar",
      "period": "Zeitraum",
      "term": "Semester",
      "until": "bis einschließlich"
    },
    "hideInputValues": "Textfelder händisch ausfüllen",
    "iCanDoThat": "Das kann ich schon.",
    "lastEdited": "Stand {date}",
    "level": "{schoolLevel}. Schulstufe",
    "levelAndClass": "Schulstufe / Klasse",
    "newReportGroup": "Neue Gruppierung",
    "notesReport": {
      "allNotes": "Alle Notizen",
      "footerTitle": "Notizbericht · {section}",
      "noteCount": "{count} Notiz | {count} Notizen"
    },
    "overview": {
      "access": "Folgende Lehrpersonen haben Zugriff",
      "currentState": "Stand {date}"
    },
    "pdf": {
      "confirmDownloadButton": "Herunterladen",
      "confirmDownloadDescription": "Möchtest du diesen Bericht wirklich herunterladen? | Möchtest du diese Berichte wirklich herunterladen?",
      "confirmDownloadTitle": "Bericht herunterladen | Berichte herunterladen",
      "confirmPrintButton": "Drucken",
      "confirmPrintDescription": "Möchtest du diesen Bericht wirklich zum Drucken öffnen? | Möchtest du diese Berichte wirklich zum Drucken öffnen?",
      "confirmPrintTitle": "Bericht drucken | Berichte drucken",
      "generationFailed": "Die PDF-Datei konnte nicht erstellt werden. Bitte versuche es später erneut."
    },
    "removeGroupConfirmText": "Bist du sicher, dass du die Gruppierung entfernen möchtest? Die verknüpften Berichte bleiben unter “Alle Berichte” weiterhin verfügbar.",
    "rename": "Bericht umbenennen",
    "report": "Bericht",
    "reportCount": "Berichte | Bericht | Berichte",
    "reportSubject": {
      "commentLabel": "Was ich noch sagen möchte",
      "commentPlaceholder": "Text hinzufügen",
      "noCompetences": "Keine dokumentierten Kompetenzen",
      "stateCompleted": "Fach abgeschlossen",
      "stateInProgress": "Bitte überprüfe das Fach und schließe es ab.",
      "stateInProgressConflicts": "{count} Kompetenz nicht eindeutig|{count} Kompetenzen nicht eindeutig"
    },
    "reports": "{count} Bericht | {count} Berichte",
    "schoolYear": "Schuljahr",
    "schoolYearTerm": "Schuljahr / Semester",
    "secondSemester": "2. Semester",
    "sort": {
      "createdAtAsc": "Älteste zuerst",
      "createdAtDesc": "Neueste zuerst",
      "lastNameAsc": "Nachname A-Z",
      "reportNameAsc": "Berichtsname A-Z"
    },
    "status": {
      "completed": "Abgeschlossen",
      "inProgress": "In Bearbeitung"
    },
    "students": {
      "description": "Für welche Schülerinnen und Schüler möchtest du den Bericht erstellen?"
    },
    "subjects": {
      "description": "Welche Kompetenzen sollen im Bericht enthalten sein?",
      "hint": "Es werden nur Fächer angezeigt, für welche bereits Kompetenzen hinterlegt sind.",
      "noSubjects": "Für die ausgewählte Leistungsfeststellung und die gewählten Schüler:innen wurden keine Kompetenzeinträge gefunden.",
      "notesDescription": "Welche Notizen sollen im Bericht enthalten sein?",
      "notesHint": "Es werden nur Fächer angezeigt, für welche bereits Notizen hinterlegt sind.",
      "withoutSubject": "Allgemein",
      "withoutSubjectAbbreviation": "A"
    },
    "summary": "Zusammenfassung",
    "summarySheet": {
      "nextSteps": "Weitere Schritte, Fördermaßnahmen, vereinbarte Ziele:",
      "parent": "Erziehungsberechtigte Person",
      "parentFeedback": "Rückmeldung Erziehungsberechtigte Person:",
      "parentFeedbackAgreement": "Die getroffenen Vereinbarungen zu den nächsten Lernschritten sind klar und verständlich.",
      "parentFeedbackDescription": "Ich bin über die aktuelle Lern- und Entwicklungssituation meines Kindes gut und ausreichend informiert worden.",
      "schoolOwner": "Schulleitung",
      "signature": "Unterschrift",
      "student": "Schüler:in",
      "teacher": "Lehrperson"
    },
    "title": "Berichte",
    "type": {
      "description": "Welchen Bericht möchtest du erstellen?",
      "notesReport": "Notizbericht",
      "notesReportDescription": "Alle Notizen des Zeitraums mit den verknüpften Kompetenzen.",
      "select": "Berichtsart auswählen",
      "standard": "Standard-Bericht",
      "standardDescription": "Kompetenzen pro Fach mit Kompetenzblume, Leistungsfeststellungen oder Anmerkungen."
    }
  },
  "school": {
    "address": "Adresse",
    "all": "Alle Schulen",
    "city": "Ort",
    "connection": "Zugewiesene Schule",
    "country": "Staat",
    "create": "Schule erstellen",
    "deleteSchoolDescription": "Du hast die Leitung der {school}. Du kannst die Leitung auf ein anderes Mitglied übertragen oder die Schule löschen.",
    "deleteSuccess": "Schule erfolgreich gelöscht!",
    "edit": "Schule bearbeiten",
    "email": "E-Mail",
    "import": "CSV importieren",
    "importSuccess": "Schulen erfolgreich importiert!",
    "isPublicOrPrivate": "Öffentlich oder Privat",
    "location": "Standort",
    "logo": {
      "errorSize": "Die Datei ist zu groß. Es sind maximal 1 MB erlaubt.",
      "errorType": "Dieser Dateityp wird nicht unterstützt. Erlaubt sind PNG oder JPG.",
      "hint": "{types} · max. {size}",
      "options": "Optionen",
      "proInfo": "Hol dir dein Digidoo Abo und verwende dein eigenes Logo",
      "remove": "Entfernen",
      "replace": "Ersetzen",
      "upload": "Logo hochladen",
      "uploading": "Wird hochgeladen..."
    },
    "nameOfSchoolAdministration": "Name der Schulleitung",
    "private": "Privat",
    "public": "Öffentlich",
    "settings": "Schuldaten",
    "skzShort": "SKZ",
    "state": "Bundesland",
    "telephone": "Telefon",
    "tenantCount": "Tenants",
    "title": "Titel",
    "unknown": "Nicht bekannt",
    "website": "Website",
    "zipCode": "PLZ"
  },
  "schoolGrades": {
    "better": "Note verbessern (+)",
    "competenceOnly": "Nur Kompetenzeintrag",
    "decimalDescription": "Halbnoten wie 2,5 und feinere Abstufungen wie 2,25 oder 2,37 eingeben.",
    "decimalTitle": "Dezimalnoten verwenden",
    "decrement": "Notenwert um 0,25 verringern (−)",
    "disableConfirm": {
      "confirm": "Deaktivieren",
      "decimals": {
        "description": "Es gibt bereits Einträge mit Dezimalnoten. Möchtest du Dezimalnoten für neue Eingaben deaktivieren? Gespeicherte Werte und Berechnungen bleiben unverändert. Die Anzeige richtet sich nach der aktuellen Notenschreibweise.",
        "title": "Dezimalnoten deaktivieren?"
      },
      "modifiers": {
        "description": "Es gibt bereits Einträge mit Plus- oder Minusnoten. Möchtest du die Verwendung von +/− für neue Eingaben deaktivieren? Gespeicherte Werte und Berechnungen bleiben unverändert. Die Anzeige richtet sich nach der aktuellen Notenschreibweise.",
        "title": "Plus und Minus deaktivieren?"
      }
    },
    "increment": "Notenwert um 0,25 erhöhen (+)",
    "modifier": "Notenzusatz ändern",
    "modifiersAccessibleLabel": "Plus und Minus bei Benotung verwenden",
    "modifiersDescription": "Erweitert die Notenskala bei Leistungsfeststellungen um + und −.",
    "modifiersTitle": "bei Benotung verwenden",
    "retry": "Erneut versuchen",
    "saveFailed": "Die Note konnte nicht gespeichert werden. Ihre Eingabe bleibt erhalten.",
    "scaleLockedByRecordedGrades": "Notenskala und Reihenfolge sind wegen vorhandener Noten (auch in der Demoklasse) gesperrt.",
    "scaleTitle": "Notenskala",
    "setupRequired": "Die Schuladministration muss eine durchgehende Notenskala von 1–5 oder 1–6 einrichten, bevor Schulnoten erfasst werden können.",
    "title": "Schulnoten",
    "worse": "Note verschlechtern (−)"
  },
  "schoolSetup": {
    "finalizeDescription": "Super, wir haben alles was wir brauchen. Bitte überprüfe deine Angaben.",
    "generalDataDescription": "Lass uns eine neue Schule erstellen. Bitte lege den Schulnamen fest und vergib gern ein Schulmotto.",
    "helpTextInviteMembers": "Du kannst dein Team auch später noch einladen.",
    "invitationCount": "{count} Einladungen",
    "inviteMembers": "Welche Teammitglieder sollen Zugriff haben?",
    "schoolName": "Name der Institution",
    "title": "Schule erstellen"
  },
  "schoolSubjects": {
    "abbreviation": "Abkürzung",
    "allSubjects": "Alle Fächer",
    "competenceCount": "{ count } Kompetenz | { count } Kompetenzen",
    "competenceDomainCount": "{ count } Kompetenzbereich | { count } Kompetenzbereiche",
    "competenceOrCompetenceDomain": "Kompetenz oder Kompetenzbereich",
    "confirm": {
      "confirmButtonLabel": "Importieren",
      "description": "Du hast Fächer aus der {sourceLabel} ausgewählt. Möchtest du sie wirklich in die {targetLabel} importieren?",
      "descriptionDifferentSchoolType": "Du hast Fächer aus der {sourceGrade}. Schulstufe ({sourceSchoolType}) ausgewählt. Möchtest du sie wirklich in die {targetLabel} deiner Schule importieren?",
      "title": "Fächer importieren"
    },
    "confirmDelete": "Bist du sicher, dass du diese Kompetenz löschen möchtest?",
    "createNew": "Neues Fach",
    "digidooTemplate": "Digidoo-Vorlage",
    "duplicateNameSuffix": " (Kopie)",
    "edit": "Fach bearbeiten",
    "emptyStateCompetenceDomainDescription": "Füge jetzt den ersten Kompetenzbereich hinzu.",
    "emptyStateCompetenceDomainTitle": "Noch keine Kompetenzbereiche",
    "emptyStateDescription": "Füge jetzt das erste Fach hinzu oder importiere eine Vorlage.",
    "emptyStateTitle": "Noch keine Fächer",
    "entryCount": "{ count } Eintrag | { count } Einträge",
    "export": "Exportieren",
    "filter": "Schulstufe { schoolLevel }",
    "filteredEmptyStateCompetenceDomainDescription": "Für die aktuelle Suche wurden keine Kompetenzbereiche gefunden.",
    "filteredEmptyStateCompetenceDomainTitle": "Keine passenden Kompetenzbereiche",
    "filteredEmptyStateDescription": "Für die ausgewählte Schulstufe wurden keine Fächer gefunden.",
    "filteredEmptyStateTitle": "Keine Fächer für diese Schulstufe",
    "fromLibrary": "Aus Bibliothek…",
    "fromSchoolTemplate": "Aus Schulvorlage…",
    "fromTemplateHelpTextClass": "Fehlt dir ein Förderschwerpunkt, Freigegenstand usw.? Bitte <a class=\"underline hover:no-underline\" href=\"{ mailto }\">kontaktiere deine Schulleitung.</a>",
    "fromTemplateHelpTextClassAsAdmin": "Du kannst in der Schuladministration weitere Kompetenzvorlagen freischalten.",
    "fromTemplateHelpTextMailBody": "Hallo { firstNameReceiver },\n\nbitte erstelle mir diese Kompetenz:\n\nBeste Grüße,\n{ firstNameSender }\n\n----\nPS: Als Digidoo Administration findest du alle verfügbaren Kompetenzvorlagen (z. B. Förderschwerpunkte, Freigegenstände, Religionen usw.) unter Schuladministration -> Kompetenzraster -> Hinzufügen. Diese können den Klassen direkt freigeschaltet werden und anschließend von der Lehrperson importiert werden.\n",
    "fromTemplateHelpTextMailSubject": "👉 Digidoo: Bitte neue Kompetenzen für die '{ className }' erstellen",
    "fromtTemplateHelpText": "Hier findest du die aktuellen Kompetenzen des Lehrplans.",
    "import": "Importieren…",
    "isPreselected": "Standardmäßig ausgewählt",
    "label": "Suchen",
    "moveToGroupAction": "Verschieben nach…",
    "newGroup": "Neue Gruppierung",
    "noGroupsAvailable": "Keine Gruppierungen verfügbar",
    "noSubjects": "Noch keine Kompetenzvorlagen vorhanden",
    "noSubjectsAvailable": "Keine Fächer verfügbar",
    "placeholder": "Name oder Kürzel",
    "remove": "Kompetenz löschen",
    "schoolTemplate": "Schulvorlage",
    "selection": {
      "addStudents": "Schüler:innen hinzufügen",
      "addTeachers": "Lehrpersonen hinzufügen",
      "differentStudentsDescription": "Die ausgewählten Fächer sind für unterschiedliche Schüler:innen relevant:",
      "differentTeachersDescription": "Unterschiedliche Lehrpersonen haben Zugriff:",
      "manageStudents": "Schüler:innen verwalten",
      "manageTeachers": "Lehrpersonen verwalten",
      "sameStudentsDescription": "Die ausgewählten Fächer sind für folgende Schüler:innen relevant:",
      "selectedCount": "{count} Fach ausgewählt | {count} Fächer ausgewählt",
      "singleStudentsDescription": "Folgende Schüler:innen sind dem ausgewählten Fach zugewiesen:",
      "studentsTab": "Schüler:innen",
      "subjectCount": "{count} Fach | {count} Fächer",
      "teacherCount": "{count} Lehrperson | {count} Lehrpersonen",
      "teachersDescription": "Folgende Lehrpersonen haben Zugriff:",
      "teachersTab": "Lehrpersonen"
    },
    "tipAdmin": "Hier siehst du alle Kompetenzen aller Schulstufen. Du kannst Fächer, Kompetenzbereiche und einzelne Kompetenzen bearbeiten, neu anlegen oder aus einer Vorlage hinzufügen. Diese Kompetenzen dienen als schulweite Vorlage und können – je nach Zugriffsrechten – von Lehrpersonen in den Klassen bearbeitet oder übernommen werden.",
    "tipTeacher": "Hier legst du fest, welche Kompetenzen im Unterricht eingesetzt werden, welche Lehrpersonen die jeweiligen Fächer unterrichten und für welche Schülerinnen und Schüler diese Kompetenzen gelten.",
    "title": "Kompetenzen",
    "withoutGroup": "Ohne Gruppierung"
  },
  "schoolYear": {
    "tip": "Hier kannst du die Schuljahre einsehen. Sie dienen als Grundlage für alle weiteren Schritte im System und werden von uns zentral verwaltet."
  },
  "schoolYears": {
    "all": "Alle Schuljahre",
    "create": "Neues Schuljahr",
    "current": "Aktuelles Schuljahr",
    "edit": "Schuljahr bearbeiten",
    "editOrCreateDialog": {
      "noStateSelected": "Kein Bundesland"
    },
    "emptyStateAction": "Fehlendes Schuljahr melden",
    "emptyStateDescription": "Für diese Schule ist aktuell kein Schuljahr hinterlegt. Kontaktiere uns, damit wir das fehlende Schuljahr ergänzen können.",
    "emptyStateMailBody": "Hallo Digidoo-Team,\n\nfür diese Schule fehlt ein Schuljahr.\n\nSchule: {schoolName}\nBundesland: {state}\nSchul-ID: {schoolId}\nAnsprechperson: {userName}\nE-Mail: {userEmail}\n\nBitte ergänzt das fehlende Schuljahr.\n\nVielen Dank!",
    "emptyStateMailSubject": "Fehlendes Schuljahr für {schoolName}",
    "emptyStateTitle": "Kein Schuljahr vorhanden",
    "endDate": "Ende",
    "endDatePlaceholder": "Enddatum wählen",
    "namePlaceholder": "Schuljahr 2024/2025",
    "noSchoolYears": "Noch keine Schuljahre vorhanden",
    "relevantForStates": "Bundesländer",
    "schoolYearName": "Schuljahr {year}",
    "startDate": "{term}. Semester",
    "startDatePlaceholder": "Startdatum wählen",
    "status": {
      "active": "aktiv",
      "past": "abgeschlossen",
      "upcoming": "bevorstehend"
    },
    "term": "Semester {term}",
    "termValidation": {
      "endDateBeforeStartDate": "Das Enddatum muss nach dem Startdatum liegen",
      "firstTermBeforeSecondTerm": "Das erste Semester muss vor dem zweiten liegen"
    },
    "view": "Schuljahre einsehen"
  },
  "settings": {
    "class": "Meine Klasse",
    "school": "Schuladministration"
  },
  "setupChecklist": {
    "dismiss": "Nicht mehr anzeigen",
    "dismissConfirmation": {
      "confirm": "Anleitung ausblenden",
      "description": "Die Anleitung wird dauerhaft ausgeblendet. Du kannst alle Schritte natürlich weiterhin jederzeit selbstständig durchführen.",
      "title": "Anleitung nicht mehr anzeigen?"
    },
    "finishedBody": "Wir wünschen dir viel Freude mit Digidoo.",
    "finishedTitle": "Juhu {firstName},\ndu bist nun startklar!",
    "progress": "Digidoo einrichten {completed}/{total}",
    "steps": {
      "createClass": "Erstelle deine erste eigene Klasse",
      "createFirstEntry": "Erstell deinen ersten Eintrag",
      "createDemoReport": "Erstelle einen Bericht in der Demoklasse",
      "demoClassTour": "Entdecke die Demoklasse",
      "inviteTeam": "Lade dein Team ein",
      "setupSchool": "Richte deine Schule ein"
    },
    "title": "{total} kleine Schritte\nund du bist startklar"
  },
  "skills": {
    "createCompetence": "Neue Kompetenz",
    "createCompetenceDomain": "Neuer Kompetenzbereich",
    "editSkills": "Kompetenzen bearbeiten",
    "title": "Kompetenzen"
  },
  "statistics": {
    "bar": {
      "entryCount": "{ count } Eintrag | { count } Einträge"
    },
    "calculationType": {
      "allHistoricalEntries": "Alle Einträge (Durchschnitt)",
      "lastHistoricalEntry": "Neuester Eintrag"
    },
    "filter": {
      "allPerformanceAssessments": "Alle",
      "competenceFilter": {
        "title": "Nur Kompetenzchecks heranziehen"
      },
      "description": "Derzeit wird der Mittelwert aller Einträge für die Visualisierung herangezogen.",
      "title": "Filter"
    },
    "flower": {
      "chart": "Kompetenzblume von {name}",
      "segment": "{name}: Stufe {level} von {levels}",
      "segmentWithoutObservations": "{name}: noch keine Beobachtungen"
    },
    "noVisualsHint": "Diese Leistungsfeststellung hat keine eigene Visualisierung und wird über die zugehörigen Kompetenzeinträge dargestellt.",
    "showStudent": "Zur Schülerübersicht",
    "tip": "Hier erhältst du mit der Digidoo-Blume einen visuellen Überblick über den Kompetenzstand deiner Klasse <b>{currentClass}</b>. Analysiere einzelne Fächer und Kompetenzen im Detail und sieh auf einen Blick, wie die gesamten Einträge verteilt sind. Verfeinere deine Analyse mit gezielten Filtern.",
    "title": "Analyse"
  },
  "student": {
    "editOrCreateDialog": {
      "add": "Schüler:innen hinzufügen",
      "assignAccess": "{names} bekommt Zugriff auf diese Klassen und Gruppen: | {names} bekommen Zugriff auf diese Klassen und Gruppen:",
      "assignClassesNow": "Gleich Klassen zuweisen",
      "assignClassOrGroup": "Klasse oder Gruppe zuweisen",
      "assignments": "{name} ist folgenden Klassen und Gruppen zugewiesen:",
      "assignTitle": "Klassen und Gruppen zuweisen",
      "createIntro": "Trag hier die Vor- und Nachnamen deiner Schüler:innen ein.",
      "edit": "Schüler:in bearbeiten",
      "moreStudents": "{count} weitere",
      "noAssignments": "Keine Klassen oder Gruppen in diesem Schuljahr zugewiesen.",
      "removeAssignment": "Zuweisung zu {name} entfernen"
    },
    "removeStudent": "Schüler:in entfernen",
    "removeSuccess": "Schüler:in entfernt!"
  },
  "studentDetails": {
    "assessmentDistribution": "Verteilung",
    "assessmentRating": "Bewertung",
    "assessmentRatingTooltipDescription": "basierend auf {count} Eintrag | basierend auf {count} Einträgen",
    "assessmentRatingTooltipTitle": "{percentage}% erreicht",
    "competenceObservation": "Kompetenzbereiche",
    "competences": "Kompetenzen",
    "editPerformanceAssessmentTypes": "Arten und Gewichtung anpassen",
    "entries": "Einträge",
    "hidePerformanceAssessment": "ausblenden",
    "hidePerformanceAssessmentDialog": {
      "confirm": "Ausblenden",
      "description": "Du kannst diese Leistungsfeststellung ausblenden, wenn du sie aktuell nicht brauchst. Sobald du einen neuen Eintrag dieses Typs erstellst, wird sie {highlight}",
      "descriptionHighlight": "automatisch wieder angezeigt.",
      "dontShowAgain": "Nicht mehr anzeigen",
      "title": "Leistungsfeststellung ausblenden"
    },
    "overview": "Übersicht",
    "performanceAssessmentInfoDescription": "Klicke auf eine Leistungsfeststellung, um zu sehen, wie sich die dabei dokumentierten Kompetenzen auf die Größe des Blütenblattes auswirken.",
    "performanceAssessmentInfoTitle": "Leistungsfeststellungen & Kompetenzen",
    "showHistory": "Verlauf anzeigen",
    "totalOverview": "Kompetenzblume",
    "weightingInfoAction": "Jetzt anpassen",
    "weightingInfoDescription": "Deine Leistungsfeststellungen sind folgendermaßen gewichtet:"
  },
  "studentTrend": {
    "allCompetences": "Alle Kompetenzen",
    "calendarWeek": "KW{week}",
    "emptyEntries": "Noch keine Kompetenzeinträge",
    "entryCount": "{count} Kompetenzeintrag | {count} Kompetenzeinträge",
    "schoolWeek": "SW{week}",
    "title": "Entwicklung",
    "tooltipEntries": "Keine Einträge | {count} Eintrag | {count} Einträge"
  },
  "students": {
    "savedBeforeAvatarUploadFailure": "Schüler:in wurde gespeichert. | Schüler:innen wurden gespeichert.",
    "avatarUploadFailed": "{count} Foto konnte nicht hochgeladen werden. | {count} Fotos konnten nicht hochgeladen werden.",
    "addMenu": {
      "create": "Neue Schüler:innen",
      "uploadList": "Liste hochladen…"
    },
    "addSuccess": "Schüler:in erfolgreich hinzugefügt! | Schüler:innen erfolgreich hinzugefügt!",
    "all": "Gesamte Klasse",
    "allEligible": "Alle {count} Schüler:in | Alle {count} Schüler:innen",
    "count": "{count} Schüler:in | {count} Schüler:innen",
    "create": "Hinzufügen",
    "delete": "Löschen",
    "deleteBulk": "Endgültig löschen",
    "deleteBulkConfirmDescription": "Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um {count} Schüler:in dauerhaft zu löschen. | Bitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um {count} Schüler:innen dauerhaft zu löschen.",
    "deleteBulkConfirmHint": "Alle verknüpften Daten der ausgewählten Schüler:innen werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteBulkConfirmInputPlaceholder": "Vorname Nachname oder E-Mail",
    "deleteBulkSuccess": "{count} Schüler:in erfolgreich gelöscht | {count} Schüler:innen erfolgreich gelöscht",
    "deleteBulkTitle": "Schüler:innen löschen",
    "deleteConfirmButton": "Endgültig löschen",
    "deleteConfirmDescription": "Möchtest du {studentName} und alle verknüpften Daten wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.\n\nBitte gib \"{name}\" ein, um die Löschung zu bestätigen.",
    "deleteConfirmInputPlaceholder": "Vor- und Nachname eingeben",
    "deleteConfirmTitle": "Schüler:in löschen",
    "deleteSuccess": "Schüler:in erfolgreich gelöscht",
    "deleteWithRelatedData": "Endgültig löschen",
    "editStudents": "Schüler:innen bearbeiten",
    "emptyStateDescription": "Füge jetzt die erste Schülerin oder den ersten Schüler hinzu.",
    "emptyStateTitle": "Noch keine Schüler:innen",
    "filteredEmptyStateDescription": "Für das ausgewählte Schuljahr wurden keine Schüler:innen gefunden.",
    "filteredEmptyStateTitle": "Keine Schüler:innen für dieses Schuljahr",
    "filteredSearchEmptyStateDescription": "Für die aktuelle Suche wurden keine Schüler:innen gefunden.",
    "forStudents": "Für {count} Schülerin oder Schüler | Für {count} Schülerinnen und Schüler",
    "hasNoClass": "{name} ist keiner Klasse zugewiesen.",
    "import": {
      "addAsNew": "Neue Schüler:in anlegen",
      "allAtSchool": "Der Name ist schon an der Schule | Alle {count} Namen sind schon an der Schule",
      "assignNames": "Namen zuordnen",
      "cleared": "Alles geklärt.",
      "clearNames": "Kein Name ist klar | {count} von {total} Namen ist klar | {count} von {total} Namen sind klar",
      "dropFile": "Foto oder Datei hierher ziehen oder",
      "emptyFile": "Die Datei ist leer. Wähle eine Datei mit Namen aus.",
      "failed": "Der Import ist fehlgeschlagen. Lade die Liste erneut hoch, um von vorne zu beginnen.",
      "intro": "Digidoo übernimmt nur Vor- und Nachnamen aus deiner Liste. Du prüfst sie, bevor etwas gespeichert wird.",
      "knownAtSchool": "{count} Name ist schon an der Schule. | {count} Namen sind schon an der Schule.",
      "namesakesAfterAdding": "Dann gibt es {count} Schüler:innen mit diesem Namen.",
      "nothingFound": "In der Liste wurden keine Namen gefunden.",
      "nothingToAdd": "Es gibt nichts hinzuzufügen.",
      "otherList": "Andere Liste hochladen",
      "pastedText": "Eingefügter Text",
      "questionNumber": "Nachfrage {number} von {count}",
      "questionsIntro": "Bei einem Namen gibt es an deiner Schule mehrere Schüler:innen mit gleichem Namen. Sag uns kurz, wer gemeint ist. | Bei {count} Namen gibt es an deiner Schule mehrere Schüler:innen mit gleichem Namen. Sag uns kurz, wer gemeint ist.",
      "readFailed": "Die Liste konnte nicht gelesen werden. Versuche es mit einem schärferen Foto oder lade die Liste als CSV hoch.",
      "reading": "Wir lesen deine Liste…",
      "review": "Prüf den Namen, bevor du ihn hinzufügst. | Prüf die Namen, bevor du sie hinzufügst.",
      "reviewOthers": "Prüf den anderen Namen, bevor du ihn hinzufügst. | Prüf die anderen, bevor du sie hinzufügst.",
      "supportedFormats": "Foto, Scan, PDF oder CSV",
      "textTooLong": "Die Datei ist zu lang. Teile die Liste auf und lade die Teile einzeln hoch.",
      "title": "Liste hochladen",
      "whoIsMeant": "Wen meinst du mit {name}?"
    },
    "none": "Ohne Schüler:innen",
    "searchPlaceholder": "Vorname oder Nachname",
    "select": "Schüler:innen wählen",
    "selection": {
      "selectedCount": "{count} Schüler:in ausgewählt | {count} Schüler:innen ausgewählt"
    },
    "selectionSearchPlaceholder": "Schüler:innen suchen …",
    "singleStudentTip": "Hier erhältst du einen umfassenden Einblick in die Lernentwicklung von <b>{student}</b>: Sieh alle Kompetenzen der belegten Fächer, den zeitlichen Verlauf der Einträge sowie eine detaillierte Analyse mit der Digidoo-Blume – bis auf Kompetenzebene und mit hilfreichen Filtern.",
    "tipAdmin": "Hier findest du alle Schülerinnen und Schüler deiner <b>{school}</b>. Du kannst ihre Daten einsehen und bearbeiten sowie gezielt nach einzelnen Personen mit Filtern und Suchfunktionen suchen.",
    "tipAll": "Hier siehst du den zeitlichen Verlauf aller Einträge deiner Klasse <b>{currentClass}</b> auf einen Blick. Verschaffe dir einen genauen Überblick und filtere gezielt nach Fächern.",
    "tipSettings": "Hier siehst du alle Schülerinnen und Schüler deiner Klasse <b>{currentClass}</b>. Je nach Berechtigung kannst du ihre Daten verwalten oder neue Schülerinnen und Schüler zur Klasse hinzufügen.",
    "wholeClassWithName": "Klasse {name}"
  },
  "teacher": {
    "copyInvitationLink": "Link kopieren",
    "edit": "Mitglied bearbeiten",
    "invitationLinkCopied": "Einladungslink wurde in die Zwischenablage kopiert",
    "invitationSuccess": "{ email } wurde eingeladen",
    "invitationsSkippedDeactivated": "Diese Accounts sind deaktiviert und wurden übersprungen: { emails }",
    "invitationsSuccess": "Einladung an { count } Person erfolgreich gesendet | Einladungen an { count } Personen erfolgreich gesendet",
    "invite": "Einladen",
    "externalPersonsHint": "Auch externe Personen können Teil eures Teams sein: Lade Personen außerhalb eurer Schule ein - z.B. Psycholog:innen, Logopäd:innen oder Therapeut:innen. Sie sehen nur die Schüler:innen und Kompetenzen, die du auswählst.",
    "inviteMoreMembers": "Lade weitere Personen zu deinem Team ein.",
    "remove": "Teammitglied löschen",
    "removeConfirmText": "Bist du sicher, dass du {userName} von deiner Schule entfernen möchtest?",
    "resend": "Einladung erneut senden",
    "teacherAccess": "{firstName} hat Zugriff:",
    "team": "Team",
    "tip": "Hier kannst du das gesamte Team deiner <b>{schoolName}</b> einladen und verwalten. Weise Rollen wie Mitglied, Admin oder externe Person zu und behalte den Überblick über Klassenzugriffe sowie den aktuellen Einladungsstatus.",
    "unlink": "Teammitglied entfernen"
  },
  "templateSet": {
    "countryWide": "Gesamtes Land (kein Bundesland)",
    "importDialog": {
      "chooseSchoolType": "Schultyp wählen",
      "hint": "Fehlt dir ein Bundesland oder hast du weitere Ideen oder Feedback?",
      "missingTemplate": {
        "bodyPrefix": "Einfach ",
        "bodySuffix": " – Digidoo erkennt alles automatisch.",
        "dialog": {
          "action": "An Digidoo schreiben",
          "body": "Schick uns deine Vorlagen, Raster oder Unterlagen per Mail. Wir lesen die Fächer und Kompetenzen aus und nehmen sie in unsere Bibliothek auf — sobald sie verfügbar sind, melden wir uns bei dir.",
          "bodyUnavailableRegion": "Für {region} sind derzeit noch keine Kompetenzvorlagen verfügbar. Schick uns deine Vorlagen, Raster oder Unterlagen per Mail. Wir nehmen sie in unsere Bibliothek auf und melden uns bei dir, sobald sie verfügbar sind.",
          "contextMissing": "Nicht ausgewählt",
          "mailBody": "Hallo Digidoo-Team,\n\nich möchte euch Vorlagen, Raster oder Unterlagen für die Kompetenzbibliothek schicken.\n\nSchultyp: {schoolType}\nLand: {country}\nBundesland: {state}\n\nBitte meldet euch bei mir, falls ihr weitere Informationen benötigt.\n\nVielen Dank!",
          "mailSubject": "Vorlagen für die Digidoo Kompetenzbibliothek",
          "tip": "Bitte nur Raster und Vorlagen mailen — keine Schülerdaten.",
          "title": "Schick uns deine Vorlagen"
        },
        "formats": "PDF, Word, Excel oder Bild hochladen",
        "title": "Keine Vorlage gefunden?",
        "unavailable": "Noch keine Vorlagen verfügbar",
        "uploadAction": "Datei hochladen"
      },
      "noSchoolTypes": "Keine Schultypen verfügbar",
      "nothingSelected": "Bitte wähle eine Region und Schultyp",
      "title": "Kompetenzbibliothek"
    },
    "isCurrent": "Aktuell",
    "isDefault": "Standard",
    "pdf": {
      "allGroups": "Alle Fachgruppen",
      "confirmDownloadButton": "Herunterladen",
      "confirmDownloadDescription": "Möchtest du die Kompetenzvorlage als PDF herunterladen?",
      "confirmDownloadTitle": "Vorlage herunterladen",
      "exportButton": "Erstellen",
      "exportDialogTitle": "PDF Vorlage exportieren",
      "generationFailed": "PDF-Erstellung fehlgeschlagen. Bitte versuche es erneut.",
      "noVisualSelected": "Bitte wähle zuerst ein Leistungsvisuell aus.",
      "subjectGroups": "Fachgruppen"
    },
    "remove": "Vorlage löschen",
    "removeConfirmText": "Bist du sicher, dass du die Vorlage löschen möchtest?",
    "title": "Kompetenzvorlagen",
    "transfer": {
      "dropFile": "ZIP-Datei hier ablegen oder",
      "exportAction": "Kompetenzraster exportieren",
      "exportDescription": "Möchtest du den gesamten Kompetenzraster deiner Schule als ZIP-Datei herunterladen? Schülerdaten, Bewertungen und Einträge werden nicht exportiert.",
      "exportError": "Der Download ist fehlgeschlagen. Bitte versuche es erneut.",
      "exportSuccess": "Download erfolgreich",
      "exportTitle": "Kompetenzraster exportieren",
      "importAction": "Kompetenzraster importieren",
      "importDescription": "Die Fächer und Kompetenzen aus der Datei werden in deinen Kompetenzraster übernommen. Bist du sicher, dass du fortfahren möchtest?",
      "importError": "Der Import ist fehlgeschlagen. Es wurde nichts übernommen. Bitte prüfe die Datei und versuche es erneut.",
      "importPending": "Kompetenzraster wird importiert …",
      "importReplaceDescription": "Die Fächer und Kompetenzen aus der Datei werden in deinen Kompetenzraster übernommen und deine bisherige Vorlage wird ersetzt.\n\nBitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um den Import zu bestätigen.",
      "importReplaceHint": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "importReplaceSettingsDescription": "Die Fächer und Kompetenzen aus der Datei werden in deinen Kompetenzraster übernommen und deine bisherige Vorlage wird ersetzt und alle Einstellungen zu Fächern werden gelöscht.\n\nBitte gib deinen Vor- und Nachnamen oder deine E-Mail-Adresse ein, um den Import zu bestätigen.",
      "importSuccess": "Kompetenzraster erfolgreich importiert",
      "importTitle": "Kompetenzraster importieren",
      "invalidFile": "Diese Datei ist kein gültiger Digidoo-Export oder ist beschädigt. Bitte wähle eine unveränderte ZIP-Datei aus einem Digidoo-Export.",
      "levelNotInFile": "Nicht in der Datei enthalten",
      "noMatchingLevels": "Die Datei enthält keine Fächer für die aktiven Schulstufen deiner Schule.",
      "previewHint": "Enthält {schoolLevels} Schulstufen · {importedSchoolLevels} davon werden importiert. Wechsle oben die Schulstufe, um alles anzusehen.",
      "supportedFormat": "Nur .zip-Dateien aus „Kompetenzraster exportieren“",
      "uploadDescription": "Lade die ZIP-Datei aus einem Digidoo-Export hoch — im nächsten Schritt siehst du, was importiert wird.",
      "uploadHint": "Importiert werden nur Schulstufen, Fächer und Kompetenzen — keine Schülerdaten."
    },
    "unknownState": "Unbekanntes Bundesland (ID: {stateId})",
    "upload": {
      "dropFile": "JSON-Datei hier ablegen oder",
      "hiddenSchoolLevels": "Der gewählte Schultyp hat die Schulstufen {levels} aus der Datei nicht. Deren Fächer werden nicht angezeigt.",
      "invalidFile": "Diese Datei ist keine gültige Kompetenzvorlage. Erwartet wird eine JSON-Datei mit Fachgruppen, Fächern, Domänen und Kompetenzen.",
      "label": "Anzeigename",
      "noMatchingSchoolLevels": "Die Datei enthält nur Fächer der Schulstufen {fileLevels}, der gewählte Schultyp hat die Schulstufen {schoolTypeLevels}. Bitte wähle einen passenden Schultyp.",
      "pending": "Kompetenzvorlage wird importiert …",
      "requiredField": "Pflichtfeld",
      "schoolLevelsMismatch": "Die Datei enthält keine Fächer für die Schulstufen des gewählten Schultyps.",
      "success": "Kompetenzvorlage erfolgreich importiert",
      "supportedFormat": "Nur .json-Dateien mit Fachgruppen, Fächern, Domänen und Kompetenzen",
      "title": "Kompetenzvorlage importieren",
      "validating": "Datei wird geprüft …",
      "versionFormat": "Bitte gib die Version als Jahr ein, z. B. 2026, oder mit Monat, z. B. 2026-10."
    },
    "version": "Version"
  },
  "tenants": {
    "activate": "Aktivieren",
    "activateTenant": "Schule aktivieren & nicht mehr löschen",
    "add": "Schule hinzufügen",
    "addStaff": "Mitarbeiter hinzufügen",
    "address": "Adresse",
    "billing": {
      "billedByTenant": "Aktiv",
      "billedExternally": "Deaktiviert",
      "mode": "Abrechnungsart",
      "perUser": "Pro Benutzer"
    },
    "changeSchoolTypeConfirm": {
      "confirmButtonLabel": "Schultyp ändern",
      "description": "Der Schultyp von {currentName} wird auf {targetName} geändert.",
      "hint": "Bestehende Schulstufen, Klassen, Fächer und Bewertungen bleiben unverändert. Künftig verfügbare Lehrplan- und Fachvorlagen richten sich nach dem neuen Schultyp.",
      "title": "Schultyp wirklich ändern?"
    },
    "city": "Ort",
    "classes": "Klassen",
    "create": "Schule erstellen",
    "currentStaffDescription": "Diese Personen haben derzeit Zugriff",
    "deactivate": "Deaktivieren",
    "deactivateConfirm": {
      "description": "Soll die Schule {school} deaktiviert werden? Diese Schule ist dann für keinen der User zugänglich und wird nach 14 Tagen automatisch gelöscht.",
      "title": "Schule deaktivieren & löschen"
    },
    "deactivateTenant": "Schule deaktivieren & in 14 Tagen löschen",
    "deleteImmediately": "Sofort löschen",
    "deleteImmediatelyConfirm": {
      "description": "Dadurch wird die Schule {school} jetzt endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
      "hint": "Der gleiche Löschpfad wie bei der automatischen Bereinigung wird sofort ausgeführt.",
      "inputPlaceholder": "Schulname eingeben",
      "title": "Schule sofort löschen?"
    },
    "detail": {
      "billingCustomerIdCopied": "Abrechnungs-ID kopiert",
      "tabs": {
        "members": "Mitglieder",
        "overview": "Übersicht",
        "referral": "Empfehlungen"
      }
    },
    "edit": "Schule bearbeiten",
    "isDisabled": "Deaktiviert",
    "locationAndSchoolType": "Standort und Schultyp",
    "maintenanceRole": "Support",
    "manageClassAccess": "Klassenzugriff verwalten",
    "members": {
      "emptyDescription": "Dieser Schule gehört noch niemand an.",
      "emptyTitle": "Keine Mitglieder",
      "loadError": "Die Mitglieder konnten nicht geladen werden.",
      "loading": "Mitglieder werden geladen…"
    },
    "noSchoolOption": "Keine zugewiesene Schule",
    "referral": {
      "balanceResetAt": "Guthaben auf 0 % zurückgesetzt · {date}",
      "discountGranted": "Gutschrift von Support",
      "discountProgress": "{percent} % von {max} % Rabatt gesammelt.",
      "discountReceivedAt": "Rabatt erhalten · {date}",
      "discountRedeemed": "Rabatt eingelöst",
      "emptyDescription": "Registrierungen über den Link dieser Schule, ihre Abos und Gutschriften erscheinen hier.",
      "emptyTitle": "Noch keine Empfehlungen",
      "grant": {
        "button": "Rabatt gutschreiben",
        "description": "Der Rabatt kommt zum Guthaben von {school} dazu und gilt für die nächste Zahlung.",
        "note": "Grund (optional)",
        "percent": "Rabatt",
        "percentOption": "{percent} %",
        "submit": "Gutschreiben",
        "success": "Rabatt gutgeschrieben.",
        "title": "Rabatt gutschreiben"
      },
      "grantedByAt": "Von {name} · {date}",
      "history": "Verlauf",
      "loading": "Empfehlungen werden geladen…",
      "maximumAlreadyReachedAt": "Maximum bereits erreicht · {date}",
      "maximumReached": "Maximum erreicht",
      "percentGained": "+{percent} %",
      "percentLost": "−{percent} %",
      "referralAcceptedAt": "Empfehlung angenommen · {date}",
      "startedAt": "Gestartet · {date}",
      "subscribedAt": "Abo abgeschlossen · {date}",
      "support": "Support",
      "viaLink": "über Link"
    },
    "remove": "Schule löschen",
    "removeConfirmText": "Bist du sicher, dass du die Schule \"{name}\" löschen möchtest?",
    "restoreConfirm": {
      "confirmButtonLabel": "Wiederherstellen",
      "description": "Die Schule {school} wird wieder aktiviert und nicht mehr automatisch gelöscht. Ein deaktiviertes Konto der Schulleitung wird ebenfalls wieder aktiviert.",
      "title": "Schule wiederherstellen?"
    },
    "staff": "Mitarbeiter",
    "students": "Schüler:innen",
    "subscription": {
      "emptyDescription": "Für diese Schule ist kein Abo hinterlegt.",
      "emptyTitle": "Kein Abo",
      "endedAt": "Beendet am",
      "endsAt": "Endet am",
      "loadError": "Das Abo konnte nicht geladen werden.",
      "loading": "Abo wird geladen…",
      "plan": "Abo-Plan",
      "renewsAt": "Verlängert sich am",
      "seats": "Plätze",
      "startedAt": "Startdatum"
    },
    "templateSetSource": {
      "bmukk": "BMUKK",
      "custom": "Benutzerdefiniert",
      "digidoo": "Digidoo",
      "official": "Offiziell"
    },
    "title": "Tenants",
    "willBeDeletedAt": "Wird gelöscht am",
    "zipCode": "PLZ"
  },
  "terms": {
    "title": "Allgemeine Geschäftsbedingungen für Digidoo"
  },
  "tfaForSchool": {
    "activateButton": "Jetzt aktivieren",
    "activateSuccessSchoolToast": "Zwei-Faktor-Authentifizierung aktiviert",
    "deactivateSuccessSchoolToast": "Zwei-Faktor-Authentifizierung deaktiviert",
    "description": "Lege fest, ob sich alle Teammitglieder deiner Organisation zusätzlich mit einer Zwei-Faktor-Authentifizierung anmelden müssen. So sind alle Konten einheitlich und bestmöglich geschützt.",
    "descriptionBottom": "Mit der Zwei-Faktor-Authentifizierung (2FA) sicherst du dein Digidoo-Konto noch besser ab – entweder via App oder E-Mail. <span class='font-semibold'>So bleibt dein Konto optimal geschützt.</span>",
    "descriptionTitle": "Zwei-Faktor-Authentifizierung für das gesamte Team",
    "descriptionTop": "Um die Konten in deiner Schule noch besser zu schützen, wurde für das gesamte Team die Zwei-Faktor-Authentifizierung (2FA) aktiviert.",
    "dialogDescription": "Dein Team wird automatisch informiert und hat <span class='font-semibold'>7 Tage</span> Zeit, die Einrichtung durchzuführen.",
    "dialogTitle": "Zwei-Faktor-Authentifizierung für dein Team aktivieren",
    "laterButton": "Später aktivieren",
    "title": "Jetzt Zwei-Faktor-Authentifizierung aktivieren",
    "tooltipProfileLabel": "deinem Profil",
    "tooltipText": "Aktiviere zuerst 2FA in {profile}, bevor du es für deine Schule einschalten kannst."
  },
  "timeline": {
    "activeSupportMeasureCount": "{count} laufende Fördermaßnahme | {count} laufende Fördermaßnahmen",
    "activeSupportMeasures": "Laufende Fördermaßnahmen",
    "calendarWeek": "KW {week}",
    "filterEntries": "Einträge filtern",
    "incompleteItems": "Offene Einträge",
    "lastWeek": "Letzte Woche",
    "moreCompetences": "und {count} weitere",
    "notes": "Notiz",
    "openEntryCount": "{count} offener Eintrag | {count} offene Einträge",
    "schoolWeek": "SW {week}",
    "showLessCompetences": "Weniger anzeigen",
    "thisWeek": "Diese Woche"
  },
  "transferOwnership": {
    "infoTitle": "{invitedBy} hat dich eingeladen, die Leitung der Schule \"{schoolName}\" zu übernehmen.",
    "invitationSuccess": "Anfrage zur Leitungsübernahme an { email } gesendet",
    "pendingRequest": "Leitungsanfrage ausstehend",
    "pendingRequestWithDate": "Leitungsanfrage ausstehend (Gültig bis {date})",
    "receiveDescription": "Wenn du die Leitung übernimmst, bist du künftig für Verwaltung und Abrechnung des Abos verantwortlich.\n\nDie bisherige Leitung bleibt weiterhin Administrator:in und behält Zugriff auf alle Funktionen.",
    "receiveTitle": "Leitung übernehmen",
    "receivedInvitation": "Ich habe eine Einladung zur Übernahme der Leitung erhalten.",
    "sendDescription": "Wenn du die Leitung überträgst, ist die neue Person künftig für Verwaltung und Abrechnung des Abos verantwortlich.\n\nKeine Sorge - du bleibst weiterhin Administrator:in und kannst alles wie gewohnt nutzen.",
    "title": "Leitung übertragen"
  },
  "twoFactorAuth": {
    "activatedSuccess": "Zwei-Faktor-Authentifizierung erfolgreich aktiviert",
    "dialog": {
      "mailStep": {
        "subtitle": "Um die Zwei-Faktor-Authentifizierung zu aktivieren, bestätige bitte, dass du künftig Sicherheitscodes per E-Mail erhalten möchtest."
      },
      "modeSelection": {
        "appMode": {
          "description": "Ich möchte den Code über meine Authenticator App wie etwa Google Authenticator oder 1Password erstellen.",
          "title": "Authenticator App"
        },
        "description": "Welche Art der Zwei-Faktor-Authentifizierung möchtest du verwenden?",
        "emailMode": {
          "description": "Ich möchte den Code via Email erhalten",
          "title": "Via Email"
        }
      },
      "title": "Zwei-Faktor-Authentifizierung",
      "totpStep": {
        "description": "Zur Überprüfung gib bitte hier den Code ein, der dir jetzt in der Authenticator App angezeigt wird.",
        "subtitle": "Um die Zwei-Faktor-Authentifizierung zu aktivieren, <span class='font-semibold'>scanne den QR Code</span> mit deiner Authenticator App und gib im Anschluss den dort angezeigten Code unten ein."
      }
    },
    "helpText": "{findOutMore} über Sicherheit und Zwei-Faktor-Authentifizierung  in Digidoo."
  },
  "user": {
    "activateConfirm": {
      "description": "Bei Aktivierung des Users wird ein Bestätigungsmail ausgesendet. Fortfahren?",
      "title": "User aktivieren?"
    },
    "deactivateConfirm": {
      "description": "Wenn dieser User deaktiviert wird, kann er sich nicht mehr einloggen und wird in {days} Tagen automatisch gelöscht. Fortfahren?",
      "ownerDescription": "Dieser User ist Inhaber der Schule {schools}. Bei Deaktivieren des Users, wird auch die zugehörige Schule deaktiviert und in 14 Tagen gelöscht. | Dieser User ist Inhaber der Schulen {schools}. Bei Deaktivieren des Users, werden auch die zugehörigen Schulen deaktiviert und in 14 Tagen gelöscht.",
      "title": "User deaktivieren & löschen"
    },
    "deleteImmediatelyConfirm": {
      "description": "Dadurch wird der User sofort endgültig gelöscht.\nDiese Aktion kann nicht rückgängig gemacht werden. Ist der User Inhaber einer (deaktivierten) Schule, wird auch die zugehörige Schule sofort gelöscht. Ist der User Mitglied einer Schule, erhält der Inhaber der Schule eine Benachrichtigung über die Löschung.",
      "hint": "Der gleiche Löschpfad wie bei der automatischen Bereinigung wird sofort ausgeführt.",
      "inputPlaceholder": "Name oder E-Mail-Adresse des Users eingeben",
      "ownerDescription": "Dieser User ist Inhaber der Schule {schools}. Die zugehörige Schule wird ebenfalls sofort gelöscht. | Dieser User ist Inhaber der Schulen {schools}. Die zugehörigen Schulen werden ebenfalls sofort gelöscht.",
      "title": "User sofort löschen?"
    },
    "detail": {
      "acquisitionSelfReported": "Eigene Angabe",
      "acquisitionSource": "Akquisitionsquelle",
      "acquisitionSourceOther": "Quelle (Freitext)",
      "attribution": {
        "capturedAt": "Erster Besuch",
        "clickIdKeys": "Werbeklick beim ersten Besuch",
        "clickIds": "Werbeklicks",
        "description": "Erster Besuch und letzte Werbeklicks, festgehalten bei der Registrierung.",
        "empty": "Für dieses Konto liegen keine Daten vor, zum Beispiel weil es schon vor der Erfassung angelegt wurde.",
        "landingPage": "Einstiegsseite",
        "platforms": {
          "googleAds": "Google Ads",
          "meta": "Meta",
          "microsoftAds": "Microsoft Ads",
          "tiktokAds": "TikTok Ads"
        },
        "referrer": "Kam von",
        "title": "Der Weg zu Digidoo",
        "utmCampaign": "Kampagne (utm_campaign)",
        "utmContent": "Anzeige (utm_content)",
        "utmMedium": "Kanal (utm_medium)",
        "utmSource": "Quelle (utm_source)",
        "utmTerm": "Suchbegriff / Zielgruppe (utm_term)"
      },
      "avatarSecurityHint": "Hochgeladene Profilbilder werden aus Sicherheitsgründen nicht geladen.",
      "copyEmail": "E-Mail-Adresse kopieren",
      "emailChanges": {
        "newEmail": "Neue E-Mail-Adresse",
        "oldEmail": "Bisherige E-Mail-Adresse",
        "title": "E-Mail-Änderungen"
      },
      "emailCopied": "E-Mail-Adresse wurde in die Zwischenablage kopiert",
      "loginProviders": "Login-Anbieter",
      "openInTenants": "Bei den Tenants öffnen",
      "openInUsers": "Bei den Usern öffnen",
      "schools": "Schulen",
      "sendWeeklyReport": "Wochenbericht senden",
      "sendWeeklyReportSuccess": "Wochenbericht erfolgreich gesendet",
      "tabs": {
        "acquisition": "Herkunft",
        "emails": "E-Mails",
        "profile": "Profil"
      }
    },
    "filteredEmptyStateDescription": "Lade jetzt ein Teammitglied ein.",
    "filteredEmptyStateTitle": "Für die aktuelle Suche wurden keine Teammitglied gefunden",
    "resetTfaConfirm": {
      "description": "Die Zwei-Faktor-Authentifizierung dieses Users wird deaktiviert und die hinterlegte Authenticator-App entfernt. Der User kann sich danach nur mit seinem Passwort anmelden und die Zwei-Faktor-Authentifizierung neu einrichten.",
      "title": "Zwei-Faktor-Authentifizierung zurücksetzen?"
    },
    "restoreConfirm": {
      "confirmButtonLabel": "Wiederherstellen",
      "description": "Das Benutzerkonto wird wieder aktiviert und nicht mehr automatisch gelöscht.",
      "hint": "Deaktivierte Schulen dieses Users bleiben zur Löschung vorgemerkt. Stelle die gewünschten Schulen anschließend separat unter „Schulen“ wieder her.",
      "title": "User wiederherstellen?"
    },
    "table": {
      "access": "Zugriff",
      "actions": {
        "activateUser": "Aktivieren & nicht mehr löschen",
        "approveUser": "Freischalten",
        "deactivateUser": "Deaktivieren & in 14 Tagen löschen",
        "deleteImmediately": "Sofort löschen",
        "resetTfa": "2FA zurücksetzen",
        "revokeApprovalUser": "Nicht mehr freischalten",
        "willBeDeletedAt": "Wird gelöscht am"
      },
      "active": "aktiv",
      "deleteInvitation": "Einladung löschen",
      "email": "E-Mail-Adresse",
      "firstName": "Vorname",
      "invitationExpired": "Einladung abgelaufen.",
      "invitationPending": "Einladung ausstehend",
      "invitationPendingShort": "eingeladen",
      "invitationPendingWithDate": "Einladung ausstehend (Gültig bis {date})",
      "isApproved": "Freigeschaltet",
      "isDeactivated": "Deaktiviert",
      "isSetupCompleted": "Onboarding abgeschlossen",
      "lastName": "Nachname",
      "ownershipInvitationExpired": "Leitungsanfrage abgelaufen",
      "resendInvitation": "Einladung erneut senden"
    },
    "title": "Benutzer"
  },
  "userRole": {
    "admin": "Admin",
    "external": "Externe Person",
    "owner": "Leitung",
    "user": "Mitglied"
  },
  "userRoleDescription": {
    "admin": "Verwalten Team, Klassen und Zugriffsrechte.",
    "external": "Haben Zugriff auf ausgewählte Schüler:innen und Kompetenzen.",
    "owner": "Als Leitung verwaltest du den Digidoo-Schulaccount. Die Rolle geht automatisch an die erstellende Person und kann später jederzeit an eine andere Person übertragen werden.",
    "user": "Haben Zugriff auf ihre zugewiesenen Klassen."
  },
  "userRoleStatus": {
    "active": "Aktiv",
    "disabled": "Deaktiviert",
    "invitationDeclined": "Einladung abgelehnt",
    "invitationPending": "Einladung ausstehend"
  },
  "userStatus": {
    "deactivatedTitle": "Dieser User ist deaktiviert und wird\nin {count} Tag automatisch gelöscht. | Dieser User ist deaktiviert und wird\nin {count} Tagen automatisch gelöscht."
  },
  "userwidget": {
    "logout": "Abmelden",
    "profile": "Mein Account"
  },
  "waitingRoom": {
    "classesToFinalizeMessage": "Du wurdest eingeladen der Klasse { className } beizutreten.",
    "classesToFinalizeMessageCreator": "Du hast die Klasse { className } erstellt und kannst sie jetzt einrichten.",
    "noClassDescription": "Dir wurde noch keine Klasse zugewiesen. Wir informieren dich, sobald du loslegen kannst.",
    "specificClassWaitingRoom": "Die Klasse { className } wurde noch nicht eingerichtet. Du kannst sie jetzt fertig einrichten.",
    "subtitle": "Willkommen bei {schoolName}",
    "title": "Hallo {firstName},"
  },
  "website": {
    "baseUrl": "https://www.digidoo.com",
    "pricingUrl": "https://www.digidoo.com/preise"
  },
  "schoolTypeConfiguration": {
    "title": "Schultyp-Konfiguration",
    "labelMode": "Stufennummerierung",
    "labelModeAdjusted": "Relativ",
    "labelModeRaw": "Absolut",
    "labelModeInfo": "Legt fest, wie die Stufen dieses Schultyps für Lehrkräfte und Berichte nummeriert werden. Absolut behält die echte Stufennummer — z. B. ein Gymnasium mit den Stufen 7–12 wird als 7–12 angezeigt. Relativ nummeriert sie ab 1 — angezeigt als 1–6."
  },
  "masterData": {
    "title": "Stammdaten",
    "countries": "Länder",
    "states": "Bundesländer",
    "schoolTypes": "Schultypen",
    "isoCode": "ISO-Code",
    "isSupported": "Unterstützt",
    "contentLanguages": "Inhaltssprachen",
    "contentLanguagesPlaceholder": "Sprachen auswählen",
    "primaryLanguage": "Primärsprache",
    "abbreviation": "Abkürzung",
    "color": "Farbe",
    "symbol": "Symbol",
    "parentState": "Übergeordnetes Bundesland",
    "noParent": "Keines",
    "translations": "Übersetzungen",
    "deleteCountryConfirm": "Möchtest du das Land \"{name}\" wirklich löschen?",
    "deleteStateConfirm": "Möchtest du das Bundesland \"{name}\" wirklich löschen?",
    "deleteSchoolTypeConfirm": "Möchtest du den Schultyp \"{name}\" wirklich löschen?"
  },
  "competenceAssessmentLevelTextCatalog": {
    "highly-achieved": {
      "description": "Ich arbeite eigenständig und kann mein Wissen und Können selbstständig und sicher anwenden. Ich habe das Lernziel in hohem Maß erreicht.",
      "title": "Das kann ich richtig gut."
    },
    "mostly-achieved": {
      "description": "Ich bewältige die Anforderungen größtenteils selbstständig. Ich habe das Lernziel überwiegend erreicht.",
      "title": "Das kann ich schon recht gut."
    },
    "not-yet-achieved": {
      "description": "Ich habe das Lernziel noch nicht erreicht.",
      "title": "Das muss ich noch üben."
    },
    "partially-achieved": {
      "description": "Mit Unterstützung bewältige ich die Anforderungen. Ich habe das Lernziel teilweise erreicht.",
      "title": "Das kann ich schon ein bisschen."
    }
  },
  "gradeScaleLevelCatalog": {
    "adequate": "Ausreichend",
    "deficient": "Mangelhaft",
    "good": "Gut",
    "insufficient": "Ungenügend",
    "not-sufficient": "Nicht genügend",
    "satisfactory": "Befriedigend",
    "sufficient": "Genügend",
    "very-good": "Sehr gut",
    "very-weak": "Sehr schwach",
    "weak": "Schwach"
  },
  "performanceAssessmentCatalog": {
    "cooperation": "Mitarbeit",
    "homework": "Hausübung",
    "oral-exam": "Mündliche Prüfung",
    "oral-exercise": "Mündliche Übung",
    "test": "Test",
    "written-exam": "Schularbeit"
  },
  "visualCatalog": {
    "colors": "Farben",
    "plants": "Pflanzen",
    "plus-wave-minus": "Plus – Welle – Minus",
    "grade-scale": "Noten",
    "smileys": "Smileys",
    "thumbs": "Daumen",
    "check-mark": "Haken"
  },
  "supportMeasureEntry": {
    "dialogTitle": "Fördermaßnahme",
    "notes": "Anmerkung zur Fördermaßnahme",
    "documentation": "Dokumentation",
    "linkedApps": "Verknüpfte Apps",
    "nextStudent": "Nächste:r Schüler:in",
    "previousStudent": "Vorherige:r Schüler:in",
    "openStudentList": "Schüler:innenliste öffnen",
    "readdStudent": "Erneut hinzufügen",
    "removeAndDeleteEntries": "Entfernen und alle Einträge löschen",
    "inactiveStudentsShow": "und {count} inaktive:r Schüler:in | und {count} inaktive Schüler:innen",
    "inactiveStudentsHide": "Inaktive Schüler:innen ausblenden",
    "removeStudentConfirm": {
      "title": "Schüler:in entfernen?",
      "description": "Möchtest du {name} wirklich aus dieser Fördermaßnahme entfernen? Alle zugehörigen Einträge werden dauerhaft gelöscht.",
      "confirm": "Entfernen und Einträge löschen"
    },
    "removeLastStudentConfirm": {
      "title": "Letzte:n Schüler:in entfernen?",
      "description": "{name} ist die/der letzte Schüler:in dieser Fördermaßnahme. Möchtest du die gesamte Fördermaßnahme löschen oder nur die/den Schüler:in entfernen?",
      "deleteEntry": "Fördermaßnahme löschen",
      "keepEntry": "Nur Schüler:in entfernen"
    },
    "supportPeriod": "Förderzeitraum",
    "newEntry": "Neue Fördermaßnahme",
    "metadataDescription": "Bearbeite Fach und Anmerkung der Fördermaßnahme.",
    "upsellTitle": "Fördermaßnahmen mit Digidoo",
    "upsellDescription": "Halte Förderziele und Fortschritte uneingeschränkt fest.",
    "upsellAriaLabel": "Abo-Pläne für Fördermaßnahmen öffnen",
    "competencesQuestion": "Willst du zu dieser Fördermaßnahme auch Kompetenzen hinzufügen?",
    "competencesHelpText": "Du kannst die Fördermaßnahme auch ohne Kompetenzen erstellen.",
    "studentsDescription": "Wähle die Schülerinnen und Schüler für die Fördermaßnahme aus.",
    "materials": {
      "allApps": "Alle Apps",
      "appChip": "App",
      "commandOpen": "Apps…",
      "question": "Willst du unterstützendes Material, wie externe Apps oder Websites, hinzufügen?",
      "searchPlaceholder": "App oder Material",
      "helpText": "Du kannst auch ohne externes Material fortfahren.",
      "previouslyUsed": "Bereits verwendet",
      "selected": "Ausgewählt",
      "recommended": "Empfohlen",
      "recentlyUsed": "Zuletzt verwendet",
      "addMaterial": "Material hinzufügen",
      "otherSchoolLevel": "Andere Schulstufe",
      "empty": "Kein passendes Material gefunden.",
      "addAsOwnApp": "als eigene App hinzufügen",
      "info": "Info",
      "visitWebsite": "Zur Website",
      "cost": "Kosten",
      "free": "Kostenlos",
      "paid": "Kostenpflichtig",
      "sidebarTitle": "Externes Material",
      "add": "Material hinzufügen",
      "none": "Kein Material zugeordnet"
    },
    "editEntry": "Fördermaßnahme bearbeiten",
    "deleteEntryTitle": "Fördermaßnahme löschen?",
    "deleteEntryDescription": "Diese Fördermaßnahme und ihr Protokoll werden dauerhaft gelöscht.",
    "noGoalAndMeasuresCompleted": "Keine Förderziele & Maßnahmen hinterlegt.",
    "protocol": "Protokoll",
    "protocolEmptyHint": "Halte nach jeder Einheit kurz fest, woran ihr gearbeitet habt.",
    "protocolPlaceholder": "Was wurde geübt?",
    "protocolRequiredAction": {
      "competenceRating": "Bewerte noch die ausgewählte Kompetenz.",
      "students": "Wähle mindestens eine:n Schüler:in aus.",
      "text": "Füge noch einen Protokolleintrag hinzu.",
      "textTooLong": "Der Protokolleintrag ist zu lang. Bitte kürze ihn."
    },
    "addProtocolEntry": "Protokolleintrag hinzufügen",
    "complete": "Abschließen",
    "completeDialogTitle": "Fördermaßnahme abschließen",
    "completeDialogDescription": "Die Maßnahme wird für alle {count} Schüler:innen abgeschlossen. Danach kannst du keine Einträge mehr hinzufügen.",
    "completionNoteLabel": "Abschlussnotiz (optional)",
    "completionNotePlaceholder": "z. B. welches Material geholfen hat oder was du wieder so machen würdest",
    "completionRatingLabel": "War die Fördermaßnahme erfolgreich?",
    "ratingNegative": "Nicht erfolgreich",
    "ratingNeutral": "Neutral",
    "ratingPositive": "Erfolgreich",
    "cancelTitle": "Fördermaßnahme verwerfen?",
    "cancelDescription": "Deine Eingaben werden nicht gespeichert.",
    "activityCount": {
      "competences": "{count} Kompetenz | {count} Kompetenzen"
    },
    "activityVerb": {
      "added": "hinzugefügt",
      "removed": "entfernt",
      "entriesRemoved": "endgültig entfernt",
      "linked": "verknüpft",
      "unlinked": "entfernt"
    },
    "deleteProtocolTitle": "Protokolleintrag löschen?",
    "deleteProtocolDescription": "Dieser Protokolleintrag wird dauerhaft gelöscht.",
    "unknownAuthor": "Unbekannt",
    "rating": {
      "question": "War diese Fördermaßnahme hilfreich?",
      "helpful": "Hilfreich",
      "notHelpful": "Nicht hilfreich"
    },
    "report": {
      "competenceDomain": "Kompetenzbereich",
      "completedByOn": "{name} am {date}",
      "completionNote": "Abschlussnotiz",
      "confirmDescription": "Dein Förderbericht ist fertig. Möchtest du ihn jetzt herunterladen? | Deine Förderberichte sind fertig. Möchtest du sie jetzt herunterladen?",
      "confirmTitle": "Förderbericht herunterladen | Förderberichte herunterladen",
      "content": "Inhalt",
      "contentHint": "Förderplanung und Protokoll sind immer enthalten.",
      "coverSheet": "Deckblatt",
      "coverSheetPlant": "Pflanze",
      "coverSheetSimple": "Einfach",
      "createAll": "Alle Förderberichte erstellen",
      "createReport": "Förderbericht erstellen",
      "designQuestion": "Wie möchtest du den Bericht gestalten?",
      "documentTitle": "Förderplan",
      "download": "Herunterladen",
      "firstAssessment": "Erste Einschätzung im Förderzeitraum",
      "footerTitle": "Förderplan · {subject}",
      "generationFailed": "Der Förderbericht konnte nicht erstellt werden. Bitte versuche es später erneut.",
      "goalsAndMeasures": "Förderziel & geplante Maßnahmen",
      "latestAssessment": "Aktuelle Einschätzung",
      "materials": "Apps & Material",
      "observation": "Beobachtung",
      "parents": "Eltern",
      "planningTitle": "Förderplanung & Entwicklung",
      "showCompetenceDevelopment": "Kompetenzentwicklung anzeigen",
      "showCompletionNote": "Abschlussnotiz anzeigen",
      "showMaterials": "Apps & Material anzeigen",
      "signatures": "Unterschriften",
      "since": "seit {date}"
    }
  },
  "avatar": {
    "uploadPicture": "Eigenes Bild hochladen..."
  }
}
